export interface BiValue<T> {
    value1?: T;
    value2?: T;
}
export interface DoubleRange {
    max?: number;
    min?: number;
}
export interface IntegerRange {
    end?: number;
    start?: number;
}
export interface LongRange {
    max?: number;
    min?: number;
}
export interface Pair<T, V> {
    left?: T;
    right?: V;
}
export interface ValueExtractor<T, V> {}
export interface AdexpPointAndDuration {
    durationInMs?: number;
    id?: string;
}
export interface AdexpRfl {
    level?: FlightLevel;
    pointId?: string;
}
export enum AdexpSpeed_SpeedType {
    K = 'K',
    N = 'N',
}
export interface AdexpSpeed {
    type?: AdexpSpeed_SpeedType;
    value?: number;
}
export enum AdexpSpeedOrMach_SpeedType {
    K = 'K',
    N = 'N',
    M = 'M',
}
export interface AdexpSpeedOrMach {
    type?: AdexpSpeedOrMach_SpeedType;
    value?: number;
}
export interface TimeOver {
    time?: Date;
    type?: TimeOverType;
}
export enum TimeOverType {
    TO = 'TO',
    STO = 'STO',
    CTO = 'CTO',
    ETO = 'ETO',
}
export interface AdexpAbstractRoutePoint {}
export interface AdexpDct {
    fromPoint?: string;
    toPoint?: string;
}
export enum AdexpEventClassType {
    MSG = 'MSG',
    MAN = 'MAN',
    SYS = 'SYS',
    REG = 'REG',
}
export interface AdexpFlightAirspace {
    airspaceId?: string;
    entryTime?: Date;
    exitTime?: Date;
}
export enum AdexpFlightRules {
    VFR = 'VFR',
    IFR = 'IFR',
}
export enum AdexpFlightType {
    OAT = 'OAT',
    GAT = 'GAT',
}
export interface AdexpGeoPoint {
    pointId?: string;
    position?: LatLonPoint;
}
export interface AdexpIfpsDiscrepancy {
    aircraftTypeDiscrepancy?: boolean;
    offBlockTimeDiscrepancy?: boolean;
    registrationMarkDiscrepancy?: boolean;
}
export interface AdexpOrigin {
    fac?: string;
    networkType?: string;
}
export interface AdexpPosition {
    calculatedTimeOver?: Date;
    flightLevel?: FlightLevel;
    point?: PointOrAerodromeId;
    timeOver?: TimeOver;
}
export interface AdexpPtCruiseClimb {
    cruiseRfl1?: FlightLevel;
    cruiseRfl2?: FlightLevel;
    cruiseSpeed?: AdexpSpeedOrMach;
}
export interface AdexpPtRuleChange {
    ruleChange?: AdexpFlightRules;
    typeChange?: AdexpFlightType;
}
export interface AdexpRefPoint {
    bearingInDegress?: number;
    distanceInNm?: number;
    pointId?: string;
    refId?: string;
}
export interface AdexpRenamePoint {
    pointId?: string;
    renameId?: string;
}
export interface AdexpRoutePoint extends AdexpAbstractRoutePoint {
    cruiseClimb?: AdexpPtCruiseClimb;
    flightLevel?: FlightLevel;
    flightLevelBand?: FlightLevelBand;
    pointId?: string;
    ptRfl?: FlightLevel;
    ptStay?: AdexpPointAndDuration;
    routeId?: string;
    ruleChange?: AdexpPtRuleChange;
    speedOrMach?: AdexpSpeedOrMach;
    supplementaryFlightLevel?: SupplementaryFlightLevel;
    timeOver?: TimeOver;
}
export enum SupplementaryFlightLevel_Type {
    AT_OR_ABOVE = 'AT_OR_ABOVE',
    AT_OR_BELOW = 'AT_OR_BELOW',
}
export interface SupplementaryFlightLevel {
    level?: FlightLevel;
    type?: SupplementaryFlightLevel_Type;
}
export interface AdexpRoutePointAerodrome extends AdexpAbstractRoutePoint {
    aerodromeId?: string;
    flightLevel?: FlightLevel;
    flightLevelBand?: FlightLevelBand;
    ptRfl?: FlightLevel;
    ptStay?: AdexpPointAndDuration;
    routeId?: string;
    ruleChange?: AdexpPtRuleChange;
    speedOrMach?: AdexpSpeedOrMach;
    supplementaryFlightLevel?: SupplementaryFlightLevel;
    timeOver?: TimeOver;
}
export interface AdexpRoutePointVector extends AdexpAbstractRoutePoint {
    eto?: Date;
    flightLevel?: FlightLevel;
    relativeDistance?: number;
}
export interface AdexpRoutePortion {
    fromPoint?: string;
    routeId?: string;
    toPoint?: string;
}
export interface AdexpStay {
    point1?: PointOrAerodromeId;
    point2?: PointOrAerodromeId;
    ptRfl?: FlightLevel;
    ptSpeed?: AdexpSpeed;
    stayIdent?: string;
    time?: Date;
}
export interface AckMessage extends AdexpOpReplyMessage {
    ifplId?: string;
}
export const ACK_MESSAGE_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.adexp.messages.AckMessage';
export interface AdexpOpReplyMessage_AdexpMessageSummary {
    flightKeys?: FlightKeys;
    originator?: string;
}
export interface AdexpOpReplyMessage extends AdexpMessage {
    addresses?: Array<string>;
    awr?: string;
    comments?: Array<string>;
    filingTime?: Date;
    messageType?: string;
    msgTxt?: string;
    msgsum?: AdexpOpReplyMessage_AdexpMessageSummary;
    oldMsg?: string;
    originDate?: Date;
}
export const ADEXP_OP_REPLY_MESSAGE_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.adexp.messages.AdexpOpReplyMessage';
export interface AdexpMessage {
    clazz?: string;
    origin?: AdexpOrigin;
    title?: string;
}
export const ADEXP_MESSAGE_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.adexp.messages.AdexpMessage';
export interface AdexpFlightMessage extends AdexpMessage {
    aircraftType?: string;
    flightId?: FlightId;
}
export const ADEXP_FLIGHT_MESSAGE_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.adexp.messages.AdexpFlightMessage';
export enum AdexpMessageType {
    IFPL = 'IFPL',
    ICHG = 'ICHG',
    IDLA = 'IDLA',
    ICNL = 'ICNL',
    IAFP = 'IAFP',
    IRQP = 'IRQP',
    IRQS = 'IRQS',
    IMFS = 'IMFS',
    IFNM = 'IFNM',
    IACH = 'IACH',
    IAPL = 'IAPL',
    IARR = 'IARR',
    IDEP = 'IDEP',
    FCM = 'FCM',
    FDI = 'FDI',
    APR = 'APR',
    FSA = 'FSA',
    DPI = 'DPI',
    API = 'API',
    REA = 'REA',
    EFD = 'EFD',
    FUM = 'FUM',
    SAM = 'SAM',
    SRM = 'SRM',
    SLC = 'SLC',
    SIP = 'SIP',
    RRP = 'RRP',
    RRN = 'RRN',
    FLS = 'FLS',
    DES = 'DES',
    RFI = 'RFI',
    SWM = 'SWM',
    SPA = 'SPA',
    SRJ = 'SRJ',
    SMM = 'SMM',
    RJT = 'RJT',
    COR = 'COR',
    CRE = 'CRE',
    CAM = 'CAM',
    CCM = 'CCM',
    ACK = 'ACK',
    MAN = 'MAN',
    REJ = 'REJ',
    ERR = 'ERR',
}
export interface FsaMessage extends AdexpFlightMessage {
    aircraftAddress?: string;
    atsrt?: Array<AdexpRoutePortion>;
    dct?: Array<AdexpDct>;
    furtherRoute?: Array<string>;
    geoPoints?: Array<AdexpGeoPoint>;
    position?: AdexpPosition;
    refPoints?: Array<AdexpRefPoint>;
    renamePoints?: Array<AdexpRenamePoint>;
    rfl?: Array<AdexpRfl>;
    sid?: string;
    star?: string;
    stay?: AdexpStay;
}
export const FSA_MESSAGE_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.adexp.messages.FsaMessage';
export interface IArrMessage extends AdexpFlightMessage {
    actualAerodromeOfArrival?: string;
    actualTimeOfArrival?: Date;
    addresses?: Array<string>;
    filingTime?: Date;
    remarks?: string;
}
export const I_ARR_MESSAGE_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.adexp.messages.IArrMessage';
export interface IChgMessage extends AdexpFlightMessage {}
export const I_CHG_MESSAGE_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.adexp.messages.IChgMessage';
export interface IDepMessage extends AdexpFlightMessage {
    actualTimeOfDeparture?: Date;
    addresses?: Array<string>;
    filingTime?: Date;
    remarks?: string;
}
export const I_DEP_MESSAGE_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.adexp.messages.IDepMessage';
export interface ManMessage extends AdexpOpReplyMessage {}
export const MAN_MESSAGE_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.adexp.messages.ManMessage';
export interface RegMessage extends AdexpMessage {
    event?: MeasureEventType;
    eventClass?: AdexpEventClassType;
    regulation?: RegulationDto;
    timestamp?: Date;
}
export const REG_MESSAGE_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.adexp.messages.RegMessage';
export interface RejMessage extends AdexpOpReplyMessage {
    errors?: Array<string>;
    posRte?: string;
}
export const REJ_MESSAGE_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.adexp.messages.RejMessage';
export interface EfdMessage extends AdexpFlightMessage {
    adesOld?: string;
    airspaceCrossings?: Array<AdexpFlightAirspace>;
    aoArcId?: string;
    aoOpr?: string;
    aobt?: Date;
    ata?: Date;
    cdmStatus?: CdmStatus;
    cobt?: Date;
    cta?: Date;
    delayInMs?: number;
    depAircraftType?: string;
    depAirportType?: DepartureAirportType;
    depRegistrationMark?: string;
    eobt?: Date;
    eta?: Date;
    event?: FlightEventType;
    eventClass?: AdexpEventClassType;
    flightState?: FlightStateType;
    flightType?: FlightType;
    geoPoints?: Array<AdexpGeoPoint>;
    ifpsDiscrepancy?: AdexpIfpsDiscrepancy;
    iobt?: Date;
    modelType?: FlightModelType;
    mostPenalisingRegulation?: string;
    readyState?: string;
    registrationMark?: string;
    regulations?: Array<string>;
    routePoints?: Array<AdexpAbstractRoutePoint>;
    taxiTimeInMs?: number;
    timestamp?: Date;
    tobt?: Date;
    tsat?: Date;
}
export const EFD_MESSAGE_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.adexp.messages.EfdMessage';
export interface AdexpPreview {
    adesOld?: string;
    eobtOld?: Date;
    flightId?: FlightId;
    messageType?: AdexpMessageType;
    oldFlightKeys?: FlightKeys;
}
export interface EfdPreview extends AdexpPreview {
    adesOld?: string;
    eobtOld?: Date;
    flightId?: FlightId;
    flightState?: FlightStateType;
    messageType?: AdexpMessageType;
}
export interface FplPreview extends AdexpPreview {
    adesOld?: string;
    eetInMs?: number;
    eobtOld?: Date;
    flightId?: FlightId;
    messageType?: AdexpMessageType;
}
export interface OpsReplyPreview extends AdexpPreview {
    replyToType?: AdexpMessageType;
}
export enum FlightLevel_Unit {
    FLIGHT_LEVEL = 'FLIGHT_LEVEL',
    ALTITUDE_FEET = 'ALTITUDE_FEET',
    STANDARD_METRIC_LEVEL_METRES = 'STANDARD_METRIC_LEVEL_METRES',
    ALTITUDE_METRES = 'ALTITUDE_METRES',
}
export interface FlightLevel {
    unit?: FlightLevel_Unit;
    value?: number;
}
export interface FlightLevelBand {
    max?: FlightLevel;
    min?: FlightLevel;
}
export interface RefLocation {
    refId?: string;
    refType?: RefLocationType;
}
export enum RefLocationType {
    AD = 'AD',
    AZ = 'AZ',
    AS = 'AS',
    SP = 'SP',
    DBP = 'DBP',
    PS = 'PS',
}
export interface LifeCycleEventDto {
    eventTime?: Date;
    userId?: string;
    userUpdateEventTime?: Date;
    userUpdateType?: LifeCycleEventType;
}
export enum LifeCycleEventType {
    CREATION = 'CREATION',
    DELETION = 'DELETION',
    UPDATE = 'UPDATE',
}
export enum AirspaceType {
    REG = 'REG',
    FIR = 'FIR',
    AUA = 'AUA',
    AUAG = 'AUAG',
    ES = 'ES',
    CS = 'CS',
    ERSA = 'ERSA',
    CRSA = 'CRSA',
    CDA = 'CDA',
    AREA = 'AREA',
    NAS = 'NAS',
    IFPZ = 'IFPZ',
    AOI = 'AOI',
    AOP = 'AOP',
    CLUS = 'CLUS',
    NS = 'NS',
    ERAS = 'ERAS',
    CRAS = 'CRAS',
}
export interface FileDto {
    fileLength?: number;
    id?: string;
    releaseTime?: Date;
    type?: string;
}
export interface DatasetDto {
    simulIdentifier?: SimulationIdentifierDto;
    simulationState?: SimulationState;
    type?: DatasetType;
}
export interface TimeAndTrafficType {
    time?: Date;
    type?: TrafficType;
}
export enum AirSpeed_Unit {
    FEET_PER_MINUTE = 'FEET_PER_MINUTE',
    KILOMETERS_PER_HOUR = 'KILOMETERS_PER_HOUR',
    KNOTS = 'KNOTS',
    MACH_NUMBER = 'MACH_NUMBER',
    UNDEFINED = 'UNDEFINED',
}
export interface AirSpeed {
    speed?: number;
    unit?: AirSpeed_Unit;
}
export enum EntityLogEntryType {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
}
export interface AbstractLoggingEntityDto {
    opLogEntries?: Array<EntityLogEntryDto>;
}
export interface EntityLogEntryDto {
    field?: string;
    issuer?: string;
    simulationTimestamp?: Date;
    timestamp?: Date;
    type?: EntityLogEntryType;
    valueAfter?: string;
    valueBefore?: string;
}
export interface TrafficVolumeLocationInfoDto {
    refLocation?: RefLocation;
    tvId?: string;
}
export enum TrafficType {
    DEMAND = 'DEMAND',
    REGULATED_DEMAND = 'REGULATED_DEMAND',
    LOAD = 'LOAD',
}
export enum DatasetType {
    FORECAST = 'FORECAST',
    OPERATIONAL = 'OPERATIONAL',
    SIMULATION = 'SIMULATION',
}
export interface SimulationIdentifierDto {
    id?: string;
    type?: SimulationType;
}
export enum SimulationState {
    CURRENT = 'CURRENT',
    INITIAL = 'INITIAL',
}
export enum SimulationType {
    NMOC_MANAGED_SIMULATION = 'NMOC_MANAGED_SIMULATION',
    STANDALONE_SIMEX = 'STANDALONE_SIMEX',
    USER_MANAGED_SIMULATION = 'USER_MANAGED_SIMULATION',
}
export enum PlanDataSourceType {
    AIRSPACE = 'AIRSPACE',
    MEASURE = 'MEASURE',
    TACTICAL = 'TACTICAL',
    NO_DATA = 'NO_DATA',
}
export interface TacticalPlan_Info {
    dataId?: string;
    dataSet?: DatasetDto;
    day?: Date;
    planCutOffReached?: boolean;
    planTransferred?: boolean;
}
export interface TacticalPlan {
    clazz?: string;
    info?: TacticalPlan_Info;
}
export const TACTICAL_PLAN_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.common.TacticalPlan';
export enum AerodromeRole {
    ARRIVAL = 'ARRIVAL',
    DEPARTURE = 'DEPARTURE',
    GLOBAL = 'GLOBAL',
    ALTERNATE = 'ALTERNATE',
}
export interface DatasetAndDayDto {
    dataset?: DatasetDto;
    day?: Date;
}
export enum EstimateQualifierType {
    ESTIMATED = 'ESTIMATED',
    ACTUAL = 'ACTUAL',
}
export interface FileListReplyDataDto {
    files?: Array<FileDto>;
}
export interface FileListRequestDto {
    fileType?: string;
    releaseTime?: TimePeriod;
}
export interface LatLongBounds {
    maxLat?: number;
    maxLon?: number;
    minLat?: number;
    minLon?: number;
}
export interface LevelAndTime {
    level?: FlightLevel;
    time?: Date;
}
export enum TimeWindowType {
    ENTRY = 'ENTRY',
    OCCUPANCY = 'OCCUPANCY',
}
export interface ValueOrDefault<T> {
    value?: T;
}
export interface LatLonPoint {
    clazz?: string;
    latitude?: number;
    longitude?: number;
}
export const LAT_LON_POINT_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.airspace.LatLonPoint';
export enum PointOrAerodromeId_Type {
    POINT = 'POINT',
    AERODROME = 'AERODROME',
}
export interface PointOrAerodromeId {
    id?: string;
    type?: PointOrAerodromeId_Type;
}
export interface Aerodrome {
    altitude?: number;
    icaoId?: string;
    name?: string;
    point?: LatLonPoint;
    taxiTimeInMin?: number;
    timeToInsertInMin?: number;
    timeToRemoveInMin?: number;
}
export interface AerodromeSet {
    aerodromes?: Array<string>;
    id?: string;
}
export interface Airblock {
    id?: string;
    points?: Array<LatLonPoint>;
}
export interface Airblock3d {
    airblock?: Airblock;
    maxLevel?: FlightLevel;
    minLevel?: FlightLevel;
}
export interface Airspace {
    airblocks?: Array<Airblock3d>;
    composedAirspace?: Array<Airspace>;
    reference?: AirspaceRef;
    skipInMs?: number;
    skipOutMs?: number;
    testAirspace?: boolean;
}
export interface AirspaceRef {
    id?: string;
    type?: AirspaceType;
}
export interface AirspaceDataFilterDto {
    responsibleAmc?: string;
}
export enum AixmDatasetType {
    COMPLETE = 'COMPLETE',
    INCREMENTAL = 'INCREMENTAL',
}
export enum DbeOrPublishedPointId_Type {
    DBE = 'DBE',
    PUBLISHED = 'PUBLISHED',
}
export interface DbeOrPublishedPointId {
    id?: string;
    type?: DbeOrPublishedPointId_Type;
}
export interface IcaoPoint {
    clazz?: string;
    pointId?: string;
    position?: LatLonPoint;
    referencePoint?: RangeAndBearing;
}
export const ICAO_POINT_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.airspace.IcaoPoint';
export interface RangeAndBearing {
    bearing?: number;
    pointId?: string;
    rangeInNm?: number;
}
export enum IcaoPointType {
    PUBLISHED_PT = 'PUBLISHED_PT',
    REFERENCE_PT = 'REFERENCE_PT',
    GEO_PT = 'GEO_PT',
    DBE_PT = 'DBE_PT',
}
export interface LatLonAltDistPoint extends LatLonAltPoint {
    distanceAlongInNm?: number;
    latitude?: number;
    level?: FlightLevel;
    longitude?: number;
    pointBeforeOrAtIdx?: number;
}
export const LAT_LON_ALT_DIST_POINT_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.airspace.LatLonAltDistPoint';
export interface LatLonAltPoint extends LatLonPoint {
    latitude?: number;
    level?: FlightLevel;
    longitude?: number;
}
export const LAT_LON_ALT_POINT_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.airspace.LatLonAltPoint';
export interface NavPoint extends LatLonPoint {
    icaoId?: string;
    id?: string;
    latitude?: number;
    longitude?: number;
    type?: NavPointType;
}
export const NAV_POINT_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.airspace.NavPoint';
export enum NavPointType {
    NAV = 'NAV',
    WP = 'WP',
    DB = 'DB',
}
export enum OceanicAreaControlCentre {
    GANDER = 'GANDER',
    SHANWICK = 'SHANWICK',
    SANTA_MARIA = 'SANTA_MARIA',
}
export interface PointSet {
    id?: string;
    pointIds?: Array<string>;
}
export enum ProcedureType {
    SID = 'SID',
    STAR = 'STAR',
}
export interface TerminalProcedureId {
    aerodromeId?: string;
    id?: string;
}
export interface TerminalProcedureOrDct {
    direct?: boolean;
    pointId?: string;
    routeId?: string;
}
export interface Unit {
    childUnits?: Array<string>;
    controlledAerodrome?: Array<string>;
    controlledAirspace?: Array<string>;
    id?: string;
    type?: UnitType;
}
export enum UnitType {
    ACC = 'ACC',
    AISU = 'AISU',
    AMC = 'AMC',
    AOA = 'AOA',
    AOCC = 'AOCC',
    AOCU = 'AOCU',
    AORO = 'AORO',
    APP = 'APP',
    ARO = 'ARO',
    CEU = 'CEU',
    CFPU = 'CFPU',
    CO = 'CO',
    EN = 'EN',
    FIC = 'FIC',
    FMP = 'FMP',
    FMU = 'FMU',
    HDLA = 'HDLA',
    IFPU = 'IFPU',
    OAC = 'OAC',
    RCC = 'RCC',
    RO = 'RO',
    TWR = 'TWR',
    UAC = 'UAC',
    DPIO = 'DPIO',
    ANSP = 'ANSP',
    ATSS = 'ATSS',
}
export interface AirspaceSummary_Airblock3dSummary {
    airblock?: string;
    maxLevel?: FlightLevel;
    minLevel?: FlightLevel;
}
export interface AirspaceSummary {
    airblocks?: Array<AirspaceSummary_Airblock3dSummary>;
    composedAirspace?: Array<AirspaceRef>;
    locationIndicator?: string;
    reference?: AirspaceRef;
    skipInMs?: number;
    skipOutMs?: number;
    testAirspace?: boolean;
}
export interface FlightKeys {
    adep?: string;
    ades?: string;
    airFiled?: boolean;
    callsign?: string;
    eobt?: Date;
    nonIcaoAdep?: boolean;
    nonIcaoAdes?: boolean;
}
export interface FlightId {
    flightKeys?: FlightKeys;
    id?: string;
}
export interface FlightEventDto {
    efdSent?: boolean;
    fumSent?: boolean;
    resultingEobt?: Date;
    resultingState?: FlightStateType;
    timestamp?: Date;
    type?: FlightEventType;
}
export enum FlightStateType {
    ATC_ACTIVATED = 'ATC_ACTIVATED',
    CANCELLED = 'CANCELLED',
    FILED = 'FILED',
    FILED_SLOT_ALLOCATED = 'FILED_SLOT_ALLOCATED',
    FILED_SLOT_ISSUED = 'FILED_SLOT_ISSUED',
    PLANNED = 'PLANNED',
    PLANNED_REROUTED = 'PLANNED_REROUTED',
    PLANNED_SLOT_ALLOCATED = 'PLANNED_SLOT_ALLOCATED',
    PLANNED_SLOT_ALLOCATED_REROUTED = 'PLANNED_SLOT_ALLOCATED_REROUTED',
    TACT_ACTIVATED = 'TACT_ACTIVATED',
    TERMINATED = 'TERMINATED',
    SUSPENDED = 'SUSPENDED',
}
export enum FlightModelType {
    FTFM = 'FTFM',
    RTFM = 'RTFM',
    CTFM = 'CTFM',
}
export enum DepartureAirportType {
    ADVANCED_ATC_TWR = 'ADVANCED_ATC_TWR',
    CDM = 'CDM',
    STANDARD = 'STANDARD',
}
export enum CdmStatus {
    DEPARTING_FROM_STANDARD_AIRPORT = 'DEPARTING_FROM_STANDARD_AIRPORT',
    DEPARTING_FROM_CDM_AIRPORT = 'DEPARTING_FROM_CDM_AIRPORT',
    ESTIMATED = 'ESTIMATED',
    TARGETED = 'TARGETED',
    PRE_SEQUENCED = 'PRE_SEQUENCED',
    ACTUAL_OFFBLOCK = 'ACTUAL_OFFBLOCK',
    PREDICTED = 'PREDICTED',
}
export interface FlightFieldType {}
export interface FlightAirspaceCrossing {
    activated?: boolean;
    airspaceId?: string;
    airspaceType?: AirspaceType;
    firstEntryDistance?: number;
    firstEntryFlightLevel?: FlightLevel;
    firstEntryTime?: Date;
    firstEntryTrend?: VerticalTrendType;
    lastExitDistance?: number;
    lastExitFlightLevel?: FlightLevel;
    lastExitTime?: Date;
    lastExitTrend?: VerticalTrendType;
    middleTrend?: VerticalTrendType;
    occupancyDistance?: number;
    occupanyInMs?: number;
}
export enum VerticalTrendType {
    CRUISE = 'CRUISE',
    CLIMB = 'CLIMB',
    DESCENT = 'DESCENT',
    NONE = 'NONE',
}
export interface FlightListDto {
    effectiveTrafficWindow?: TimePeriod;
    flightPlanSummariesOrInvalidFilings?: Array<FlightPlanSummaryOrInvalidFiling>;
    flights?: Array<FlightDto>;
    query?: FlightListRequestDto;
}
export interface DepartureToleranceDto {
    extended?: boolean;
    timePeriod?: TimePeriod;
}
export enum CfmuFlightType {
    MFD = 'MFD',
    IFPL = 'IFPL',
    RPL = 'RPL',
    ACT = 'ACT',
    TACT_ACTIVATED = 'TACT_ACTIVATED',
    TERMINATED = 'TERMINATED',
    PREDICTED_FLIGHT = 'PREDICTED_FLIGHT',
}
export enum SuspensionStatus {
    AIRPORT_SUSPENSION = 'AIRPORT_SUSPENSION',
    DELAY_CONFIRMATION = 'DELAY_CONFIRMATION',
    FLIGHT_PLAN_REVALIDATION = 'FLIGHT_PLAN_REVALIDATION',
    MANUAL_SUSPENSION = 'MANUAL_SUSPENSION',
    NOT_REPORTED_AS_AIRBORNE = 'NOT_REPORTED_AS_AIRBORNE',
    NOT_SUSPENDED = 'NOT_SUSPENDED',
    REGULATION_CONFIRMATION = 'REGULATION_CONFIRMATION',
    SIT_TIME_OUT = 'SIT_TIME_OUT',
    SLOT_MISSED = 'SLOT_MISSED',
    TRAFFIC_VOLUMES_CONDITION = 'TRAFFIC_VOLUMES_CONDITION',
    V_MANUAL_SUSPENSION = 'V_MANUAL_SUSPENSION',
}
export interface FlightCdmInfo {
    aircraftIdInbound?: string;
    aircraftType?: string;
    aircraftTypeDiscrepancy?: boolean;
    aircraftTypeIata?: string;
    airportType?: DepartureAirportType;
    atcTtot?: Date;
    cancelReason?: DpiCancelReasonType;
    consolidatedTtot?: Date;
    departureApronStand?: string;
    departureRunway?: string;
    departureStatus?: DepartureStatus;
    departureTerminal?: string;
    earliestTtot?: Date;
    flightStatusOutbound?: AtvFlightStatusOutbound;
    iataFlightDesignator?: string;
    iataFlightDesignatorDiscrepancy?: boolean;
    ifplIdInbound?: string;
    offBlockTimeDiscrepancy?: boolean;
    registration?: string;
    registrationMarkDiscrepancy?: boolean;
    registrationMarkInbound?: string;
    sid?: TerminalProcedureOrDct;
    status?: CdmStatus;
    taxiTimeInMs?: number;
    tobt?: Date;
    tsat?: Date;
    turnaroundTtot?: Date;
}
export interface ArrivalInformationDto {
    aircraftIataId?: string;
    aircraftType?: string;
    airportSlotArrival?: Date;
    apiArrivalProcedure?: TerminalProcedureOrDct;
    arrivalApronStand?: string;
    arrivalRunwayId?: string;
    arrivalTaxiTimeInMs?: number;
    arrivalTerminal?: string;
    calculatedTimeOver?: Date;
    consolidatedTargetTimeOver?: Date;
    coordinationFix?: PointOrAerodromeId;
    earliestTargetTimeOver?: Date;
    estimatedOrActualTimeOver?: Date;
    flightStatusInbound?: AtvFlightStatusInbound;
    impactSeverityIndicator?: ImpactSeverityIndicator;
    inBlockTime?: Date;
    initialApproachFix?: string;
    landingTime?: Date;
    maxCalculatedTimeOver?: Date;
    minCalculatedTimeOver?: Date;
    minimumTurnaroundTimeInMs?: number;
    nmArrivalProcedure?: TerminalProcedureOrDct;
    registrationMark?: string;
    regulationId?: string;
    scheduledInBlockTime?: Date;
    targetTimeOver?: Date;
}
export interface TaxiTimeAndProcedureDto {
    taxiTimeInMs?: number;
    taxiTimeSource?: TaxiTimeSource;
    terminalProcedure?: TerminalProcedureOrDct;
}
export interface SequenceRevisionTimes {
    timeToInsertInMs?: number;
    timeToRemoveInMs?: number;
    udppCutOffTime?: Date;
}
export interface ReadyStatus {
    readyForImprovement?: boolean;
    readyToDepart?: boolean;
    revisedTaxiTimeInMs?: number;
}
export interface FlightProfileRfl {
    flightLevel?: FlightLevel;
    relativeDistance?: number;
    segmentSequenceNumber?: number;
}
export interface Position4d {
    level?: FlightLevel;
    position?: LatLonPoint;
    timeOver?: Date;
}
export interface ReroutingIndicator {
    reason?: ReroutingReason;
    rerouted?: boolean;
    state?: ReroutingState;
}
export enum ReroutableStatusType {
    CANNOT_BE_REROUTED = 'CANNOT_BE_REROUTED',
    TRY_ALLOWED = 'TRY_ALLOWED',
    TRY_AND_APPLY_ALLOWED = 'TRY_AND_APPLY_ALLOWED',
}
export enum AtfmMessageType {
    DES = 'DES',
    ERR = 'ERR',
    FCM = 'FCM',
    FLS = 'FLS',
    FUM = 'FUM',
    REA = 'REA',
    RFI = 'RFI',
    RJT = 'RJT',
    RRN = 'RRN',
    RRP = 'RRP',
    SAM = 'SAM',
    SIP = 'SIP',
    SLC = 'SLC',
    SMM = 'SMM',
    SPA = 'SPA',
    SRJ = 'SRJ',
    SRM = 'SRM',
    SWM = 'SWM',
    UNK = 'UNK',
}
export interface ProposalInformationDto {
    deltaCost?: number;
    deltaDelayInMs?: number;
    kind?: ProposalKind;
    knownProposalContexts?: Array<string>;
    proposedCtot?: Date;
    reroutingId?: string;
    responseBy?: Date;
    routeId?: ReroutingRouteIdDto;
}
export interface FlightPointDto {
    aerodrome?: string;
    associatedRoute?: FlightPointAssociatedRoute;
    coveredDistance?: number;
    entryTrend?: VerticalTrendType;
    exitTrend?: VerticalTrendType;
    flightLevel?: FlightLevel;
    flightPlanPoint?: boolean;
    point?: IcaoPoint;
    timeOver?: Date;
    visible?: boolean;
}
export interface FlightTrafficVolumeDto {
    activated?: boolean;
    entryFlightLevel?: FlightLevel;
    entryTime?: Date;
    entryTrend?: VerticalTrendType;
    exempted?: boolean;
    exitFlightLevel?: FlightLevel;
    exitTime?: Date;
    exitTrend?: VerticalTrendType;
    flows?: Array<FlowDto>;
    middleTrend?: VerticalTrendType;
    tvId?: string;
}
export interface FlightRestrictionDto {
    coveredDistanceInNm?: number;
    event?: EntryExitType;
    flightLevel?: FlightLevel;
    flightPlanProcessing?: FlightPlanProcessingType;
    position?: LatLonPoint;
    restrictionId?: string;
    timeOver?: Date;
}
export interface DeltaEntry {
    airspaceOriginOfIntruder?: string;
    deltaFlightLevel?: number;
    deltaPositionInNm?: number;
    deltaTimeInMs?: number;
    intruderKind?: IntruderKindType;
}
export interface ExclusionFromRegulationsDto {
    all?: boolean;
    count?: number;
    hasBeenExcluded?: boolean;
    onTrafficVolume?: boolean;
}
export interface LoadStateAtRefLoc {
    entry?: LoadClassification;
    occupancy?: OtmvAlert_AlertStatus;
}
export interface SlotSwapCounterDto {
    maxNumberOfSwaps?: number;
    numberOfSwaps?: number;
}
export interface SlotSwapCandidateDto {
    candidateDeltaDelayInMinutes?: number;
    ifplId?: string;
    subjectDeltaDelayInMinutes?: number;
    swapDecideByTime?: Date;
}
export interface SlotZoneDto {
    afterCtoInMin?: number;
    beforeCtoInMin?: number;
}
export enum CtotLimitReasonType {
    FORCED_BY_CHAMAN = 'FORCED_BY_CHAMAN',
    FORCED_BY_NMOC = 'FORCED_BY_NMOC',
    FORCED_BY_STAM_MEASURE = 'FORCED_BY_STAM_MEASURE',
    FORCED_BY_TOWER = 'FORCED_BY_TOWER',
    LIMITED_BY_VIOLATION = 'LIMITED_BY_VIOLATION',
    LIMITED_BY_VIOLATION_THEN_ZERO_RATE_OR_RVR = 'LIMITED_BY_VIOLATION_THEN_ZERO_RATE_OR_RVR',
    SLOT_EXTENSION = 'SLOT_EXTENSION',
    SLOT_TIME_NOT_LIMITED = 'SLOT_TIME_NOT_LIMITED',
    WAS_FORCED_BY_NMOC = 'WAS_FORCED_BY_NMOC',
}
export enum ProfileValidityDto_ProfileValidityKind {
    NO_VIOLATIONS = 'NO_VIOLATIONS',
    UNKNOWN = 'UNKNOWN',
    VIOLATIONS = 'VIOLATIONS',
}
export interface ProfileValidityDto {
    lastValidEobt?: Date;
    profileValidityKind?: ProfileValidityDto_ProfileValidityKind;
}
export interface ApiSubmissionRulesDto {
    earliestSubmissionTargetTimeOverAPI?: Date;
    latestSubmissionTargetTakeOffAPI?: Date;
}
export enum TargetTimeDto_IntervalPosition {
    BEFORE = 'BEFORE',
    INSIDE = 'INSIDE',
    AFTER = 'AFTER',
}
export interface TargetTimeDto_ActualTimeAtTargetDto {
    estimatedActualTimeAtTarget?: Date;
    targetTimeCompliance?: TargetTimeDto_IntervalPosition;
}
export interface TargetTimeDto {
    actualTimeAtTarget?: TargetTimeDto_ActualTimeAtTargetDto;
    aerodrome?: string;
    coveredDistance?: number;
    flightPlanPoint?: boolean;
    point?: IcaoPoint;
    regulId?: string;
    targetLevel?: FlightLevel;
    targetTime?: Date;
}
export interface FlightCriticalityIndicatorDto {
    comment?: string;
    kind?: FlightCriticalityKind;
}
export interface AircraftIATAIdFromDataSourceDto {
    dataSource?: AircraftIdDataSource;
    id?: string;
}
export interface ReroutingOpportunitiesDto {
    offBlockTimeValidity?: TimePeriod;
    oplogTimestamp?: Date;
    opportunities?: Array<AlternateRouteInfoDto>;
    reroutingId?: string;
    reroutingNote?: string;
    reroutingPurpose?: ReroutingPurpose;
}
export interface ProbabilityAtTimes {
    durationInMs?: number;
    probabilities?: Array<number>;
    startTime?: Date;
    stepInMs?: number;
}
export interface RegulationRiskDto {
    maxDelayInMs?: number;
    regulationId?: string;
    regulationRiskPeriod?: TimePeriod;
    regulationState?: RegulationState;
}
export interface AlternateRouteInfoDto {
    delayInMin?: number;
    deltaDelayInMin?: number;
    deltaDurationInMin?: number;
    deltaFuelConsumptionInKg?: number;
    deltaLengthInNm?: number;
    deltaRouteChargesInEuros?: number;
    durationInMin?: number;
    fuelConsumptionInKg?: number;
    icaoRoute?: string;
    lengthInNm?: number;
    routeChargesInEuros?: number;
    routeId?: ReroutingRouteIdDto;
    totalCost?: number;
}
export enum AircraftIdDataSource {
    DDR = 'DDR',
    API = 'API',
    DPI = 'DPI',
    FPM = 'FPM',
}
export enum FlightCriticalityKind {
    CRITICAL_DUE_TO_AIRFRAME_UTILISATION = 'CRITICAL_DUE_TO_AIRFRAME_UTILISATION',
    CRITICAL_DUE_TO_AIRPORT_CLOSURE = 'CRITICAL_DUE_TO_AIRPORT_CLOSURE',
    CRITICAL_DUE_TO_CREW_TIME = 'CRITICAL_DUE_TO_CREW_TIME',
    CRITICAL_DUE_TO_NOISE_ABATEMENT = 'CRITICAL_DUE_TO_NOISE_ABATEMENT',
    CRITICAL_DUE_TO_OTHER_REASONS = 'CRITICAL_DUE_TO_OTHER_REASONS',
    CRITICAL_DUE_TO_PASSENGER_CONNECTIONS = 'CRITICAL_DUE_TO_PASSENGER_CONNECTIONS',
    CRITICAL_DUE_TO_PASSENGER_DELAY_COMPENSATION = 'CRITICAL_DUE_TO_PASSENGER_DELAY_COMPENSATION',
    CRITICAL_DUE_TO_TURNAROUND_CRITICAL = 'CRITICAL_DUE_TO_TURNAROUND_CRITICAL',
    WAS_CRITICAL = 'WAS_CRITICAL',
}
export enum IntruderKindType {
    NON_INTRUDER = 'NON_INTRUDER',
    HORIZONTAL_INTRUDER = 'HORIZONTAL_INTRUDER',
    MIXED_INTRUDER = 'MIXED_INTRUDER',
    VERTICAL_INTRUDER = 'VERTICAL_INTRUDER',
}
export enum FlightPlanProcessingType {
    RAD = 'RAD',
    PROFILE_TUNING = 'PROFILE_TUNING',
    AERODROME_FLIGHT_RULE = 'AERODROME_FLIGHT_RULE',
    TP_AIRCRAFT_TYPE_CLASSIFICATION = 'TP_AIRCRAFT_TYPE_CLASSIFICATION',
    DCT_LIMIT = 'DCT_LIMIT',
    SSR_CODE_ALLOCATION = 'SSR_CODE_ALLOCATION',
    FRA_DCT_LIMIT = 'FRA_DCT_LIMIT',
}
export enum EntryExitType {
    ENTRY = 'ENTRY',
    EXIT = 'EXIT',
}
export interface FlightPointAssociatedRoute {
    direct?: boolean;
    routeId?: string;
    sid?: TerminalProcedureId;
    star?: TerminalProcedureId;
}
export enum ProposalKind {
    DELAY_CONF = 'DELAY_CONF',
    RRP = 'RRP',
    RVR = 'RVR',
    SIP = 'SIP',
    STAM_SLOT = 'STAM_SLOT',
    NPP_PROPOSAL = 'NPP_PROPOSAL',
}
export enum ReroutingReason {
    AO = 'AO',
    ATC_PURPOSE_PROPOSAL = 'ATC_PURPOSE_PROPOSAL',
    ATFCM_PURPOSE_PROPOSAL = 'ATFCM_PURPOSE_PROPOSAL',
    ATFM_EXECUTED = 'ATFM_EXECUTED',
    CDR_OPPORTUNITY_PROPOSAL = 'CDR_OPPORTUNITY_PROPOSAL',
    FLIGHT_EFFICIENCY_PURPOSE_PROPOSAL = 'FLIGHT_EFFICIENCY_PURPOSE_PROPOSAL',
    STAM_PURPOSE_PROPOSAL = 'STAM_PURPOSE_PROPOSAL',
}
export enum ReroutingState {
    EXECUTED = 'EXECUTED',
    NO_MATCH = 'NO_MATCH',
    PRODUCED = 'PRODUCED',
    REJECTED = 'REJECTED',
    REVOKED = 'REVOKED',
    TIMED_OUT = 'TIMED_OUT',
}
export enum TaxiTimeSource {
    CDM = 'CDM',
    ENV = 'ENV',
    FPL = 'FPL',
    REA = 'REA',
    RWY = 'RWY',
}
export enum DepartureStatus {
    DEICING = 'DEICING',
    OK = 'OK',
}
export enum DpiCancelReasonType {
    FLIGHT_CANCEL_IN_AODB = 'FLIGHT_CANCEL_IN_AODB',
    FLIGHT_PLAN_INVALID = 'FLIGHT_PLAN_INVALID',
    NO_AIRPORT_SLOT = 'NO_AIRPORT_SLOT',
    OTHER = 'OTHER',
    RETURN_TO_STAND = 'RETURN_TO_STAND',
    TOBT_UNKNOWN_OR_EXPIRED = 'TOBT_UNKNOWN_OR_EXPIRED',
    TOT_UNKNOWN = 'TOT_UNKNOWN',
    TSAT_EXPIRED = 'TSAT_EXPIRED',
    UNDEFINED = 'UNDEFINED',
    UNDO_ADPI = 'UNDO_ADPI',
}
export interface FlightListRequestDto extends AbstractFlightRelatedRequest {
    algorithm?: FlightListAlgorithm;
    compareWithOtherTrafficType?: TrafficType;
    fields?: Array<FlightFieldType>;
    includeForecastFlights?: boolean;
    maxWindowForRegulationRiskInMs?: number;
    trafficType?: TrafficType;
    trafficWindow?: TimePeriod;
    worstLoadStateAtRefLocationType?: CountType;
}
export const FLIGHT_LIST_REQUEST_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.flight.FlightListRequestDto';
export interface FlightPlanSummaryOrInvalidFiling {
    invalidFiling?: InvalidFilingDto;
    lastValidFlightPlan?: FlightPlanSummaryDto;
}
export enum FlightPlanSummaryDto_FlightPlanStatus {
    AIRBORNE = 'AIRBORNE',
    BACKUP = 'BACKUP',
    CLOSED = 'CLOSED',
    FILED = 'FILED',
    OFFBLOCKS = 'OFFBLOCKS',
    SUSPENDED = 'SUSPENDED',
    TACT_DELETED = 'TACT_DELETED',
    TERMINATED = 'TERMINATED',
}
export interface FlightPlanSummaryDto {
    id?: FlightId;
    status?: FlightPlanSummaryDto_FlightPlanStatus;
}
export interface InvalidFilingDto {
    filingTime?: Date;
    invalidMessageStatus?: FlightPlanMessageStatus;
    invalidMessageType?: FlightPlanMessageType;
    keys?: FlightKeys;
}
export enum FlightPlanMessageType {
    ACH = 'ACH',
    AFP = 'AFP',
    APL = 'APL',
    ARR = 'ARR',
    CHG = 'CHG',
    CNL = 'CNL',
    DEP = 'DEP',
    DLA = 'DLA',
    FNM = 'FNM',
    FPL = 'FPL',
    MFS = 'MFS',
    RQP = 'RQP',
    RQS = 'RQS',
}
export enum FlightPlanMessageStatus {
    DELETED = 'DELETED',
    DISCARD = 'DISCARD',
    INVALID = 'INVALID',
    MULTIPLE = 'MULTIPLE',
    REFERRED = 'REFERRED',
    REJECTED = 'REJECTED',
}
export enum FlightListAlgorithm {
    NM = 'NM',
    PROBABILISTIC = 'PROBABILISTIC',
}
export interface AircraftPositionReportDto {
    position?: FlightPoint4D;
}
export interface FlightPoint4D {
    level?: FlightLevel;
    point?: IcaoPoint;
    timeOver?: Date;
}
export interface DepartureInformationDto {
    furtherRoute?: Array<IcaoPoint>;
    sid?: TerminalProcedureOrDct;
    star?: TerminalProcedureOrDct;
    takeOffTime?: Date;
    takeOffTimeQualifier?: EstimateQualifierType;
}
export interface EnrichedFlightId {
    dataset?: DatasetDto;
    flightId?: FlightId;
    proposalContext?: string;
}
export interface EnrouteInformationDto {
    arrivalProcedure?: TerminalProcedureOrDct;
    furtherRoute?: Array<IcaoPoint>;
    hold?: Array<EnRouteDelayDto>;
    position?: FlightPoint4D;
    positionQualifier?: EstimateQualifierType;
}
export enum FamStatus {
    AIRBORNE_WHEN_SHIFTED_BY_FAM = 'AIRBORNE_WHEN_SHIFTED_BY_FAM',
    AIRBORNE_WHEN_SUSPENDED_BY_FAM = 'AIRBORNE_WHEN_SUSPENDED_BY_FAM',
    NOT_UNDER_FAM = 'NOT_UNDER_FAM',
    SHIFTED_BY_FAM = 'SHIFTED_BY_FAM',
    SUBJECT_TO_FAM = 'SUBJECT_TO_FAM',
    SUSPENDED_BY_FAM = 'SUSPENDED_BY_FAM',
    WAS_SHIFTED_BY_FAM = 'WAS_SHIFTED_BY_FAM',
    WAS_SUBJECT_TO_FAM = 'WAS_SUBJECT_TO_FAM',
    WAS_SUSPENDED_BY_FAM = 'WAS_SUSPENDED_BY_FAM',
}
export interface FlightAircraftId {
    flightId?: FlightId;
    registrationMark?: string;
}
export interface FlightCriticalityRequestDto extends FlightInformationUpdateRequestDto {
    criticality?: FlightCriticalityIndicatorDto;
}
export const FLIGHT_CRITICALITY_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.flight.FlightCriticalityRequestDto';
export enum FlightDataset {
    FLIGHT = 'FLIGHT',
    FLIGHT_PLAN = 'FLIGHT_PLAN',
    FLIGHT_PLAN_HISTORY = 'FLIGHT_PLAN_HISTORY',
}
export enum FlightEventType {
    AAI = 'AAI',
    ACH = 'ACH',
    ADI = 'ADI',
    ADS = 'ADS',
    ADT = 'ADT',
    AFI = 'AFI',
    APL = 'APL',
    APR = 'APR',
    ATT = 'ATT',
    AXT = 'AXT',
    CAI = 'CAI',
    CAL = 'CAL',
    CDC = 'CDC',
    CDI = 'CDI',
    CEO = 'CEO',
    CMC = 'CMC',
    CMN = 'CMN',
    CNC = 'CNC',
    CPR = 'CPR',
    CPT = 'CPT',
    CRL = 'CRL',
    CRQ = 'CRQ',
    CSC = 'CSC',
    CSU = 'CSU',
    CTD = 'CTD',
    DAU = 'DAU',
    EAI = 'EAI',
    EDI = 'EDI',
    EMR = 'EMR',
    FCM = 'FCM',
    FDI = 'FDI',
    FLS = 'FLS',
    FSA = 'FSA',
    FUM = 'FUM',
    GAI = 'GAI',
    IAR = 'IAR',
    ICA = 'ICA',
    ICH = 'ICH',
    IDE = 'IDE',
    IDL = 'IDL',
    IFP = 'IFP',
    MET = 'MET',
    MSG = 'MSG',
    NEV = 'NEV',
    OAI = 'OAI',
    OAR = 'OAR',
    OCA = 'OCA',
    OCM = 'OCM',
    ODA = 'ODA',
    OEX = 'OEX',
    OIC = 'OIC',
    ORX = 'ORX',
    PDI = 'PDI',
    PFI = 'PFI',
    PTD = 'PTD',
    PTX = 'PTX',
    REA = 'REA',
    TRE = 'TRE',
    RFR = 'RFR',
    RSF = 'RSF',
    RJT = 'RJT',
    RLR = 'RLR',
    RPL = 'RPL',
    RPU = 'RPU',
    RRF = 'RRF',
    RRM = 'RRM',
    RSI = 'RSI',
    RSU = 'RSU',
    RWI = 'RWI',
    SCA = 'SCA',
    SCM = 'SCM',
    SIP = 'SIP',
    SIT = 'SIT',
    SMM = 'SMM',
    SPA = 'SPA',
    SRJ = 'SRJ',
    SSC = 'SSC',
    SSM = 'SSM',
    SSP = 'SSP',
    SSR = 'SSR',
    SUS = 'SUS',
    TAC = 'TAC',
    TAI = 'TAI',
    TAM = 'TAM',
    TDE = 'TDE',
    TDI = 'TDI',
    TPF = 'TPF',
    TRC = 'TRC',
    TRM = 'TRM',
    TSA = 'TSA',
    TSC = 'TSC',
    TTE = 'TTE',
    UAA = 'UAA',
    UCD = 'UCD',
    UFA = 'UFA',
    UFC = 'UFC',
    UXC = 'UXC',
    XCR = 'XCR',
}
export interface FlightDto {
    clazz?: string;
    actualOffBlockTime?: Date;
    actualTakeOffTime?: Date;
    actualTimeOfArrival?: Date;
    aircraftAddress?: string;
    aircraftOperator?: string;
    aircraftType?: string;
    alternateAerodromes?: Array<string>;
    apiSubmissionRules?: ApiSubmissionRulesDto;
    applicableScenarios?: Array<TrafficVolumeScenariosDto>;
    arrivalInformation?: ArrivalInformationDto;
    atfcmMeasureLocations?: Array<FlightAtfcmMeasureLoc>;
    avoidedRegulationIds?: Array<string>;
    bestReroutingIndicator?: GroupReroutingSummaryDto;
    calculatedOffBlockTime?: Date;
    calculatedTakeOffTime?: Date;
    calculatedTimeOfArrival?: Date;
    caughtInHotspots?: number;
    cdmEobt?: Date;
    cdmInfo?: FlightCdmInfo;
    cfmuFlightType?: CfmuFlightType;
    compareWithOtherTrafficType?: DeltaEntry;
    confirmedCprDistance?: number;
    ctfmAirspacePoints?: Array<FlightAirspaceCrossing>;
    ctfmDynamicVolumeProfile?: Array<FlightDynamicVolumeCrossing>;
    ctfmPoints?: Array<FlightPointDto>;
    ctfmRequestedFlightLevels?: Array<FlightProfileRfl>;
    ctfmRestrictionProfile?: Array<FlightRestrictionDto>;
    ctfmTrafficVolumeProfile?: Array<FlightTrafficVolumeDto>;
    ctotLimitReason?: CtotLimitReasonType;
    currentDepartureTaxiTimeAndProcedure?: TaxiTimeAndProcedureDto;
    dataVersionNumber?: number;
    dataset?: DatasetDto;
    delayInMs?: number;
    departureTolerance?: DepartureToleranceDto;
    divertedAdes?: string;
    estimatedElapsedTimeInMs?: number;
    estimatedTakeOffTime?: Date;
    estimatedTimeOfArrival?: Date;
    excludedRegulationIds?: Array<string>;
    exclusionFromRegulations?: ExclusionFromRegulationsDto;
    exemptedFromRegulations?: boolean;
    filedRegistration?: string;
    flightCriticality?: FlightCriticalityIndicatorDto;
    flightHistory?: Array<FlightEventDto>;
    flightId?: FlightId;
    flightIsIoat?: boolean;
    flightLevelAtReferenceLocationEntry?: FlightLevel;
    flightLevelAtReferenceLocationExit?: FlightLevel;
    flightState?: FlightStateType;
    ftfmAirspacePoints?: Array<FlightAirspaceCrossing>;
    ftfmDynamicVolumeProfile?: Array<FlightDynamicVolumeCrossing>;
    ftfmPoints?: Array<FlightPointDto>;
    ftfmRequestedFlightLevels?: Array<FlightProfileRfl>;
    ftfmRestrictionProfile?: Array<FlightRestrictionDto>;
    ftfmTrafficVolumeProfile?: Array<FlightTrafficVolumeDto>;
    fuelConsumptionInKg?: number;
    hasBeenForced?: boolean;
    hasOtherRegulations?: boolean;
    hotspots?: Array<FlightHotspotLoc>;
    iataFlightDesignator?: AircraftIATAIdFromDataSourceDto;
    icaoRoute?: string;
    initialRfl?: FlightLevel;
    lastAtfmMessageType?: AtfmMessageType;
    lastKnownPosition?: Position4d;
    lateFiler?: boolean;
    lateUpdater?: boolean;
    mcdmInfo?: FlightMcdmInfo;
    minimumTurnaroundTimeInMin?: number;
    mostPenalisingRegulation?: string;
    mostPenalizingRegulationCause?: RegulationCauseDto;
    opLogHistory?: Array<OpLogEntry>;
    operatingAircraftOperator?: string;
    otherRemarks?: string;
    priority?: number;
    probabilityInCountSteps?: ProbabilityAtTimes;
    probabilityInQuery?: number;
    profileValidity?: ProfileValidityDto;
    proposalContext?: string;
    proposalInformation?: ProposalInformationDto;
    readyEobt?: Date;
    readyStatus?: ReadyStatus;
    regulationLocations?: Array<FlightRegLocation>;
    regulationRiskInBlockTimeZone?: Array<RegulationRiskDto>;
    regulationRiskOffBlockTimeZone?: Array<RegulationRiskDto>;
    regulationRiskTakeOffTimeZone?: Array<RegulationRiskDto>;
    requestedInitialSpeed?: AirSpeed;
    reroutable?: ReroutableStatusType;
    reroutingIndicator?: ReroutingIndicator;
    reroutingOpportunities?: Array<ReroutingOpportunitiesDto>;
    revisionTimes?: SequenceRevisionTimes;
    rfl?: FlightLevel;
    routeChargesInEuros?: number;
    routeLength?: number;
    rtfmAirspacePoints?: Array<FlightAirspaceCrossing>;
    rtfmDynamicVolumeProfile?: Array<FlightDynamicVolumeCrossing>;
    rtfmPoints?: Array<FlightPointDto>;
    rtfmRequestedFlightLevels?: Array<FlightProfileRfl>;
    rtfmRestrictionProfile?: Array<FlightRestrictionDto>;
    rtfmTrafficVolumeProfile?: Array<FlightTrafficVolumeDto>;
    runwayVisualRange?: number;
    slotIssued?: boolean;
    slotSwapCandidateList?: Array<SlotSwapCandidateDto>;
    slotSwapCounter?: SlotSwapCounterDto;
    slotZone?: SlotZoneDto;
    suspensionStatus?: SuspensionStatus;
    targetTimeOverFix?: TargetTimeDto;
    taxiTimeInMs?: number;
    timeAtReferenceLocationEntry?: TimeAndTrafficType;
    timeAtReferenceLocationExit?: TimeAndTrafficType;
    trendAtReferenceLocationEntry?: VerticalTrendType;
    trendAtReferenceLocationExit?: VerticalTrendType;
    trendAtReferenceLocationMiddle?: VerticalTrendType;
    turnaroundImpactMarginInMin?: number;
    udppFlightParams?: UdppFlightParametersExtendedDto;
    unplannedTvs?: Array<string>;
    wakeTurbulenceCategory?: WakeTurbulenceCategory;
    worstLoadStateAtReferenceLocation?: LoadStateAtRefLoc;
}
export const FLIGHT_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.flight.FlightDto';
export interface IataFlightKeysDto {
    estimatedOffBlockTime?: Date;
    flightDesignator?: string;
}
export enum FlightExchangeModelType {
    FIXM = 'FIXM',
    NM_B2B = 'NM_B2B',
}
export interface FlightIataId {
    iataAdep?: string;
    iataAdes?: string;
    iataId?: string;
    originDate?: Date;
    repeatNumber?: number;
}
export interface FlightIdAndDataset {
    dataset?: DatasetDto;
    flightId?: FlightId;
}
export interface FlightIdListRequestDto {
    adep?: string;
    ades?: string;
    airFiled?: boolean;
    callsign?: string;
    dataset?: DatasetDto;
    eobtPeriod?: TimePeriod;
    iataFlightKeys?: IataFlightKeysDto;
    ifplId?: string;
    nonIcaoAdep?: boolean;
    nonIcaoAdes?: boolean;
}
export interface FlightPlanListRequestDto {
    adep?: string;
    ades?: string;
    airFiled?: boolean;
    callsign?: string;
    eobtPeriod?: TimePeriod;
    nonIcaoAdep?: boolean;
    nonIcaoAdes?: boolean;
}
export interface FlightListByKeysRequestDto extends FlightListRequestDto {
    adep?: string;
    ades?: string;
    airFiled?: boolean;
    aircraftId?: string;
    nonIcaoAdep?: boolean;
    nonIcaoAdes?: boolean;
    returnInvalidFilingSummaries?: boolean;
}
export const FLIGHT_LIST_BY_KEYS_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.flight.FlightListByKeysRequestDto';
export interface FlightListByAORequestDto extends FlightListByLocationRequestDto {
    timeType?: TimeWindowType;
}
export const FLIGHT_LIST_BY_A_O_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.flight.FlightListByAORequestDto';
export interface FlightListByLocationRequestDto extends FlightListRequestDto {
    aircraftOperators?: Array<string>;
    countsInterval?: CountsIntervalDto;
    includeInvisibleFlights?: boolean;
}
export const FLIGHT_LIST_BY_LOCATION_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.flight.FlightListByLocationRequestDto';
export interface FlightListByAerodromeRequestDto extends FlightListByLocationRequestDto {
    aerodrome?: string;
    role?: AerodromeRole;
}
export const FLIGHT_LIST_BY_AERODROME_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.flight.FlightListByAerodromeRequestDto';
export interface FlightListByAircraftRegistrationRequestDto extends FlightListRequestDto {
    registrationMark?: string;
}
export const FLIGHT_LIST_BY_AIRCRAFT_REGISTRATION_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.flight.FlightListByAircraftRegistrationRequestDto';
export interface FlightListByAirspaceRequestDto extends FlightListByLocationRequestDto {
    airspace?: string;
    calculationType?: TimeWindowType;
}
export const FLIGHT_LIST_BY_AIRSPACE_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.flight.FlightListByAirspaceRequestDto';
export interface FlightListByHotspotRequestDto extends FlightListByLocationRequestDto {
    flowId?: string;
    hotspotId?: HotspotId;
    periodExtensionInMs?: number;
}
export const FLIGHT_LIST_BY_HOTSPOT_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.flight.FlightListByHotspotRequestDto';
export enum FlightListByMeasureRequestDto_Mode {
    ACTIVATED_BY_MEASURE = 'ACTIVATED_BY_MEASURE',
    CONCERNED_BY_MEASURE = 'CONCERNED_BY_MEASURE',
}
export interface FlightListByMeasureRequestDto extends FlightListByLocationRequestDto {
    measureId?: MeasureId;
    mode?: FlightListByMeasureRequestDto_Mode;
}
export const FLIGHT_LIST_BY_MEASURE_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.flight.FlightListByMeasureRequestDto';
export interface FlightListByPointRequestDto extends FlightListByLocationRequestDto {
    flightLevelRange?: FlightLevelBand;
    point?: string;
}
export const FLIGHT_LIST_BY_POINT_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.flight.FlightListByPointRequestDto';
export interface FlightListByTvRequestDto extends FlightListByLocationRequestDto {
    flowId?: string;
    timeType?: TimeWindowType;
    tvName?: string;
}
export const FLIGHT_LIST_BY_TV_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.flight.FlightListByTvRequestDto';
export interface FlightResultList_Failure {
    flightKeys?: FlightKeys;
    reason?: string;
}
export interface FlightResultList<R> {
    failures?: Array<FlightResultList_Failure>;
    processed?: Array<R>;
}
export interface FlightTrafficVolumeListRequestDto extends AbstractFlightRelatedRequest {
    activeOnly?: boolean;
    dataset?: DatasetDto;
    flightId?: FlightId;
    hourlyCapacityDefinedOnly?: boolean;
    otmvDefinedOnly?: boolean;
    proposalContexts?: Array<string>;
    trafficType?: TrafficType;
    tvsWithoutFlowsOnly?: boolean;
}
export const FLIGHT_TRAFFIC_VOLUME_LIST_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.flight.FlightTrafficVolumeListRequestDto';
export interface FlightTvCrossingInfo {
    airspaceCrossing?: FlightAirspaceCrossing;
    flightPoint?: FlightPointDto;
}
export interface FlightUpdateChoiceDto {
    aircraftPositionReport?: AircraftPositionReportDto;
    departureInfo?: DepartureInformationDto;
    enrouteInfo?: EnrouteInformationDto;
    landingInfo?: LandingInfoDto;
    oceanicInfo?: OceanicInformationDto;
}
export interface OceanicInformationDto {
    icaoRoute?: string;
    landfallPoint?: IcaoPoint;
    position?: FlightPoint4D;
    source?: OceanicAreaControlCentre;
}
export interface LandingInfoDto {
    landingTime?: Date;
    landingTimeQualifier?: EstimateQualifierType;
}
export interface FlightUpdateReplyDto extends FlightInformationUpdateReplyDto {
    ifpsProcessingResult?: FilingReplyDto;
}
export interface FlightUpdateRequestDto extends FlightInformationUpdateRequestDto {
    aircraftAddress?: string;
    aircraftType?: string;
    choice?: FlightUpdateChoiceDto;
    numberOfAircraft?: number;
    registrationMark?: string;
    wakeTurbulenceCategory?: WakeTurbulenceCategory;
}
export const FLIGHT_UPDATE_REQUEST_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.flight.FlightUpdateRequestDto';
export class InnoveFlightFieldType implements FlightFieldType {
    public static readonly REGULATION_RISK_OFF_BLOCK_TIME_ZONE = [
        'eurocontrol.npp.core.shared.dto.flight.InnoveFlightFieldType',
        'REGULATION_RISK_OFF_BLOCK_TIME_ZONE',
    ];
    public static readonly REGULATION_RISK_IN_BLOCK_TIME_ZONE = [
        'eurocontrol.npp.core.shared.dto.flight.InnoveFlightFieldType',
        'REGULATION_RISK_IN_BLOCK_TIME_ZONE',
    ];
    public static readonly REGULATION_RISK_TAKEOFF_TIME_ZONE = [
        'eurocontrol.npp.core.shared.dto.flight.InnoveFlightFieldType',
        'REGULATION_RISK_TAKEOFF_TIME_ZONE',
    ];
    public static readonly PRIORITY = ['eurocontrol.npp.core.shared.dto.flight.InnoveFlightFieldType', 'PRIORITY'];
    public static readonly CTFM_DYNAMIC_VOLUME_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.InnoveFlightFieldType',
        'CTFM_DYNAMIC_VOLUME_PROFILE',
    ];
    public static readonly RTFM_DYNAMIC_VOLUME_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.InnoveFlightFieldType',
        'RTFM_DYNAMIC_VOLUME_PROFILE',
    ];
    public static readonly FTFM_DYNAMIC_VOLUME_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.InnoveFlightFieldType',
        'FTFM_DYNAMIC_VOLUME_PROFILE',
    ];
    public static readonly HIGHEST_DYNAMIC_VOLUME_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.InnoveFlightFieldType',
        'HIGHEST_DYNAMIC_VOLUME_PROFILE',
    ];
}
export interface MessageOriginatorDto {
    address?: NetworkAddressDto;
    anuId?: string;
}
export class StandardFlightFieldType implements FlightFieldType {
    public static readonly COBT = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'COBT'];
    public static readonly CTOT = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'CTOT'];
    public static readonly ETOT = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'ETOT'];
    public static readonly AOBT = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'AOBT'];
    public static readonly ATOT = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'ATOT'];
    public static readonly CTA = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'CTA'];
    public static readonly ETA = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'ETA'];
    public static readonly ATA = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'ATA'];
    public static readonly DELAY = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'DELAY'];
    public static readonly DEPARTURE_TOLERANCE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'DEPARTURE_TOLERANCE',
    ];
    public static readonly CDM_EOBT = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'CDM_EOBT'];
    public static readonly READY_EOBT = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'READY_EOBT',
    ];
    public static readonly SLOT_ISSUED = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'SLOT_ISSUED',
    ];
    public static readonly MPR = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'MPR'];
    public static readonly MPR_CAUSE = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'MPR_CAUSE'];
    public static readonly EXEMPTED_FROM_REGULATIONS = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'EXEMPTED_FROM_REGULATIONS',
    ];
    public static readonly EXCLUSION_FROM_REGULATIONS = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'EXCLUSION_FROM_REGULATIONS',
    ];
    public static readonly HAS_OTHER_REGULATIONS = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'HAS_OTHER_REGULATIONS',
    ];
    public static readonly REGULATION_LOCATIONS = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'REGULATION_LOCATIONS',
    ];
    public static readonly ATFCM_MEASURE_LOCATIONS = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'ATFCM_MEASURE_LOCATIONS',
    ];
    public static readonly EXCLUDED_REGULATIONS = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'EXCLUDED_REGULATIONS',
    ];
    public static readonly AVOIDED_REGULATIONS = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'AVOIDED_REGULATIONS',
    ];
    public static readonly CFMU_FLIGHT_TYPE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'CFMU_FLIGHT_TYPE',
    ];
    public static readonly FLIGHT_STATE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'FLIGHT_STATE',
    ];
    public static readonly SUSPENSION = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'SUSPENSION',
    ];
    public static readonly LATE_FILER = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'LATE_FILER',
    ];
    public static readonly LATE_UPDATER = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'LATE_UPDATER',
    ];
    public static readonly DIVERTED_ADES = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'DIVERTED_ADES',
    ];
    public static readonly ALTERNATE_AERODROMES = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'ALTERNATE_AERODROMES',
    ];
    public static readonly CDM_INFO = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'CDM_INFO'];
    public static readonly ARRIVAL_INFORMATION = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'ARRIVAL_INFORMATION',
    ];
    public static readonly TAXI_TIME = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'TAXI_TIME'];
    public static readonly CURRENT_DEPARTURE_TAXI_TIME_AND_PROCEDURE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'CURRENT_DEPARTURE_TAXI_TIME_AND_PROCEDURE',
    ];
    public static readonly REVISION_TIMES = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'REVISION_TIMES',
    ];
    public static readonly READY_STATUS = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'READY_STATUS',
    ];
    public static readonly AO = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'AO'];
    public static readonly OPERATING_AO = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'OPERATING_AO',
    ];
    public static readonly AC_TYPE = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'AC_TYPE'];
    public static readonly WAKE_TURBULENCE_CATEGORY = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'WAKE_TURBULENCE_CATEGORY',
    ];
    public static readonly FILED_REGISTRATION = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'FILED_REGISTRATION',
    ];
    public static readonly AIRCRAFT_ADDRESS = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'AIRCRAFT_ADDRESS',
    ];
    public static readonly RUNWAY_VISUAL_RANGE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'RUNWAY_VISUAL_RANGE',
    ];
    public static readonly RFL = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'RFL'];
    public static readonly INITIAL_RFL = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'INITIAL_RFL',
    ];
    public static readonly REQUESTED_INITIAL_SPEED = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'REQUESTED_INITIAL_SPEED',
    ];
    public static readonly FL_AT_REFLOC_ENTRY = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'FL_AT_REFLOC_ENTRY',
    ];
    public static readonly FL_AT_REFLOC_EXIT = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'FL_AT_REFLOC_EXIT',
    ];
    public static readonly TIME_AT_REFLOC_ENTRY = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'TIME_AT_REFLOC_ENTRY',
    ];
    public static readonly TIME_AT_REFLOC_EXIT = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'TIME_AT_REFLOC_EXIT',
    ];
    public static readonly TREND_ENTRY = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'TREND_ENTRY',
    ];
    public static readonly TREND_MIDDLE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'TREND_MIDDLE',
    ];
    public static readonly TREND_EXIT = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'TREND_EXIT',
    ];
    public static readonly CONFIRMED_CPR = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'CONFIRMED_CPR',
    ];
    public static readonly ROUTE_LENGTH = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'ROUTE_LENGTH',
    ];
    public static readonly EET = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'EET'];
    public static readonly ICAO_ROUTE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'ICAO_ROUTE',
    ];
    public static readonly RRT_INDICATOR = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'RRT_INDICATOR',
    ];
    public static readonly REROUTABLE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'REROUTABLE',
    ];
    public static readonly BEST_REROUTING_INDICATOR = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'BEST_REROUTING_INDICATOR',
    ];
    public static readonly CTFM_POINT_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'CTFM_POINT_PROFILE',
    ];
    public static readonly RTFM_POINT_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'RTFM_POINT_PROFILE',
    ];
    public static readonly FTFM_POINT_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'FTFM_POINT_PROFILE',
    ];
    public static readonly HIGHEST_POINT_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'HIGHEST_POINT_PROFILE',
    ];
    public static readonly CTFM_AIRSPACE_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'CTFM_AIRSPACE_PROFILE',
    ];
    public static readonly RTFM_AIRSPACE_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'RTFM_AIRSPACE_PROFILE',
    ];
    public static readonly FTFM_AIRSPACE_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'FTFM_AIRSPACE_PROFILE',
    ];
    public static readonly HIGHEST_AIRSPACE_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'HIGHEST_AIRSPACE_PROFILE',
    ];
    public static readonly FTFM_REQUESTED_FLIGHT_LEVELS = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'FTFM_REQUESTED_FLIGHT_LEVELS',
    ];
    public static readonly RTFM_REQUESTED_FLIGHT_LEVELS = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'RTFM_REQUESTED_FLIGHT_LEVELS',
    ];
    public static readonly CTFM_REQUESTED_FLIGHT_LEVELS = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'CTFM_REQUESTED_FLIGHT_LEVELS',
    ];
    public static readonly FTFM_RESTRICTION_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'FTFM_RESTRICTION_PROFILE',
    ];
    public static readonly RTFM_RESTRICTION_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'RTFM_RESTRICTION_PROFILE',
    ];
    public static readonly CTFM_RESTRICTION_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'CTFM_RESTRICTION_PROFILE',
    ];
    public static readonly HIGHEST_RESTRICTION_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'HIGHEST_RESTRICTION_PROFILE',
    ];
    public static readonly CTFM_TRAFFIC_VOLUME_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'CTFM_TRAFFIC_VOLUME_PROFILE',
    ];
    public static readonly RTFM_TRAFFIC_VOLUME_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'RTFM_TRAFFIC_VOLUME_PROFILE',
    ];
    public static readonly FTFM_TRAFFIC_VOLUME_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'FTFM_TRAFFIC_VOLUME_PROFILE',
    ];
    public static readonly HIGHEST_TRAFFIC_VOLUME_PROFILE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'HIGHEST_TRAFFIC_VOLUME_PROFILE',
    ];
    public static readonly OPLOG = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'OPLOG'];
    public static readonly FLIGHT_HISTORY = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'FLIGHT_HISTORY',
    ];
    public static readonly LAST_ATFM_MESSAGE_TYPE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'LAST_ATFM_MESSAGE_TYPE',
    ];
    public static readonly COMPARE_WITH_OTHER_TRAFFIC_TYPE = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'COMPARE_WITH_OTHER_TRAFFIC_TYPE',
    ];
    public static readonly PROPOSAL_CONTEXT = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'PROPOSAL_CONTEXT',
    ];
    public static readonly PROPOSAL_INFORMATION = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'PROPOSAL_INFORMATION',
    ];
    public static readonly HAS_BEEN_FORCED = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'HAS_BEEN_FORCED',
    ];
    public static readonly CAUGHT_IN_HOTSPOTS = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'CAUGHT_IN_HOTSPOTS',
    ];
    public static readonly HOTSPOTS = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'HOTSPOTS'];
    public static readonly MCDM_INFO = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'MCDM_INFO'];
    public static readonly WORST_LOAD_STATE_AT_REFLOC = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'WORST_LOAD_STATE_AT_REFLOC',
    ];
    public static readonly LAST_KNOWN_POSITION = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'LAST_KNOWN_POSITION',
    ];
    public static readonly CTOT_LIMIT_REASON = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'CTOT_LIMIT_REASON',
    ];
    public static readonly PROFILE_VALIDITY = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'PROFILE_VALIDITY',
    ];
    public static readonly SLOT_SWAP_COUNTER = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'SLOT_SWAP_COUNTER',
    ];
    public static readonly SLOT_SWAP_CANDIDATE_LIST = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'SLOT_SWAP_CANDIDATE_LIST',
    ];
    public static readonly SLOT_ZONE = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'SLOT_ZONE'];
    public static readonly DATA_VERSION_NUMBER = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'DATA_VERSION_NUMBER',
    ];
    public static readonly APPLICABLE_SCENARIOS = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'APPLICABLE_SCENARIOS',
    ];
    public static readonly API_SUBMISSION_RULES = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'API_SUBMISSION_RULES',
    ];
    public static readonly FUEL_CONSUMPTION = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'FUEL_CONSUMPTION',
    ];
    public static readonly ROUTE_CHARGES = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'ROUTE_CHARGES',
    ];
    public static readonly FLIGHT_CRITICALITY = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'FLIGHT_CRITICALITY',
    ];
    public static readonly TARGET_TIME_OVER_FIX = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'TARGET_TIME_OVER_FIX',
    ];
    public static readonly IATA_FLIGHT_DESIGNATOR = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'IATA_FLIGHT_DESIGNATOR',
    ];
    public static readonly UNPLANNED_TVS = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'UNPLANNED_TVS',
    ];
    public static readonly UDPP_FLIGHT_PARAMETERS = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'UDPP_FLIGHT_PARAMETERS',
    ];
    public static readonly REROUTING_OPPORTUNITIES = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'REROUTING_OPPORTUNITIES',
    ];
    public static readonly IOAT = ['eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType', 'IOAT'];
    public static readonly OTHER_REMARKS = [
        'eurocontrol.npp.core.shared.dto.flight.StandardFlightFieldType',
        'OTHER_REMARKS',
    ];
}
export class StandardNppFlightFieldType implements FlightFieldType {
    public static readonly PROBABILITY_IN_QUERY = [
        'eurocontrol.npp.core.shared.dto.flight.StandardNppFlightFieldType',
        'PROBABILITY_IN_QUERY',
    ];
    public static readonly PROBABILITY_IN_COUNT_STEPS = [
        'eurocontrol.npp.core.shared.dto.flight.StandardNppFlightFieldType',
        'PROBABILITY_IN_COUNT_STEPS',
    ];
    public static readonly TURNAROUND_IMPACT_MARGIN = [
        'eurocontrol.npp.core.shared.dto.flight.StandardNppFlightFieldType',
        'TURNAROUND_IMPACT_MARGIN',
    ];
    public static readonly MINIMUM_TURNAROUND_TIME = [
        'eurocontrol.npp.core.shared.dto.flight.StandardNppFlightFieldType',
        'MINIMUM_TURNAROUND_TIME',
    ];
}
export enum ValueQuality {
    ESTIMATED = 'ESTIMATED',
    CALCULATED = 'CALCULATED',
    ACTUAL = 'ACTUAL',
}
export interface FlightDetailsReplyDto {
    flight?: FlightDto;
    flightPlanHistory?: FlightPlanHistoryDto;
    structuredFlightPlan?: StructuredFlightPlanDto;
}
export interface FlightDetailsRequestDto extends AbstractFlightRelatedRequest {
    flightDatasets?: Array<FlightDataset>;
    flightFields?: Array<FlightFieldType>;
    flightId?: FlightId;
    iataFlightKeys?: IataFlightKeysDto;
    maxWindowForRegulationRiskInMs?: number;
    requestedDataFormat?: FlightExchangeModelType;
}
export const FLIGHT_DETAILS_REQUEST_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.flight.FlightDetailsRequestDto';
export enum FlightType {
    GENERAL = 'GENERAL',
    MILITARY = 'MILITARY',
    NOT_SCHEDULED = 'NOT_SCHEDULED',
    OTHER = 'OTHER',
    SCHEDULED = 'SCHEDULED',
}
export interface ReroutingRouteIdDto {
    routeType?: ReroutingRouteType;
    standardRouteId?: StandardRouteIdDto;
}
export enum ReroutingRouteType {
    GENERATED = 'GENERATED',
    STANDARD = 'STANDARD',
    USER = 'USER',
    VERTICAL = 'VERTICAL',
}
export interface StandardRouteIdDto {
    adep?: string;
    ades?: string;
    seqNr?: number;
}
export interface RouteInfoDto {
    countChanges?: Array<NiaImpactOnTv>;
    ctot?: Date;
    delayInMs?: number;
    durationInMs?: number;
    fuelConsumptionInKg?: number;
    hotspotCountChanges?: Array<NiaImpactOnHotspot>;
    icaoRoute?: string;
    ifpsErrors?: Array<IfpsError>;
    lengthInNm?: number;
    mostPenalisingRegulation?: string;
    overloadedTvIds?: Array<string>;
    profileValidity?: ProfileValidityDto;
    regulationLocations?: Array<FlightRegLocation>;
    routeChargesInEuros?: number;
    routeId?: ReroutingRouteIdDto;
    suspensionStatus?: SuspensionStatus;
}
export interface RoutingAssistanceDataResultDto {
    aircraftId?: string;
    aircraftType?: string;
    estimatedTakeOffTime?: Date;
    extraOriginalFlightData?: FlightDto;
    originalRoute?: RouteInfoDto;
    proposedRoutes?: Array<RouteInfoDto>;
}
export interface IfpsError {
    anomalyComment?: string;
    code?: string;
    description?: string;
}
export interface EnRouteDelayDto {
    delayInMinutes?: number;
    point?: IcaoPoint;
}
export interface StructuredFlightPlanDto {
    basicTrajectoryData?: BasicTrajectoryDataDto;
    departureData?: DepartureDataDto;
    flightPlan?: FlightPlanDto;
}
export interface FlightPlanHistoryDto {
    infos?: Array<FlightPlanHistoryInfoDto>;
}
export interface FlightPlanHistoryInfoDto {
    addresses?: Array<string>;
    checkpoint?: string;
    detail?: string;
    mode?: string;
    msgIn?: string;
    msgOut?: string;
    timeStamp?: Date;
}
export interface FlightPlanDto {
    adep?: FplAerodrome;
    ades?: AerodromeOfDestinationsDto;
    airFiledData?: AirFiledDataDto;
    aircraftId?: AircraftIdentificationDto;
    aircraftType?: string;
    arrivalAirportSlot?: string;
    departureAirportSlot?: string;
    eetsToLocations?: Array<EstimatedElapsedTimeAtLocationDto>;
    enrouteAlternates?: string;
    enrouteDelays?: Array<EnRouteDelayDto>;
    eobt?: Date;
    equipment?: EquipmentCapabilityAndStatusDto;
    flightPlanOriginator?: FlightPlanOriginatorDto;
    flightRules?: FlightRules;
    flightType?: FlightType;
    iataFlightNumber?: string;
    icaoRoute?: string;
    ifplId?: string;
    numberOfAircraft?: number;
    otherInformation?: OtherInformationDto;
    stayInformation?: Array<string>;
    supplementaryInformation?: SupplementaryInformationDto;
    surveillanceEquipment?: SurveillanceEquipmentDto;
    takeOffAlternates?: string;
    totalEstimatedElapsedTimeInMs?: number;
    whatIfRerouteReference?: number;
    wtc?: WakeTurbulenceCategory;
}
export interface DepartureDataDto {
    taxiTimeInMin?: number;
}
export interface BasicTrajectoryDataDto {
    bottomOfClimb?: Array<Relative4DPointDto>;
    bottomOfDescent?: Array<Relative4DPointDto>;
    distanceAtLocation?: DistanceAtLocationDto;
    takeOffWeightInKg?: number;
    topOfClimb?: Array<Relative4DPointDto>;
    topOfDescent?: Array<Relative4DPointDto>;
}
export interface Relative4DPointDto {
    altitudeInMeters?: number;
    cumulativeDistanceInMeters?: number;
    elapsedTimeInSeconds?: number;
}
export interface DistanceAtLocationDto {
    adepDistanceAlong?: DistanceAlong<string>;
    adesDistanceAlong?: DistanceAlong<string>;
    pointsDistanceAlong?: Array<DistanceAlong<IcaoPoint>>;
}
export interface DistanceAlong<T> {
    distanceInMeters?: number;
    location?: T;
}
export interface AirFiledDataDto {
    atsUnitId?: string;
    clearedLevel?: FlightLevel;
    estimatedTimeOver?: Date;
    startingPoint?: IcaoPoint;
}
export interface FplAerodrome {
    aerodromeLocation?: IcaoPoint;
    aerodromeName?: string;
    firstLastRoutePoint?: IcaoPoint;
    icaoId?: string;
}
export interface AerodromeOfDestinationsDto {
    ades?: FplAerodrome;
    alternate1?: string;
    alternate2?: string;
}
export interface AircraftIdentificationDto {
    aircraftAddress?: string;
    aircraftId?: string;
    registrationMark?: string;
    ssrInfo?: SSRInfo;
}
export enum EstimatedElapsedTimeAtLocationDto_EstimateType {
    FOR_POINT = 'FOR_POINT',
    FOR_FIR = 'FOR_FIR',
    FOR_LATITUDE_LONGITUDE = 'FOR_LATITUDE_LONGITUDE',
}
export interface EstimatedElapsedTimeAtLocationDto {
    elapsedTimeInMs?: number;
    firId?: string;
    latitude?: number;
    longtitude?: number;
    point?: IcaoPoint;
}
export enum FlightRules {
    IFR = 'IFR',
    IFR_THEN_VFR = 'IFR_THEN_VFR',
    VFR = 'VFR',
    VFR_THEN_IFR = 'VFR_THEN_IFR',
}
export interface EquipmentCapabilityAndStatusDto {
    adf?: EquipmentStatus;
    atcRtfSatcomInmarsat?: EquipmentStatus;
    atcRtfSatcomIridium?: EquipmentStatus;
    atcRtfSatcomMtsat?: EquipmentStatus;
    cpdlcAtnVdlMode2?: EquipmentStatus;
    cpdlcFans1AHFDL?: EquipmentStatus;
    cpdlcFans1ASatcomInmarsat?: EquipmentStatus;
    cpdlcFans1ASatcomIridium?: EquipmentStatus;
    cpdlcFans1ASatcomMtsat?: EquipmentStatus;
    cpdlcFans1AVdlMode2?: EquipmentStatus;
    cpdlcFans1AVdlModeA?: EquipmentStatus;
    dFisAcars?: EquipmentStatus;
    dme?: EquipmentStatus;
    fmcWprAcars?: EquipmentStatus;
    gbas?: EquipmentStatus;
    gnss?: EquipmentStatus;
    hfRtf?: EquipmentStatus;
    ils?: EquipmentStatus;
    inertialNavigation?: EquipmentStatus;
    khz833?: EquipmentStatus;
    loranC?: EquipmentStatus;
    lpv?: EquipmentStatus;
    mls?: EquipmentStatus;
    mnps?: EquipmentStatus;
    other?: EquipmentStatus;
    pbnApproved?: EquipmentStatus;
    pdcAcars?: EquipmentStatus;
    rcp1?: EquipmentStatus;
    rcp2?: EquipmentStatus;
    rcp3?: EquipmentStatus;
    rcp4?: EquipmentStatus;
    rcp5?: EquipmentStatus;
    rcp6?: EquipmentStatus;
    rcp7?: EquipmentStatus;
    rcp8?: EquipmentStatus;
    rcp9?: EquipmentStatus;
    rvsm?: EquipmentStatus;
    standard?: EquipmentStatus;
    tacan?: EquipmentStatus;
    uhfRtf?: EquipmentStatus;
    vhfRtf?: EquipmentStatus;
    vor?: EquipmentStatus;
}
export interface SurveillanceEquipmentDto {
    adsb1900Out?: EquipmentStatus;
    adsb1900OutIn?: EquipmentStatus;
    adsbOutInUAT?: EquipmentStatus;
    adsbOutInVDL4?: EquipmentStatus;
    adsbOutUAT?: EquipmentStatus;
    adsbOutVDL4?: EquipmentStatus;
    adscAtn?: EquipmentStatus;
    adscFans?: EquipmentStatus;
    modeA?: EquipmentStatus;
    modeAAndC?: EquipmentStatus;
    modeS?: EquipmentStatus;
    modeSCapabilities?: ModeSCapabilitiesDto;
}
export interface OtherInformationDto {
    communicationEquipment?: string;
    datalinkCapabilities?: string;
    nameOfOperator?: string;
    navigationEquipment?: string;
    otherRemarks?: Array<string>;
    otherSurveillanceEquipments?: string;
    performanceBasedNavigationCodes?: Array<PerformanceBasedNavigationCode>;
    performanceCategory?: AircraftPerformanceCategory;
    reasonForSpecialHandling?: SpecialHandlingIndicatorsDto;
    reclearanceInFlight?: ReclearanceInFlightDto;
    replacementFlightPlanIndicator?: number;
    runwayVisualRange?: number;
    selCalCode?: string;
}
export interface SupplementaryInformationDto {
    aircraftColourAndMarkings?: string;
    dinghies?: DinghiesDto;
    frequencies?: Array<FrequencyOnAircraft>;
    fuelEnduranceInMin?: number;
    lifeJacketEquipment?: Array<LifeJacketEquipment>;
    numberOfPersons?: number;
    otherSurvivalEquipment?: string;
    pilotInCommand?: string;
    survivalEquipment?: Array<SurvivalEquipment>;
}
export interface FlightPlanOriginatorDto {
    address?: string;
    otherInformation?: string;
    phone?: string;
}
export enum FrequencyOnAircraft {
    ELT = 'ELT',
    UHF = 'UHF',
    VHF = 'VHF',
}
export enum SurvivalEquipment {
    DESERT = 'DESERT',
    JUNGLE = 'JUNGLE',
    MARITIME = 'MARITIME',
    POLAR = 'POLAR',
}
export enum LifeJacketEquipment {
    FLUORESCEIN = 'FLUORESCEIN',
    LIGHTS = 'LIGHTS',
    UHF = 'UHF',
    VHF = 'VHF',
}
export interface DinghiesDto {
    areCovered?: boolean;
    colour?: string;
    numberOfDinghies?: number;
    totalCapacity?: number;
}
export interface SpecialHandlingIndicatorsDto {
    eurStsIndicators?: Array<EURSTSIndicator>;
    icaoStsIndicators?: Array<ICAOSTSIndicator>;
}
export enum AircraftPerformanceCategory {
    CAT_A = 'CAT_A',
    CAT_B = 'CAT_B',
    CAT_C = 'CAT_C',
    CAT_D = 'CAT_D',
    CAT_E = 'CAT_E',
    CAT_H = 'CAT_H',
}
export enum PerformanceBasedNavigationCode {
    BASIC_RNP_1_ALL = 'BASIC_RNP_1_ALL',
    BASIC_RNP_1_DME_DME = 'BASIC_RNP_1_DME_DME',
    BASIC_RNP_1_DME_DME_IRU = 'BASIC_RNP_1_DME_DME_IRU',
    BASIC_RNP_1_GNSS = 'BASIC_RNP_1_GNSS',
    RNAV_10 = 'RNAV_10',
    RNAV_1_ALL = 'RNAV_1_ALL',
    RNAV_1_DME_DME = 'RNAV_1_DME_DME',
    RNAV_1_DME_DME_IRU = 'RNAV_1_DME_DME_IRU',
    RNAV_1_GNSS = 'RNAV_1_GNSS',
    RNAV_2_ALL = 'RNAV_2_ALL',
    RNAV_2_DME_DME = 'RNAV_2_DME_DME',
    RNAV_2_DME_DME_IRU = 'RNAV_2_DME_DME_IRU',
    RNAV_2_GNSS = 'RNAV_2_GNSS',
    RNAV_5_ALL = 'RNAV_5_ALL',
    RNAV_5_DME_DME = 'RNAV_5_DME_DME',
    RNAV_5_GNSS = 'RNAV_5_GNSS',
    RNAV_5_INS_OR_IRS = 'RNAV_5_INS_OR_IRS',
    RNAV_5_LORAN_C = 'RNAV_5_LORAN_C',
    RNAV_5_VOR_DME = 'RNAV_5_VOR_DME',
    RNP_4 = 'RNP_4',
    RNP_APCH = 'RNP_APCH',
    RNP_APCH_BARO_VNAV = 'RNP_APCH_BARO_VNAV',
    RNP_AR_APCH_NO_RF = 'RNP_AR_APCH_NO_RF',
    RNP_AR_APCH_RF = 'RNP_AR_APCH_RF',
}
export interface ReclearanceInFlightDto {
    aerodrome?: string;
    route?: string;
}
export enum ICAOSTSIndicator {
    ALTRV = 'ALTRV',
    ATFMX = 'ATFMX',
    FFR = 'FFR',
    FLTCK = 'FLTCK',
    HAZMAT = 'HAZMAT',
    HEAD = 'HEAD',
    HOSP = 'HOSP',
    HUM = 'HUM',
    MARSA = 'MARSA',
    MEDEVAC = 'MEDEVAC',
    NONRVSM = 'NONRVSM',
    SAR = 'SAR',
    STATE = 'STATE',
}
export enum EURSTSIndicator {
    CPDLCX = 'CPDLCX',
    EXM833 = 'EXM833',
    PROTECTED = 'PROTECTED',
    RNAVINOP = 'RNAVINOP',
    RNAVX = 'RNAVX',
    OAT = 'OAT',
}
export enum EquipmentStatus {
    EQUIPPED = 'EQUIPPED',
    NOT_EQUIPPED = 'NOT_EQUIPPED',
}
export interface ModeSCapabilitiesDto {
    aircraftId?: EquipmentStatus;
    enhancedSurveillance?: EquipmentStatus;
    extendedSquitterADSB?: EquipmentStatus;
    pressureAltitude?: EquipmentStatus;
}
export enum SSRInfo_SSRMode {
    A = 'A',
}
export interface SSRInfo {
    code?: string;
    mode?: SSRInfo_SSRMode;
}
export interface FilingReplyDto {
    clazz?: string;
    filingStatus?: FilingStatus;
    queuedFiling?: FilingResultQueuedDto;
    rejectedFiling?: FilingResultRejectedDto;
    vaildFiling?: FilingResultValidDto;
}
export const FILING_REPLY_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.flightplan.FilingReplyDto';
export enum FilingStatus {
    INVALID_QUEUED_FOR_CORRECTION = 'INVALID_QUEUED_FOR_CORRECTION',
    INVALID_REJECTED = 'INVALID_REJECTED',
    VALID = 'VALID',
}
export interface FilingResultValidDto {
    cfmuChange?: boolean;
    comments?: Array<string>;
    ifpIndicators?: Array<IFPIndicator>;
    ifplId?: string;
}
export interface FilingResultQueuedDto {
    filingId?: string;
}
export interface FilingResultRejectedDto {
    ifpsErrors?: Array<IfpsError>;
}
export enum IFPIndicator {
    AIRCRAFT_TYPE = 'AIRCRAFT_TYPE',
    EOBDT = 'EOBDT',
    ERREQPT = 'ERREQPT',
    ERRRTECOORD = 'ERRRTECOORD',
    FLIGHT_LEVEL = 'FLIGHT_LEVEL',
    IFPSROUTEMOD = 'IFPSROUTEMOD',
    MODE_S = 'MODE_S',
    NON_833 = 'NON_833',
    NON_RVSM = 'NON_RVSM',
    ROUTE = 'ROUTE',
    ROUTE_RAD = 'ROUTE_RAD',
    ROUTE_WE = 'ROUTE_WE',
    RVSM_VIOLATION = 'RVSM_VIOLATION',
    UNKNOWN_833 = 'UNKNOWN_833',
    UNKNOWN_RVSM = 'UNKNOWN_RVSM',
}
export interface NetworkAddressDto {
    address?: string;
    network?: NetworkType;
}
export enum NetworkType {
    AFTN = 'AFTN',
    SITA = 'SITA',
    OTHER = 'OTHER',
}
export enum AllowedIfpsErrorViolations {
    NONE = 'NONE',
    RAD_ONLY = 'RAD_ONLY',
    ALL = 'ALL',
}
export interface EvaluateFlowImpactReplyDto {
    extraOriginalFlightData?: FlightDto;
    ifpsErrors?: Array<IfpsError>;
    originalRoute?: RouteInfoDto;
}
export interface FilingRequestDto {
    additionalAddresses?: Array<string>;
}
export enum FilingRule {
    FILING_ALLOWED_BY_AO_CFMU = 'FILING_ALLOWED_BY_AO_CFMU',
    NOT_AUTHORISED = 'NOT_AUTHORISED',
    OPERATOR_MUST_REFILE = 'OPERATOR_MUST_REFILE',
}
export interface FilingStatusRequestDto {
    filingId?: string;
}
export interface FlightArrivalRequestDto extends FilingRequestDto {
    actualTimeOfArrival?: Date;
    aerodromeOfArrival?: FplAerodrome;
    ifplId?: string;
}
export interface FlightDepartureRequestDto extends FilingRequestDto {
    actualTimeOfDeparture?: Date;
    ifplId?: string;
}
export interface FlightPlanCancellationRequestDto extends FilingRequestDto {
    ifplId?: string;
}
export interface RoutingAssistanceRequestDto {
    adepFreezePoint?: string;
    adesFreezePoint?: string;
    extraOriginalFlightFields?: Array<FlightFieldType>;
    flightPlan?: FlightPlanInputDto;
    forExistingFlight?: FlightKeys;
    ifpsErrorsOff?: AllowedIfpsErrorViolations;
    nbRoutes?: number;
    sourcesAndConstraints?: ReroutingSourcesAndConstraintsDto;
}
export interface FlightPlanDelayRequestDto extends FilingRequestDto {
    ifplId?: string;
    newEobt?: Date;
}
export interface FlightPlanReplyDto extends FilingReplyDto {
    flightPlan?: StructuredFlightPlanDto;
}
export const FLIGHT_PLAN_REPLY_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.flightplan.FlightPlanReplyDto';
export interface FlightPlanUpdateRequestDto extends FilingRequestDto {
    flightPlan?: StructuredFlightPlanDto;
    ifplId?: string;
}
export interface FlightPlanValidationReplyDto {
    fixm?: FlightTypeDto;
    ifpsErrors?: Array<IfpsError>;
}
export interface FlightPlanCreationRequestDto extends FilingRequestDto {
    flightPlan?: FlightPlanInputDto;
}
export interface ReroutingApplyRequestDto {
    appliedFlightFields?: Array<FlightFieldType>;
    applyKind?: ReroutingAssistanceApplyKind;
    dataset?: DatasetDto;
    filedFrom?: NetworkAddressDto;
    flightPlan?: FlightPlanInputDto;
    forExistingFlight?: FlightKeys;
    icaoRoute?: string;
    maxDelayInMin?: number;
    routeId?: ReroutingRouteIdDto;
    waitUntilApplied?: boolean;
}
export enum ReroutingProposalStatus {
    ALREADY_PROPOSAL = 'ALREADY_PROPOSAL',
    BAD_DELAY = 'BAD_DELAY',
    CONSTRAINT_VIOLATED = 'CONSTRAINT_VIOLATED',
    FLIGHT_ACTIVATED = 'FLIGHT_ACTIVATED',
    NOT_AUTHORIZED = 'NOT_AUTHORIZED',
    NOT_AVAILABLE = 'NOT_AVAILABLE',
    NOT_IFPS_COMPLIANT = 'NOT_IFPS_COMPLIANT',
    OBT_VALIDITY = 'OBT_VALIDITY',
    OK = 'OK',
    OVERLOAD = 'OVERLOAD',
    SUSPENDED = 'SUSPENDED',
}
export interface RoutingAssistanceReplyDto {
    ifpsErrors?: Array<IfpsError>;
    result?: RoutingAssistanceDataResultDto;
}
export enum ReroutingAssistanceApplyKind {
    AO_REFILE = 'AO_REFILE',
    CREATE_PROPOSAL_FLIGHT_ONLY = 'CREATE_PROPOSAL_FLIGHT_ONLY',
    NM_REFILES = 'NM_REFILES',
}
export interface ReroutingProposalKey {
    icaoRoute?: string;
    routeId?: ReroutingRouteIdDto;
}
export interface ReroutingApplyReplyDto_Result {
    aircraftType?: string;
    appliedRoute?: RouteInfoDto;
    arcId?: string;
    etot?: Date;
    failureDetails?: string;
    status?: ReroutingProposalStatus;
    textualFpl?: string;
}
export interface EvaluateFlowImpactRequestDto {
    extraOriginalFlightFields?: Array<FlightFieldType>;
    flightPlan?: FlightPlanInputDto;
    forExistingFlight?: FlightKeys;
}
export interface FlightPlanInputDto {
    fixmFlight?: FlightTypeDto;
    structured?: StructuredFlightPlanDto;
    textual?: string;
}
export interface FlightPlanValidationRequestDto {
    flightPlan?: FlightPlanInputDto;
}
export interface ReroutingApplyReplyDto {
    appliedFlight?: FlightDto;
    ifpsErrors?: Array<IfpsError>;
    result?: ReroutingApplyReplyDto_Result;
}
export interface RegulationDto extends RegulationOrMcdmOnlyDto {
    regulationState?: RegulationState;
}
export const REGULATION_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.measure.regulation.RegulationDto';
export interface RegulationOrMcdmOnlyDto extends MeasureDto {
    autoLink?: boolean;
    calculationType?: CountType;
    delayConfirmationThresholdInMs?: number;
    delayTvSetId?: string;
    initialConstraints?: Array<RegInitialConstraint>;
    linkedRegulations?: Array<string>;
    location?: TrafficVolumeLocationDto;
    noDelayWindowInMs?: number;
    occupancyConstraints?: Array<RegulationOccupancyConstraintDto>;
    occupancyDurationInMs?: number;
    protectedLocation?: RefLocation;
    reason?: RegulationReasonType;
    remark?: string;
    supplementaryConstraints?: Array<RegSupplementaryConstraint>;
    updateCapacityRequired?: boolean;
    updateTvActivationRequired?: boolean;
}
export const REGULATION_OR_MCDM_ONLY_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.regulation.RegulationOrMcdmOnlyDto';
export enum RegulationState {
    APPLYING = 'APPLYING',
    APPLIED = 'APPLIED',
    CANCELLED = 'CANCELLED',
    CANCELLING = 'CANCELLING',
    TERMINATED = 'TERMINATED',
}
export enum RegulationFieldType {
    APPLICABILITY = 'APPLICABILITY',
    AUTOLINK = 'AUTOLINK',
    CALCULATION_TYPE = 'CALCULATION_TYPE',
    CREATED_BY_FMP = 'CREATED_BY_FMP',
    DATA_ID = 'DATA_ID',
    DELAY_CONFIRMATION_THRESHOLD = 'DELAY_CONFIRMATION_THRESHOLD',
    DELAY_TVSET = 'DELAY_TVSET',
    EXTERNALLY_EDITABLE = 'EXTERNALLY_EDITABLE',
    INITIAL_CONSTRAINTS = 'INITIAL_CONSTRAINTS',
    LAST_UPDATE = 'LAST_UPDATE',
    LINKED_REGULATIONS = 'LINKED_REGULATIONS',
    LOCATION = 'LOCATION',
    MCDM_REQUIRED = 'MCDM_REQUIRED',
    MEASURE_CHERRY_PICKED = 'MEASURE_CHERRY_PICKED',
    NO_DELAY_WINDOW = 'NO_DELAY_WINDOW',
    OCCUPANCY_CONSTRAINTS = 'OCCUPANCY_CONSTRAINTS',
    OCCUPANCY_DURATION = 'OCCUPANCY_DURATION',
    PROTECTED_LOCATION = 'PROTECTED_LOCATION',
    REASON = 'REASON',
    REGULATION_STATE = 'REGULATION_STATE',
    REMARK = 'REMARK',
    SCENARIO_REFERENCE = 'SCENARIO_REFERENCE',
    SOURCE_HOTSPOT = 'SOURCE_HOTSPOT',
    SUBTYPE = 'SUBTYPE',
    SUPPLEMENTARY_CONSTRAINTS = 'SUPPLEMENTARY_CONSTRAINTS',
    UPDATE_CAPACITY_REQUIRED = 'UPDATE_CAPACITY_REQUIRED',
    UPDATE_TV_ACTIVATIONS_REQUIRED = 'UPDATE_TV_ACTIVATIONS_REQUIRED',
}
export enum RegulationReasonType {
    ACCIDENT_INCIDENT = 'ACCIDENT_INCIDENT',
    AERODROME_CAPACITY = 'AERODROME_CAPACITY',
    AERODROME_SERVICES = 'AERODROME_SERVICES',
    AIRSPACE_MANAGEMENT = 'AIRSPACE_MANAGEMENT',
    ATC_CAPACITY = 'ATC_CAPACITY',
    ATC_EQUIPMENT = 'ATC_EQUIPMENT',
    ATC_INDUSTRIAL_ACTION = 'ATC_INDUSTRIAL_ACTION',
    ATC_ROUTINGS = 'ATC_ROUTINGS',
    ATC_STAFFING = 'ATC_STAFFING',
    ENVIRONMENTAL_ISSUES = 'ENVIRONMENTAL_ISSUES',
    NON_ATC_INDUSTRIAL_ACTION = 'NON_ATC_INDUSTRIAL_ACTION',
    OTHERS = 'OTHERS',
    SPECIAL_EVENT = 'SPECIAL_EVENT',
    WEATHER = 'WEATHER',
}
export interface RegInitialConstraint {
    equipmentRate?: number;
    exceptionalConstraint?: RegExceptionalConstraint;
    normalRate?: number;
    pendingRate?: number;
    timePeriod?: TimePeriod;
}
export interface RegSupplementaryConstraint {
    supplementaryRate?: number;
    timePeriod?: TimePeriod;
}
export interface RegulationOccupancyConstraintDto {
    occupancyRate?: number;
    peakCapacity?: number;
    pendingCapacityPercentage?: number;
    timePeriod?: TimePeriod;
}
export interface RegulationSubPeriod {
    equipmentRate?: number;
    normalRate?: number;
    pendingRate?: number;
    period?: TimePeriod;
}
export interface RegExceptionalConstraint {
    fcmMandatory?: boolean;
    rvr?: number;
    shift?: boolean;
}
export interface FlightRegLocation {
    refLocation?: RefLocation;
    regulationId?: string;
    toConfirm?: boolean;
}
export interface RegulationCauseDto {
    iataDelayCode?: number;
    locationCategory?: RegulationLocationCategory;
    reason?: RegulationReasonType;
}
export enum RegulationLocationCategory {
    ARRIVAL = 'ARRIVAL',
    DEPARTURE = 'DEPARTURE',
    ENROUTE = 'ENROUTE',
}
export enum ForceEntryType {
    TO = 'TO',
    TOT = 'TOT',
}
export interface RegulationOrMcdmOnlyListRequestDto extends MeasureListRequestDto {
    reasons?: Array<RegulationReasonType>;
    regulIds?: Array<string>;
}
export const REGULATION_OR_MCDM_ONLY_LIST_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.regulation.RegulationOrMcdmOnlyListRequestDto';
export enum EquipmentRateType {
    MLS = 'MLS',
    None = 'None',
}
export interface ForceEntryTimeReplyDto {
    appliedEntryTime?: Date;
    flightId?: FlightId;
    forceEntryType?: ForceEntryType;
    regulationId?: string;
}
export interface ForceEntryTimeRequestDto {
    createProposal?: boolean;
    dataset?: DatasetDto;
    flightId?: FlightId;
    forceEntryTime?: Date;
    forceEntryType?: ForceEntryType;
    regulationId?: string;
}
export interface RegulationCancelRequestDto {
    computeNetworkImpactAssessment?: boolean;
    dataId?: string;
    dataset?: DatasetDto;
    day?: Date;
    regulationId?: string;
}
export interface RegulationCreateRequestDto {
    computeNetworkImpactAssessment?: boolean;
    dataset?: DatasetDto;
    regulation?: RegulationDto;
}
export interface RegulationList extends MeasureList<RegulationDto> {}
export interface RegulationListRequestDto extends RegulationOrMcdmOnlyListRequestDto {
    fields?: Array<RegulationFieldType>;
    states?: Array<RegulationState>;
}
export const REGULATION_LIST_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.regulation.RegulationListRequestDto';
export interface RegulationRequestDto {
    dataset?: DatasetDto;
    day?: Date;
    fields?: Array<RegulationFieldType>;
    regulId?: string;
}
export interface RegulationUpdateRequestDto {
    computeNetworkImpactAssessment?: boolean;
    dataset?: DatasetDto;
    regulation?: RegulationDto;
}
export enum BlockedState {
    NONE = 'NONE',
    SIP_BOOKING = 'SIP_BOOKING',
    WHAT_IF_BOOKING = 'WHAT_IF_BOOKING',
    SUSPENSION_BOOKING = 'SUSPENSION_BOOKING',
    USER_BOOKING = 'USER_BOOKING',
    MANUAL_BOOKING = 'MANUAL_BOOKING',
    STAM_BOOKING = 'STAM_BOOKING',
    DELAY_CONF_SUSPENSION_BOOKING = 'DELAY_CONF_SUSPENSION_BOOKING',
    RVR_SUSPENSION_BOOKING = 'RVR_SUSPENSION_BOOKING',
}
export enum ExemptionReason {
    EMERGENCY = 'EMERGENCY',
    SEARCH_AND_RESCUE = 'SEARCH_AND_RESCUE',
    HEAD_STATE = 'HEAD_STATE',
    ATFM_EXEMPTION_APPROVED = 'ATFM_EXEMPTION_APPROVED',
    MEDICAL_EVACUATION = 'MEDICAL_EVACUATION',
    FIRE_FIGHTING = 'FIRE_FIGHTING',
    LONG_HAUL = 'LONG_HAUL',
    MANUAL_EXEMPTION = 'MANUAL_EXEMPTION',
    OTHER = 'OTHER',
}
export enum SlotForcedType {
    NOT_FORCED = 'NOT_FORCED',
    FORCED_BY_TOWER = 'FORCED_BY_TOWER',
    FORCED_BY_FMD = 'FORCED_BY_FMD',
    FORCED_BY_CHAMAN = 'FORCED_BY_CHAMAN',
    FORCED_BY_STAM = 'FORCED_BY_STAM',
    FORCED_BY_FMD_FOR_SLOT_EXTENSION = 'FORCED_BY_FMD_FOR_SLOT_EXTENSION',
    FORCED_BY_ATC_DPI_FOR_SLOT_EXTENSION = 'FORCED_BY_ATC_DPI_FOR_SLOT_EXTENSION',
}
export enum ReservationStatus {
    EXEMPTED = 'EXEMPTED',
    FORCED = 'FORCED',
    TAKEN_OFF = 'TAKEN_OFF',
    SLOT_ISSUED = 'SLOT_ISSUED',
    OTHER = 'OTHER',
}
export interface RetrieveSlotListsRequestDto {
    dataset?: DatasetDto;
    regulationIds?: Array<MeasureId>;
}
export enum SlotStatus {
    AVAILABLE = 'AVAILABLE',
    PRE_ALLOCATED = 'PRE_ALLOCATED',
    ALLOCATED = 'ALLOCATED',
    BLOCKED = 'BLOCKED',
}
export enum SlotType {
    NORMAL = 'NORMAL',
    OVERLOAD = 'OVERLOAD',
    PENDING = 'PENDING',
}
export enum SlotUpdateKind {
    DELETE_SLOT = 'DELETE_SLOT',
    BLOCK_SLOT = 'BLOCK_SLOT',
    UNBLOCK_SLOT = 'UNBLOCK_SLOT',
}
export interface UpdateSlotRequestDto {
    dataset?: DatasetDto;
    regulationId?: string;
    slotSequenceIndex?: number;
    slotTime?: Date;
    updateKind?: SlotUpdateKind;
}
export interface RegulatedFlightDto extends FlightDto {
    actualTimeOver?: Date;
    calculatedTimeOver?: Date;
    estimatedTimeOver?: Date;
    exempted?: boolean;
    exemptionReason?: ExemptionReason;
    famStatus?: FamStatus;
    forced?: SlotForcedType;
    mostPenalising?: boolean;
    scheduledTimeOver?: Date;
}
export const REGULATED_FLIGHT_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.regulation.slots.RegulatedFlightDto';
export interface Slot {
    blockedState?: BlockedState;
    bookedAircraftId?: string;
    outsideSlotWindow?: boolean;
    periodEnd?: boolean;
    referenceTime?: Date;
    regulatedFlight?: RegulatedFlightDto;
    slotSequenceIndex?: number;
    status?: SlotStatus;
    type?: SlotType;
}
export interface SlotList {
    measureId?: MeasureId;
    slotSequences?: Array<SlotSequence>;
}
export interface SlotSequence {
    regulatedPeriod?: TimePeriod;
    slotListSequenceIndex?: number;
    slots?: Array<Slot>;
}
export interface MeasureDto {
    clazz?: string;
    applicability?: TimePeriod;
    cherryPicking?: boolean;
    createdByFmp?: boolean;
    dataId?: string;
    externallyEditable?: boolean;
    lastUpdate?: LifeCycleEventDto;
    mcdmInfo?: McdmMeasureTopic;
    mcdmRequired?: boolean;
    measureId?: MeasureId;
    scenarioReference?: MeasureFromScenarioDto;
    sourceHotspot?: HotspotId;
    subType?: MeasureSubType;
}
export const MEASURE_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.measure.MeasureDto';
export enum MeasureEventType {
    DMR = 'DMR',
    APR = 'APR',
    CNR = 'CNR',
    TRG = 'TRG',
}
export interface TrafficVolumeLocationDto extends LocationDto {
    description?: string;
    flightLevels?: FlightLevelBand;
    id?: string;
    refLocation?: TvRefLocation;
    tvSetIds?: Array<string>;
}
export const TRAFFIC_VOLUME_LOCATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.location.TrafficVolumeLocationDto';
export interface LocationDto {
    clazz?: string;
}
export const LOCATION_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.measure.location.LocationDto';
export interface FlightAtfcmMeasureLoc {
    clazz?: string;
    hotspotId?: HotspotId;
    mcdmState?: McdmState;
    measureId?: MeasureId;
    measureSubType?: MeasureSubType;
    tvLocation?: TrafficVolumeLocationInfoDto;
}
export const FLIGHT_ATFCM_MEASURE_LOC_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.location.FlightAtfcmMeasureLoc';
export interface AerodromeLocationDto extends LocationDto {}
export const AERODROME_LOCATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.location.AerodromeLocationDto';
export interface AirspaceLocationDto extends LocationDto {}
export const AIRSPACE_LOCATION_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.measure.location.AirspaceLocationDto';
export interface AllFlightsLocationDto extends LocationDto {}
export const ALL_FLIGHTS_LOCATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.location.AllFlightsLocationDto';
export interface AoLocationDto extends LocationDto {}
export const AO_LOCATION_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.measure.location.AoLocationDto';
export interface CherryPickedLocationDto extends LocationDto {}
export const CHERRY_PICKED_LOCATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.location.CherryPickedLocationDto';
export interface DelayLocationDto extends LocationDto {}
export const DELAY_LOCATION_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.measure.location.DelayLocationDto';
export interface FlightAtfcmMcdmOnlyLoc extends FlightAtfcmMeasureLoc {}
export const FLIGHT_ATFCM_MCDM_ONLY_LOC_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.location.FlightAtfcmMcdmOnlyLoc';
export interface FlightAtfcmRegulationLoc extends FlightAtfcmMeasureLoc {
    toConfirm?: boolean;
}
export const FLIGHT_ATFCM_REGULATION_LOC_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.location.FlightAtfcmRegulationLoc';
export interface FlightAtfcmReroutingLoc extends FlightAtfcmMeasureLoc {
    aoAcknowledgedRRP?: boolean;
    applyKind?: ReroutingApplyKind;
    groupIndicator?: GroupReroutingIndicator;
    originator?: string;
    originatorLatestReroutingProposalFlight?: boolean;
    requestText?: string;
    reroutingPurpose?: ReroutingPurpose;
}
export const FLIGHT_ATFCM_REROUTING_LOC_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.location.FlightAtfcmReroutingLoc';
export enum KindOfRestriction {
    AC = 'AC',
    CF = 'CF',
    DCT = 'DCT',
    RAD = 'RAD',
    SC = 'SC',
}
export interface PointLocationDto extends LocationDto {}
export const POINT_LOCATION_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.measure.location.PointLocationDto';
export interface RestrictionLocationDto extends LocationDto {
    kind?: KindOfRestriction;
}
export const RESTRICTION_LOCATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.location.RestrictionLocationDto';
export interface SegmentLocationDto extends LocationDto {}
export const SEGMENT_LOCATION_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.measure.location.SegmentLocationDto';
export interface SetOfAerodromesLocationDto extends LocationDto {}
export const SET_OF_AERODROMES_LOCATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.location.SetOfAerodromesLocationDto';
export interface MeasureId {
    id?: string;
    type?: MeasureType;
}
export enum MeasureType {
    REROUTING = 'REROUTING',
    REGULATION = 'REGULATION',
    MCDM_ONLY = 'MCDM_ONLY',
}
export enum MeasureSubType {
    AIRBORNE_HORIZONTAL_REROUTING = 'AIRBORNE_HORIZONTAL_REROUTING',
    AIRBORNE_LEVEL_CAP = 'AIRBORNE_LEVEL_CAP',
    GROUND_DELAY = 'GROUND_DELAY',
    GROUND_HORIZONTAL_REROUTING = 'GROUND_HORIZONTAL_REROUTING',
    GROUND_LEVEL_CAP = 'GROUND_LEVEL_CAP',
    MILES_MINUTES_IN_TRAIL = 'MILES_MINUTES_IN_TRAIL',
    MINIMUM_DEPARTURE_INTERVAL = 'MINIMUM_DEPARTURE_INTERVAL',
    OTHER_KIND_OF_STAM_MEASURE = 'OTHER_KIND_OF_STAM_MEASURE',
    TAKE_OFF_NOT_AFTER = 'TAKE_OFF_NOT_AFTER',
    TAKE_OFF_NOT_BEFORE = 'TAKE_OFF_NOT_BEFORE',
    TERMINAL_PROCEDURE_CHANGE = 'TERMINAL_PROCEDURE_CHANGE',
}
export interface MeasureFromScenarioDto {
    measureId?: MeasureId;
    scenarioId?: string;
}
export interface McdmMeasureTopic extends McdmStatefulTopic {
    deadlines?: McdmDeadlines;
    flightTopics?: Array<McdmFlightTopic>;
    predefinedUsersForFlightCoordination?: Array<McdmUserRole>;
    proposalFeedback?: string;
    proposalNote?: string;
    remark?: string;
    userCategories?: Array<McdmRoleUserCategory>;
}
export const MCDM_MEASURE_TOPIC_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.measure.mcdm.McdmMeasureTopic';
export interface McdmStatefulTopic extends McdmTopic {
    initatorId?: string;
    initiatorIsImplementer?: boolean;
    measureId?: MeasureId;
    state?: McdmState;
    userRoleAndApprovalStates?: Array<McdmUserRoleAndApprovalState>;
}
export const MCDM_STATEFUL_TOPIC_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.measure.mcdm.McdmStatefulTopic';
export interface McdmTopic {
    clazz?: string;
    dataId?: string;
    topicId?: string;
}
export const MCDM_TOPIC_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.measure.mcdm.McdmTopic';
export interface McdmFlightTopic extends McdmStatefulTopic {
    flightId?: FlightId;
    ticket?: EHelpDeskTicketChoiceDto;
}
export const MCDM_FLIGHT_TOPIC_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.measure.mcdm.McdmFlightTopic';
export interface McdmDeadlines {
    timeToCoordinate?: Date;
    timeToImplement?: Date;
    timeToStartImplement?: Date;
}
export interface McdmRoleUserCategory {
    category?: McdmUserCategory;
    coordinationLevel?: McdmCoordinationLevel;
    role?: McdmRole;
}
export interface McdmUserRole {
    role?: McdmRole;
    userId?: string;
}
export enum McdmUserCategory {
    IMPACTED_FMP = 'IMPACTED_FMP',
    AIRCRAFT_OPERATOR = 'AIRCRAFT_OPERATOR',
    ALL_FMP = 'ALL_FMP',
    NMOC = 'NMOC',
    TOWER = 'TOWER',
}
export enum McdmRole {
    APPROVAL = 'APPROVAL',
    IMPLEMENTER = 'IMPLEMENTER',
    INFO = 'INFO',
    INITIATOR = 'INITIATOR',
    NOT_INVOLVED = 'NOT_INVOLVED',
    ROLE_INFO = 'ROLE_INFO',
}
export enum McdmCoordinationLevel {
    FLIGHT = 'FLIGHT',
    MEASURE = 'MEASURE',
}
export enum McdmState {
    DRAFT = 'DRAFT',
    PROPOSED = 'PROPOSED',
    COORDINATED = 'COORDINATED',
    IMPLEMENTING = 'IMPLEMENTING',
    IMPLEMENTED = 'IMPLEMENTED',
    FINISHED = 'FINISHED',
    ABANDONED = 'ABANDONED',
    INTERRUPTED = 'INTERRUPTED',
}
export interface McdmUserRoleAndApprovalState extends McdmUserRole {
    approvalState?: McdmApprovalState;
}
export enum McdmApprovalState {
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    ACKNOWLEDGED = 'ACKNOWLEDGED',
    UNKNOWN = 'UNKNOWN',
}
export interface FlightMcdmInfo {
    leastAdvancedMcdmMeasure?: MeasureId;
    leastAdvancedMcdmState?: McdmState;
    nrAssociatedMcdmOnlyMeaures?: number;
    nrAssociatedMcdmRegulations?: number;
    nrAssociatedMcdmReroutings?: number;
}
export enum McdmTopicFieldType {
    DEADLINES = 'DEADLINES',
    INITIATOR = 'INITIATOR',
    USER_CATEGORIES = 'USER_CATEGORIES',
    USER_ROLES_AND_APPROVAL_STATES = 'USER_ROLES_AND_APPROVAL_STATES',
    REMARK = 'REMARK',
    PREDEFINED_USERS_FOR_FLIGHT_COORDINATION = 'PREDEFINED_USERS_FOR_FLIGHT_COORDINATION',
    EHELPDESK_TOPIC = 'EHELPDESK_TOPIC',
}
export enum McdmMessageType {
    INCOMING = 'INCOMING',
    OUTGOING = 'OUTGOING',
    SYSTEM = 'SYSTEM',
}
export interface McdmStateUpdateRequestDto {
    dataId?: string;
    dataset?: DatasetDto;
    measureId?: MeasureId;
    newState?: McdmState;
}
export interface McdmTopicList {
    measures?: Array<McdmMeasureTopic>;
    standaloneFlights?: Array<McdmFlightTopic>;
}
export interface McdmTopicListRequestDto {
    activeOnly?: boolean;
    actors?: Array<string>;
    dataset?: DatasetDto;
    day?: Date;
    fields?: Array<McdmTopicFieldType>;
    measures?: Array<MeasureId>;
    topics?: Array<string>;
}
export interface UpdateMcdmTopicRequestDto {
    dataset?: DatasetDto;
    day?: Date;
    topic?: McdmTopic;
}
export interface GroupReroutingSummaryDto {
    deltaCost?: number;
    deltaDelayInMs?: number;
    indicator?: GroupReroutingIndicator;
    reroutingId?: string;
}
export enum ReroutingPurpose {
    AOLO_REROUTING = 'AOLO_REROUTING',
    ATC_ROUTING = 'ATC_ROUTING',
    ATFCM = 'ATFCM',
    CDR_OPPORTUNITY = 'CDR_OPPORTUNITY',
    FLIGHT_EFFICIENCY = 'FLIGHT_EFFICIENCY',
    STAM = 'STAM',
}
export enum GroupReroutingIndicator {
    EXECUTED = 'EXECUTED',
    INTERESTING = 'INTERESTING',
    NO_REROUTING = 'NO_REROUTING',
    OPPORTUNITY = 'OPPORTUNITY',
    UNINTERESTING = 'UNINTERESTING',
}
export interface ReroutingSourcesAndConstraintsDto {
    horizontalReroutingSourcesAndConstraints?: HorizontalReroutingSourcesAndConstraintsDto;
    reroutingConstraintSets?: Array<ReroutingConstraintSetDto>;
    reroutingManualConstraints?: ReroutingManualConstraintsDto;
    useVerticalOrSpeedReroutingSource?: boolean;
}
export interface HorizontalReroutingSourcesAndConstraintsDto {
    freezeOutsideZone?: boolean;
    freezeTP?: FreezeTerminalProcedureType;
    lengthLimit?: ReroutingLengthLimitDto;
    referenceRequestedFlightLevel?: ReferenceRequestedFlightLevel;
    useCityPairStatisticsSource?: boolean;
    useDctAsReference?: boolean;
    useFlightsCurrentlyInSystemSource?: boolean;
    useMixerSource?: boolean;
    usePathGeneratorSource?: boolean;
}
export interface ReroutingManualConstraintsDto {
    manualField15OrField15Portions?: Array<string>;
}
export interface ReroutingConstraintSetDto {
    constraints?: Array<ReroutingConstraintDto>;
}
export interface ReroutingConstraintDto {
    clazz?: string;
}
export const REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.reroute.ReroutingConstraintDto';
export enum FreezeTerminalProcedureType {
    FREEZE_SID_STAR = 'FREEZE_SID_STAR',
    FREEZE_SID_STAR_AND_CONNECTING_POINTS = 'FREEZE_SID_STAR_AND_CONNECTING_POINTS',
    NO = 'NO',
}
export enum ReferenceRequestedFlightLevel {
    ORIGINAL = 'ORIGINAL',
    HIGHEST = 'HIGHEST',
    LONGEST = 'LONGEST',
}
export interface ReroutingLengthLimitDto {
    fixedPart?: number;
    referenceLengthPercentage?: number;
}
export enum ReroutingFieldType {
    APPLICABILITY = 'APPLICABILITY',
    APPLY_KIND = 'APPLY_KIND',
    CONSTRAINTS = 'CONSTRAINTS',
    CREATED_BY_FMP = 'CREATED_BY_FMP',
    DATA_ID = 'DATA_ID',
    DISABLED_RESTRICTIONS = 'DISABLED_RESTRICTIONS',
    EXTERNALLY_EDITABLE = 'EXTERNALLY_EDITABLE',
    FLOW_ID = 'FLOW_ID',
    IGNORED_RESTRICTIONS = 'IGNORED_RESTRICTIONS',
    LAST_UPDATE = 'LAST_UPDATE',
    LOCATION = 'LOCATION',
    MCDM_REQUIRED = 'MCDM_REQUIRED',
    MEASURE_CHERRY_PICKED = 'MEASURE_CHERRY_PICKED',
    STATE = 'STATE',
    REMARK = 'REMARK',
    REROUTING_PURPOSE = 'REROUTING_PURPOSE',
    SCENARIO_REFERENCE = 'SCENARIO_REFERENCE',
    SOURCE_HOTSPOT = 'SOURCE_HOTSPOT',
    SUBTYPE = 'SUBTYPE',
}
export enum ReroutingApplyKind {
    EXECUTE = 'EXECUTE',
    FOR_INDICATION_WITHOUT_AUTOMATIC_PROPOSAL_FLIGHT = 'FOR_INDICATION_WITHOUT_AUTOMATIC_PROPOSAL_FLIGHT',
    FOR_INDICATION_WITH_AUTOMATIC_RRN = 'FOR_INDICATION_WITH_AUTOMATIC_RRN',
    FOR_INDICATION_WITH_AUTOMATIC_RRP = 'FOR_INDICATION_WITH_AUTOMATIC_RRP',
}
export enum AvoidAirspaceReroutingKind {
    HORIZONTAL = 'HORIZONTAL',
    VERTICAL = 'VERTICAL',
    HORIZONTAL_OR_VERTICAL = 'HORIZONTAL_OR_VERTICAL',
}
export interface AvoidViaAirspaceReroutingConstraintDto extends ReroutingConstraintDto {
    avoidKind?: AvoidAirspaceReroutingKind;
    location?: string;
    type?: AvoidViaReroutingType;
}
export const AVOID_VIA_AIRSPACE_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.reroute.AvoidViaAirspaceReroutingConstraintDto';
export enum AvoidViaReroutingType {
    AVOID = 'AVOID',
    VIA = 'VIA',
}
export interface AvoidViaHotspotReroutingConstraintDto extends ReroutingConstraintDto {
    avoidKind?: AvoidAirspaceReroutingKind;
    hotspotId?: HotspotId;
    type?: AvoidViaReroutingType;
}
export const AVOID_VIA_HOTSPOT_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.reroute.AvoidViaHotspotReroutingConstraintDto';
export interface AvoidViaPointReroutingConstraintDto extends ReroutingConstraintDto {
    location?: DbeOrPublishedPointId;
    type?: AvoidViaReroutingType;
}
export const AVOID_VIA_POINT_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.reroute.AvoidViaPointReroutingConstraintDto';
export interface AvoidViaRegulationReroutingConstraintDto extends ReroutingConstraintDto {
    avoidKind?: AvoidAirspaceReroutingKind;
    regulationId?: string;
    type?: AvoidViaReroutingType;
}
export const AVOID_VIA_REGULATION_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.reroute.AvoidViaRegulationReroutingConstraintDto';
export interface DeltaLevelReroutingConstraintDto extends ReroutingConstraintDto {
    deltaFlightLevel?: number;
    location?: DbeOrPublishedPointId;
}
export const DELTA_LEVEL_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.reroute.DeltaLevelReroutingConstraintDto';
export interface LevelAndSpeedReroutingConstraintDto extends ReroutingConstraintDto {
    airSpeed?: AirSpeed;
    flightLevel?: FlightLevel;
    fromPoint?: DbeOrPublishedPointId;
    untilPoint?: DbeOrPublishedPointId;
}
export const LEVEL_AND_SPEED_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.reroute.LevelAndSpeedReroutingConstraintDto';
export interface OtherReroutingConstraintDto extends ReroutingConstraintDto {}
export const OTHER_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.reroute.OtherReroutingConstraintDto';
export interface PreR22LevelAndSpeedReroutingConstraintDto extends ReroutingConstraintDto {
    airSpeed?: ValueOrDefault<AirSpeed>;
    flightLevel?: ValueOrDefault<FlightLevel>;
    location?: DbeOrPublishedPointId;
}
export const PRE_R22_LEVEL_AND_SPEED_REROUTING_CONSTRAINT_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.reroute.PreR22LevelAndSpeedReroutingConstraintDto';
export interface ReroutingCancelRequestDto {
    computeNetworkImpactAssessment?: boolean;
    dataId?: string;
    dataset?: DatasetDto;
    day?: Date;
    reroutingId?: string;
}
export interface ReroutingCreateRequestDto {
    computeNetworkImpactAssessment?: boolean;
    dataset?: DatasetDto;
    rerouting?: ReroutingDto;
}
export interface ReroutingDto extends MeasureDto {
    disabledRestrictions?: Array<string>;
    flowId?: string;
    ignoredRestrictions?: Array<string>;
    location?: LocationDto;
    remark?: string;
    reroutingApplyKind?: ReroutingApplyKind;
    reroutingPurpose?: ReroutingPurpose;
    reroutingState?: ReroutingMeasureState;
    sourcesAndConstraints?: ReroutingSourcesAndConstraintsDto;
}
export const REROUTING_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.measure.reroute.ReroutingDto';
export enum ReroutingMeasureState {
    ACTIVATING = 'ACTIVATING',
    APPLIED = 'APPLIED',
    CANCELLED = 'CANCELLED',
    CANCELLING = 'CANCELLING',
}
export interface ReroutingList extends MeasureList<ReroutingDto> {}
export interface ReroutingListRequestDto extends MeasureListRequestDto {
    fields?: Array<ReroutingFieldType>;
    reroutingIds?: Array<string>;
    states?: Array<ReroutingMeasureState>;
}
export const REROUTING_LIST_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.reroute.ReroutingListRequestDto';
export interface ReroutingUpdateRequestDto {
    computeNetworkImpactAssessment?: boolean;
    dataset?: DatasetDto;
    rerouting?: ReroutingDto;
}
export interface AllMeasureListRequestDto extends MeasureListRequestDto {
    activeOnly?: boolean;
    cherryPickingOnly?: boolean;
    createdByFmp?: boolean;
    externallyEditable?: boolean;
    mcdmOnlyFields?: Array<McdmOnlyFieldType>;
    mcdmRequired?: boolean;
    measureIds?: Array<string>;
    regulationFields?: Array<RegulationFieldType>;
    regulationProposalFields?: Array<RegulationProposalFieldType>;
    reroutingFields?: Array<ReroutingFieldType>;
}
export const ALL_MEASURE_LIST_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.AllMeasureListRequestDto';
export interface MeasureListRequestDto {
    clazz?: string;
    dataset?: DatasetDto;
    timePeriod?: TimePeriod;
    tvIds?: Array<string>;
    tvSetIds?: Array<string>;
}
export const MEASURE_LIST_REQUEST_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.measure.MeasureListRequestDto';
export enum McdmOnlyFieldType {
    APPLICABILITY = 'APPLICABILITY',
    AUTOLINK = 'AUTOLINK',
    CREATED_BY_FMP = 'CREATED_BY_FMP',
    DATA_ID = 'DATA_ID',
    DELAY_CONFIRMATION_THRESHOLD = 'DELAY_CONFIRMATION_THRESHOLD',
    DELAY_TVSET = 'DELAY_TVSET',
    EXTERNALLY_EDITABLE = 'EXTERNALLY_EDITABLE',
    INITIAL_CONSTRAINTS = 'INITIAL_CONSTRAINTS',
    LAST_UPDATE = 'LAST_UPDATE',
    LINKED_REGULATIONS = 'LINKED_REGULATIONS',
    LOCATION = 'LOCATION',
    MCDM_ONLY_STATE = 'MCDM_ONLY_STATE',
    MCDM_REQUIRED = 'MCDM_REQUIRED',
    MEASURE_CHERRY_PICKED = 'MEASURE_CHERRY_PICKED',
    NO_DELAY_WINDOW = 'NO_DELAY_WINDOW',
    PROTECTED_LOCATION = 'PROTECTED_LOCATION',
    REASON = 'REASON',
    REMARK = 'REMARK',
    SCENARIO_REFERENCE = 'SCENARIO_REFERENCE',
    SOURCE_HOTSPOT = 'SOURCE_HOTSPOT',
    SUBTYPE = 'SUBTYPE',
    SUPPLEMENTARY_CONSTRAINTS = 'SUPPLEMENTARY_CONSTRAINTS',
    UPDATE_CAPACITY_REQUIRED = 'UPDATE_CAPACITY_REQUIRED',
    UPDATE_TV_ACTIVATIONS_REQUIRED = 'UPDATE_TV_ACTIVATIONS_REQUIRED',
}
export interface McdmOnlyCancelRequestDto {
    dataId?: string;
    dataset?: DatasetDto;
    day?: Date;
    mcdmId?: string;
}
export interface McdmOnlyCreateRequestDto {
    dataset?: DatasetDto;
    mcdmOnly?: McdmOnlyDto;
}
export interface McdmOnlyDto extends RegulationOrMcdmOnlyDto {
    mcdmOnlyState?: RegulationState;
}
export const MCDM_ONLY_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.measure.mcdmOnly.McdmOnlyDto';
export interface McdmOnlyList extends MeasureList<McdmOnlyDto> {}
export interface McdmOnlyListRequestDto extends RegulationOrMcdmOnlyListRequestDto {
    fields?: Array<McdmOnlyFieldType>;
    states?: Array<RegulationState>;
}
export const MCDM_ONLY_LIST_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.mcdmOnly.McdmOnlyListRequestDto';
export interface McdmOnlyUpdateRequestDto {
    dataset?: DatasetDto;
    mcdmOnly?: McdmOnlyDto;
}
export enum RegulationProposalFieldType {
    ACTION = 'ACTION',
    APPLICABILITY = 'APPLICABILITY',
    APPROVAL_STATE = 'APPROVAL_STATE',
    AUTOLINK = 'AUTOLINK',
    CALCULATION_TYPE = 'CALCULATION_TYPE',
    CREATED_BY_FMP = 'CREATED_BY_FMP',
    DATA_ID = 'DATA_ID',
    DELAY_CONFIRMATION_THRESHOLD = 'DELAY_CONFIRMATION_THRESHOLD',
    DELAY_TVSET = 'DELAY_TVSET',
    EXTERNALLY_EDITABLE = 'EXTERNALLY_EDITABLE',
    INITIAL_CONSTRAINTS = 'INITIAL_CONSTRAINTS',
    LAST_UPDATE = 'LAST_UPDATE',
    LINKED_REGULATIONS = 'LINKED_REGULATIONS',
    LOCATION = 'LOCATION',
    MCDM_REQUIRED = 'MCDM_REQUIRED',
    MCDM_STATE = 'MCDM_STATE',
    MEASURE_CHERRY_PICKED = 'MEASURE_CHERRY_PICKED',
    NO_DELAY_WINDOW = 'NO_DELAY_WINDOW',
    OCCUPANCY_CONSTRAINTS = 'OCCUPANCY_CONSTRAINTS',
    OCCUPANCY_DURATION = 'OCCUPANCY_DURATION',
    PROTECTED_LOCATION = 'PROTECTED_LOCATION',
    REASON = 'REASON',
    REGULATION_STATE = 'REGULATION_STATE',
    REMARK = 'REMARK',
    SCENARIO_REFERENCE = 'SCENARIO_REFERENCE',
    SOURCE_HOTSPOT = 'SOURCE_HOTSPOT',
    SUBTYPE = 'SUBTYPE',
    SUPPLEMENTARY_CONSTRAINTS = 'SUPPLEMENTARY_CONSTRAINTS',
    UPDATE_CAPACITY_REQUIRED = 'UPDATE_CAPACITY_REQUIRED',
    UPDATE_TV_ACTIVATIONS_REQUIRED = 'UPDATE_TV_ACTIVATIONS_REQUIRED',
    PROPOSAL_FEEDBACK = 'PROPOSAL_FEEDBACK',
    PROPOSAL_NOTE = 'PROPOSAL_NOTE',
}
export enum RegulationProposalAcceptRejectDto {
    ACCEPT = 'ACCEPT',
    REJECT = 'REJECT',
}
export interface RegulationProposalAcceptRejectRequestDto {
    acceptReject?: RegulationProposalAcceptRejectDto;
    dataset?: DatasetDto;
    regulationProposal?: RegulationProposalDto;
}
export interface RegulationProposalDto extends RegulationOrMcdmOnlyDto {
    action?: RegulationProposalAction;
    approvalState?: McdmApprovalState;
    kind?: RegulationProposalKind;
    mcdmState?: McdmState;
    proposalFeedback?: string;
    proposalNote?: string;
    regulationState?: RegulationState;
}
export const REGULATION_PROPOSAL_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.regproposal.RegulationProposalDto';
export enum RegulationProposalKind {
    RegulationProposalWithProposalFlights = 'RegulationProposalWithProposalFlights',
    RegulationProposalWithoutProposalFlights = 'RegulationProposalWithoutProposalFlights',
}
export enum RegulationProposalAction {
    CANCELLATION = 'CANCELLATION',
    CREATION = 'CREATION',
    UPDATE = 'UPDATE',
}
export interface RegulationProposalFilingRequestDto {
    dataset?: DatasetDto;
    normalRegulationDataId?: string;
    regulation?: RegulationProposalDto;
}
export interface RegulationProposalList extends MeasureList<RegulationProposalDto> {}
export interface RegulationProposalListRequestDto extends RegulationOrMcdmOnlyListRequestDto {
    fields?: Array<RegulationProposalFieldType>;
    states?: Array<McdmApprovalState>;
}
export const REGULATION_PROPOSAL_LIST_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.regproposal.RegulationProposalListRequestDto';
export interface RegulationProposalRevocationRequestDto {
    dataId?: string;
    dataset?: DatasetDto;
    day?: Date;
    forceDelete?: boolean;
    regulId?: string;
    remark?: string;
}
export enum RegulationProposalState {
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
    WAITING = 'WAITING',
}
export interface RegulationProposalUpdateRequestDto {
    dataset?: DatasetDto;
    regulation?: RegulationProposalDto;
}
export interface MeasureAndTopic {
    measure?: MeasureDto;
    relatedTvs?: Array<string>;
    topic?: McdmMeasureTopic;
}
export interface MeasureAndTopicListRequestDto extends AllMeasureListRequestDto {
    anuId?: string;
    returnFlightTopics?: boolean;
    targetTvIds?: Array<string>;
    topicFields?: Array<McdmTopicFieldType>;
}
export const MEASURE_AND_TOPIC_LIST_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.MeasureAndTopicListRequestDto';
export interface MeasureCancelRequestDto {
    computeNetworkImpactAssessment?: boolean;
    dataId?: string;
    dataset?: DatasetDto;
    day?: Date;
    measureId?: MeasureId;
}
export interface MeasureCompositeRequest extends MeasureRequestDto {
    flightFields?: Array<FlightFieldType>;
    mcdmTopicFields?: Array<McdmTopicFieldType>;
    retrieveOplogs?: boolean;
}
export interface MeasureRequestDto {
    dataset?: DatasetDto;
    day?: Date;
    mcdmOnlyFields?: Array<McdmOnlyFieldType>;
    measureId?: MeasureId;
    regulationFields?: Array<RegulationFieldType>;
    regulationProposalFields?: Array<RegulationProposalFieldType>;
    reroutingFields?: Array<ReroutingFieldType>;
}
export interface UpdateFlightInMeasureDto {
    clazz?: string;
    flightKeys?: FlightKeys;
}
export const UPDATE_FLIGHT_IN_MEASURE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.flight.UpdateFlightInMeasureDto';
export interface AddFlightToMcdmOnlyDto extends UpdateFlightInMeasureDto {
    mcdmOnlyId?: string;
}
export const ADD_FLIGHT_TO_MCDM_ONLY_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.flight.AddFlightToMcdmOnlyDto';
export interface AddFlightToReroutingDto extends UpdateFlightInMeasureDto {
    reroutingId?: string;
}
export const ADD_FLIGHT_TO_REROUTING_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.flight.AddFlightToReroutingDto';
export interface AssignFlightInSlotDto extends UpdateFlightInMeasureDto {
    flightSlotSequenceIndex?: number;
    flightSlotTime?: Date;
    regulationId?: string;
    slotSequenceIndex?: number;
    slotTime?: Date;
}
export const ASSIGN_FLIGHT_IN_SLOT_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.flight.AssignFlightInSlotDto';
export interface BookSlotInRegulationDto extends UpdateFlightInMeasureDto {
    regulationId?: string;
    slotSequenceIndex?: number;
    slotTime?: Date;
}
export const BOOK_SLOT_IN_REGULATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.flight.BookSlotInRegulationDto';
export interface CreateSlotInRegulationDto extends UpdateFlightInMeasureDto {
    flightSlotSequenceIndex?: number;
    flightSlotTime?: Date;
    forceEntryKind?: ForceEntryType;
    forceEntryTime?: Date;
    regulationId?: string;
}
export const CREATE_SLOT_IN_REGULATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.flight.CreateSlotInRegulationDto';
export interface ExcludeFlightInRegulationDto extends UpdateFlightInMeasureDto {
    regulationIds?: Array<string>;
}
export const EXCLUDE_FLIGHT_IN_REGULATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.flight.ExcludeFlightInRegulationDto';
export enum ForceFlightInRegulationDto_ForceType {
    TOT = 'TOT',
    TO = 'TO',
}
export interface ForceFlightInRegulationDto extends UpdateFlightInMeasureDto {
    forceType?: ForceFlightInRegulationDto_ForceType;
    newCto?: Date;
    newCtot?: Date;
    regulationId?: string;
}
export const FORCE_FLIGHT_IN_REGULATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.flight.ForceFlightInRegulationDto';
export interface FreeFlightFromSlotDto extends UpdateFlightInMeasureDto {
    flightSlotSequenceIndex?: number;
    flightSlotTime?: Date;
    regulationId?: string;
}
export const FREE_FLIGHT_FROM_SLOT_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.flight.FreeFlightFromSlotDto';
export interface ReincludeFlightInRegulationDto extends UpdateFlightInMeasureDto {
    regulationIds?: Array<string>;
}
export const REINCLUDE_FLIGHT_IN_REGULATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.flight.ReincludeFlightInRegulationDto';
export interface RemoveFlightFromMcdmOnlyDto extends UpdateFlightInMeasureDto {
    mcdmOnlyId?: string;
}
export const REMOVE_FLIGHT_FROM_MCDM_ONLY_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.flight.RemoveFlightFromMcdmOnlyDto';
export interface RemoveFlightFromReroutingDto extends UpdateFlightInMeasureDto {
    reroutingId?: string;
}
export const REMOVE_FLIGHT_FROM_REROUTING_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.flight.RemoveFlightFromReroutingDto';
export interface SwapTwoFlightsDto extends UpdateFlightInMeasureDto {
    flightSlotSequenceIndex?: number;
    flightSlotTime?: Date;
    otherFlightKeys?: FlightKeys;
    otherFlightSlotSequenceIndex?: number;
    otherFlightSlotTime?: Date;
    regulationId?: string;
}
export const SWAP_TWO_FLIGHTS_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.measure.flight.SwapTwoFlightsDto';
export interface UnforceFlightInRegulationDto extends UpdateFlightInMeasureDto {
    regulationId?: string;
}
export const UNFORCE_FLIGHT_IN_REGULATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.flight.UnforceFlightInRegulationDto';
export interface UpdateFlightsInMeasureRequestDto {
    dataset?: DatasetDto;
    day?: Date;
    flights?: Array<UpdateFlightInMeasureDto>;
}
export interface MeasureCompositeUpdateRequest {
    computeNetworkImpact?: boolean;
    dataset?: DatasetDto;
    flightFields?: Array<FlightFieldType>;
    flightsToUpdate?: Array<UpdateFlightInMeasureDto>;
    mcdmFields?: Array<McdmTopicFieldType>;
    measure?: MeasureDto;
    measureNeedsUpdating?: boolean;
    measureTopic?: McdmMeasureTopic;
    retrieveOplogs?: boolean;
}
export interface MeasureCreateRequestDto {
    computeNetworkImpactAssessment?: boolean;
    dataset?: DatasetDto;
    measure?: MeasureDto;
    waitUntilApplied?: boolean;
}
export interface MeasureList<T> {
    dataset?: DatasetDto;
    measures?: Array<T>;
    planCutOffReached?: boolean;
    planTransferred?: boolean;
}
export interface MeasureUpdateRequestDto {
    computeNetworkImpactAssessment?: boolean;
    dataset?: DatasetDto;
    measure?: MeasureDto;
    waitUntilApplied?: boolean;
}
export interface SafelyAddFlightsToMeasureReplyDto extends FlightResultList<FlightKeys> {}
export interface SafelyAddFlightsToMeasureRequestDto_FlightInfo {
    clazz?: string;
    currentCtot?: Date;
    currentMpr?: string;
    flightId?: FlightId;
}
export const SAFELY_ADD_FLIGHTS_TO_MEASURE_REQUEST_DTO__FLIGHT_INFO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.SafelyAddFlightsToMeasureRequestDto$FlightInfo';
export interface SafelyAddFlightsToMeasureRequestDto_FlightInfoForForce
    extends SafelyAddFlightsToMeasureRequestDto_FlightInfo {
    newCto?: Date;
    newCtot?: Date;
}
export const SAFELY_ADD_FLIGHTS_TO_MEASURE_REQUEST_DTO__FLIGHT_INFO_FOR_FORCE_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.measure.SafelyAddFlightsToMeasureRequestDto$FlightInfoForForce';
export interface SafelyAddFlightsToMeasureRequestDto {
    dataset?: DatasetDto;
    flights?: Array<SafelyAddFlightsToMeasureRequestDto_FlightInfo>;
    measureId?: MeasureId;
    minApplicabilityPeriod?: TimePeriod;
    proposalMeasure?: boolean;
    waitUntilApplied?: boolean;
}
export interface SafelyRemoveFlightsFromMeasureReplyDto extends FlightResultList<FlightKeys> {}
export interface SafelyRemoveFlightsFromMeasureRequestDto_FlightInfo {
    currentCtot?: Date;
    currentMpr?: string;
    flightId?: FlightId;
}
export interface SafelyRemoveFlightsFromMeasureRequestDto {
    dataset?: DatasetDto;
    day?: Date;
    flights?: Array<SafelyRemoveFlightsFromMeasureRequestDto_FlightInfo>;
    measureId?: MeasureId;
    waitUntilApplied?: boolean;
}
export interface MeasureCompositeReply {
    measure?: MeasureDto;
    measureFlightList?: FlightListDto;
    measureTopic?: McdmMeasureTopic;
    opLogList?: Array<OpLogEntry>;
}
export interface MeasureCompositeUpdateReply extends MeasureCompositeReply {
    flightUpdateResults?: FlightResultList<UpdateFlightInMeasureDto>;
}
export interface TvRefLocation extends RefLocation {
    role?: RefLocationRole;
}
export enum RefLocationRole {
    D = 'D',
    A = 'A',
    G = 'G',
}
export enum FlowRoleType {
    IN = 'IN',
    IE = 'IE',
    EX = 'EX',
    EM = 'EM',
}
export interface PlannedActivation {
    active?: boolean;
    dataSource?: PlanDataSourceType;
    timePeriod?: TimePeriod;
}
export interface TrafficVolumeSet {
    name?: string;
    trafficVolumes?: Array<string>;
}
export interface TvActivationPlanDto extends TacticalPlan {
    clientActivations?: Array<PlannedActivation>;
    nmActivations?: Array<PlannedActivation>;
    tvId?: string;
}
export const TV_ACTIVATION_PLAN_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.tv.TvActivationPlanDto';
export interface TvActivationPlanRequestDto {
    dataset?: DatasetDto;
    day?: Date;
    tvId?: string;
}
export interface TrafficVolume {
    flightLevelBand?: FlightLevelBand;
    flows?: Array<FlowRef>;
    id?: string;
    monitorable?: boolean;
    refLocation?: TvRefLocation;
    skipInMs?: number;
    skipOutMs?: number;
    title?: string;
}
export interface FlowRef {
    flowRef?: string;
    role?: FlowRoleType;
}
export interface TimePeriod {
    from?: Date;
    to?: Date;
}
export interface TimeRange {
    countDurationInMinutes?: number;
    from?: Date;
    stepSizeInMinutes?: number;
    to?: Date;
}
export interface DaysOfWeekPresence {
    friday?: boolean;
    monday?: boolean;
    saturday?: boolean;
    sunday?: boolean;
    thursday?: boolean;
    tuesday?: boolean;
    wednesday?: boolean;
}
export interface TimeOfDay {
    hours?: number;
    minutes?: number;
    seconds?: number;
    timeZone?: string;
}
export interface TimeOfDayPeriod {
    from?: TimeOfDay;
    to?: TimeOfDay;
}
export interface TimeStampedValue<V> {
    time?: Date;
    value?: V;
}
export enum CountType {
    ENTRY = 'ENTRY',
    OCCUPANCY = 'OCCUPANCY',
}
export enum OtmvAlert_AlertStatus {
    SUSTAINED = 'SUSTAINED',
    PEAK = 'PEAK',
}
export interface OtmvAlert {
    alertPeriod?: TimePeriod;
    alertStatus?: OtmvAlert_AlertStatus;
}
export interface FlowDto {
    applicableScenarios?: TrafficVolumeScenariosDto;
    id?: string;
    role?: FlowRoleType;
    scenarioImpact?: ScenarioImpactDto;
    type?: FlowType;
}
export enum FlowType {
    ASSOCIATED = 'ASSOCIATED',
    LINKED = 'LINKED',
    SCENARIO = 'SCENARIO',
}
export interface ScenarioImpactDto {
    scenarioTvEntryPeriod?: TimePeriod;
    totalCommonFlightCount?: number;
    totalOtherFlightCount?: number;
}
export enum CapacityModel {
    CCM = 'CCM',
    WCM_NRP = 'WCM_NRP',
}
export interface CountSubtotalsType {}
export interface CountedRegulation {
    cancelledTime?: Date;
    occupancyDurationInMs?: number;
    occupancySubPeriods?: Array<RegulationOccupancyConstraintDto>;
    regulationId?: string;
    subPeriods?: Array<RegulationSubPeriod>;
}
export enum CountsAlgorithm {
    DEFAULT = 'DEFAULT',
    NM = 'NM',
    PSEUDO_NM = 'PSEUDO_NM',
    PROBABILISTIC = 'PROBABILISTIC',
    WEIGHTED = 'WEIGHTED',
}
export interface CountsComparisonCriteria {
    comparisonAlgorithm?: CountsAlgorithm;
    comparisonDataset?: DatasetDto;
    proposalContexts?: Array<string>;
    retrieveComparisonOnlyIfDiffer?: boolean;
    simplifyComparisonCounts?: boolean;
}
export interface TrafficCountsRequestDto extends AbstractFlightRelatedRequest {
    algorithm?: CountsAlgorithm;
    computeRegulations?: boolean;
    durationInMin?: number;
    includeForecastFlights?: boolean;
    intervalInMin?: number;
    subtotalsType?: CountSubtotalsType;
    trafficTypes?: Array<TrafficType>;
    trafficWindow?: TimePeriod;
}
export const TRAFFIC_COUNTS_REQUEST_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.counts.TrafficCountsRequestDto';
export interface CountsIntervalDto {
    durationInMin?: number;
    intervalInMin?: number;
}
export interface FlightCountCategory {}
export class FlightCountStandardCategory implements FlightCountCategory {
    public static readonly ATC_ACTIVATED = [
        'eurocontrol.npp.core.shared.dto.counts.FlightCountStandardCategory',
        'ATC_ACTIVATED',
    ];
    public static readonly IFPL = ['eurocontrol.npp.core.shared.dto.counts.FlightCountStandardCategory', 'IFPL'];
    public static readonly PFD = ['eurocontrol.npp.core.shared.dto.counts.FlightCountStandardCategory', 'PFD'];
    public static readonly RPL = ['eurocontrol.npp.core.shared.dto.counts.FlightCountStandardCategory', 'RPL'];
    public static readonly SUSPENDED = [
        'eurocontrol.npp.core.shared.dto.counts.FlightCountStandardCategory',
        'SUSPENDED',
    ];
    public static readonly TACT_ACTIVATED_WITHOUT_FSA = [
        'eurocontrol.npp.core.shared.dto.counts.FlightCountStandardCategory',
        'TACT_ACTIVATED_WITHOUT_FSA',
    ];
    public static readonly TACT_ACTIVATED_WITH_FSA = [
        'eurocontrol.npp.core.shared.dto.counts.FlightCountStandardCategory',
        'TACT_ACTIVATED_WITH_FSA',
    ];
}
export class FlightCountStandardRegulationCategory implements FlightCountCategory {
    public static readonly DELAYED_FLIGHTS_ALREADY_AIRBORNE = [
        'eurocontrol.npp.core.shared.dto.counts.FlightCountStandardRegulationCategory',
        'DELAYED_FLIGHTS_ALREADY_AIRBORNE',
    ];
    public static readonly DELAYED_FLIGHTS_NOT_YET_AIRBORNE = [
        'eurocontrol.npp.core.shared.dto.counts.FlightCountStandardRegulationCategory',
        'DELAYED_FLIGHTS_NOT_YET_AIRBORNE',
    ];
    public static readonly NOT_REGULATED_AIRBORNE_OR_EXEMPTED_FLIGHTS = [
        'eurocontrol.npp.core.shared.dto.counts.FlightCountStandardRegulationCategory',
        'NOT_REGULATED_AIRBORNE_OR_EXEMPTED_FLIGHTS',
    ];
    public static readonly NOT_REGULATED_BUT_REGULATABLE_FLIGHTS = [
        'eurocontrol.npp.core.shared.dto.counts.FlightCountStandardRegulationCategory',
        'NOT_REGULATED_BUT_REGULATABLE_FLIGHTS',
    ];
    public static readonly OTHER_MPR_DELAYED_FLIGHTS_ALREADY_AIRBORNE = [
        'eurocontrol.npp.core.shared.dto.counts.FlightCountStandardRegulationCategory',
        'OTHER_MPR_DELAYED_FLIGHTS_ALREADY_AIRBORNE',
    ];
    public static readonly OTHER_MPR_DELAYED_FLIGHTS_NOT_YET_AIRBORNE = [
        'eurocontrol.npp.core.shared.dto.counts.FlightCountStandardRegulationCategory',
        'OTHER_MPR_DELAYED_FLIGHTS_NOT_YET_AIRBORNE',
    ];
    public static readonly ZERO_DELAY_FLIGHTS_ALREADY_AIRBORNE = [
        'eurocontrol.npp.core.shared.dto.counts.FlightCountStandardRegulationCategory',
        'ZERO_DELAY_FLIGHTS_ALREADY_AIRBORNE',
    ];
    public static readonly ZERO_DELAY_FLIGHTS_NOT_YET_AIRBONE = [
        'eurocontrol.npp.core.shared.dto.counts.FlightCountStandardRegulationCategory',
        'ZERO_DELAY_FLIGHTS_NOT_YET_AIRBONE',
    ];
}
export interface FlightModelCounts {
    counts?: Array<TimeSliceCountData>;
    omtvAlerts?: Array<OtmvAlert>;
}
export interface TimeSliceCountData {
    clazz?: string;
    subtotals?: TimeSliceSubCounts;
    total?: number;
}
export const TIME_SLICE_COUNT_DATA_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.counts.TimeSliceCountData';
export interface TimeSliceSubCounts {
    clazz?: string;
}
export const TIME_SLICE_SUB_COUNTS_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.counts.TimeSliceSubCounts';
export interface FlightWeightedOccupancyInfo {
    climbingDescending?: boolean;
    enteringExiting?: boolean;
    flightId?: FlightId;
    slowMover?: boolean;
    weight?: number;
}
export interface FlowCount {
    count?: number;
    id?: string;
}
export interface NmTimeSliceCountData extends TimeSliceCountData {
    flowCounts?: Array<FlowCount>;
}
export const NM_TIME_SLICE_COUNT_DATA_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.counts.NmTimeSliceCountData';
export interface ProbabilisticTimeSliceCountsData extends TimeSliceCountData {
    stdDeviation?: number;
}
export const PROBABILISTIC_TIME_SLICE_COUNTS_DATA_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.counts.ProbabilisticTimeSliceCountsData';
export interface PseudoNmTimeSliceCountData extends TimeSliceCountData {}
export const PSEUDO_NM_TIME_SLICE_COUNT_DATA_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.counts.PseudoNmTimeSliceCountData';
export class StandardCountSubtotalsType implements CountSubtotalsType {
    public static readonly NM = ['eurocontrol.npp.core.shared.dto.counts.StandardCountSubtotalsType', 'NM'];
    public static readonly NM_REGULATION = [
        'eurocontrol.npp.core.shared.dto.counts.StandardCountSubtotalsType',
        'NM_REGULATION',
    ];
    public static readonly NONE = ['eurocontrol.npp.core.shared.dto.counts.StandardCountSubtotalsType', 'NONE'];
}
export interface TimeSliceStandardRegulationSubCounts extends TimeSliceSubCounts {
    mprDelayedAirborne?: number;
    mprDelayedNotAirborne?: number;
    notRegulatedAirborneOrExempted?: number;
    notRegulatedButRegulatable?: number;
    otherMprDelayedAirborne?: number;
    otherMprDelayedNotAirborne?: number;
    zeroDelayAirborne?: number;
    zeroDelayNotAirborne?: number;
}
export const TIME_SLICE_STANDARD_REGULATION_SUB_COUNTS_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.counts.TimeSliceStandardRegulationSubCounts';
export interface TimeSliceStandardSubCounts extends TimeSliceSubCounts {
    atcActivated?: number;
    ifpl?: number;
    pfd?: number;
    rpl?: number;
    suspended?: number;
    tactActivatedWithFsa?: number;
    tactActivatedWithoutFsa?: number;
}
export const TIME_SLICE_STANDARD_SUB_COUNTS_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.counts.TimeSliceStandardSubCounts';
export interface TimeSliceWeightedOccupancyInfo {
    closeToPeakFactor?: number;
    flightInfos?: Array<FlightWeightedOccupancyInfo>;
}
export interface TrafficCountsComparisonRequestDto {
    comparisonCriteria?: CountsComparisonCriteria;
    request?: TrafficCountsRequestDto;
}
export interface TrafficCountsAndFlightListComparisonRequestDto extends TrafficCountsAndFlightListRequestDto {
    comparisonCriteria?: CountsComparisonCriteria;
    comparisonFlightFields?: Array<FlightFieldType>;
}
export interface TrafficCountsAndFlightListRequestDto {
    extraFlightWindowInMinutes?: number;
    flightFields?: Array<FlightFieldType>;
    tcRequest?: TrafficCountsRequestDto;
}
export interface TrafficCountsByAerodromeRequestDto extends TrafficCountsRequestDto {
    aerodrome?: string;
    includeInvisibleFlights?: boolean;
    role?: AerodromeRole;
}
export const TRAFFIC_COUNTS_BY_AERODROME_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.counts.TrafficCountsByAerodromeRequestDto';
export interface TrafficCountsByAirlineRequestDto extends TrafficCountsRequestDto {
    airline?: string;
    countType?: CountType;
}
export const TRAFFIC_COUNTS_BY_AIRLINE_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.counts.TrafficCountsByAirlineRequestDto';
export interface TrafficCountsByAirspaceRequestDto extends TrafficCountsRequestDto {
    airspace?: string;
    countType?: CountType;
}
export const TRAFFIC_COUNTS_BY_AIRSPACE_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.counts.TrafficCountsByAirspaceRequestDto';
export interface TrafficCountsByMeasureRequestDto extends TrafficCountsRequestDto {
    computeFlowCounts?: FlowType;
    computeOtmvAlerts?: boolean;
    countType?: CountType;
    measureId?: MeasureId;
}
export const TRAFFIC_COUNTS_BY_MEASURE_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.counts.TrafficCountsByMeasureRequestDto';
export interface TrafficCountsByPointRequestDto extends TrafficCountsRequestDto {
    flightLevelRange?: FlightLevelBand;
    point?: string;
}
export const TRAFFIC_COUNTS_BY_POINT_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.counts.TrafficCountsByPointRequestDto';
export interface TrafficCountsByTvRequestDto extends TrafficCountsRequestDto {
    computeFlowCounts?: FlowType;
    computeHotspots?: boolean;
    computeHourlyEntryRates?: boolean;
    computeInactivePeriods?: boolean;
    computeOtmvAlerts?: boolean;
    computeOtmvDefns?: boolean;
    countType?: CountType;
    includeInvisibleFlights?: boolean;
    tvId?: string;
}
export const TRAFFIC_COUNTS_BY_TV_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.counts.TrafficCountsByTvRequestDto';
export interface WeightedOccupancyTimeSliceCountData extends TimeSliceCountData {
    weightedInfo?: TimeSliceWeightedOccupancyInfo;
}
export const WEIGHTED_OCCUPANCY_TIME_SLICE_COUNT_DATA_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.counts.WeightedOccupancyTimeSliceCountData';
export interface TrafficCountsAndComparisonDto {
    comparisonCounts?: TrafficCountsDto;
    counts?: TrafficCountsDto;
    request?: TrafficCountsComparisonRequestDto;
}
export interface TrafficCountsDto {
    algorithm?: CountsAlgorithm;
    countType?: CountType;
    demandCounts?: FlightModelCounts;
    flows?: Array<FlowDto>;
    hotspots?: Array<HotspotDto>;
    hourlyEntryCapacity?: Array<CapacityValue>;
    inactivePeriods?: Array<TimePeriod>;
    loadCounts?: FlightModelCounts;
    otmvDefns?: Array<Otmv>;
    regulatedCounts?: FlightModelCounts;
    regulatedPeriods?: Array<CountedRegulation>;
    request?: TrafficCountsRequestDto;
    timeRange?: TimeRange;
}
export interface TrafficCountsAndFlightListComparisonDto extends TrafficCountsAndFlightListDto {
    comparisonCounts?: TrafficCountsDto;
    comparisonFlightList?: FlightListDto;
}
export interface TrafficCountsAndFlightListDto {
    counts?: TrafficCountsDto;
    flightList?: FlightListDto;
}
export interface HotspotId {
    durationInMinutes?: number;
    timePeriod?: TimePeriod;
    tvId?: string;
}
export enum HotspotSeverity {
    NONE_SEVERITY = 'NONE_SEVERITY',
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
}
export enum HotspotStatus {
    ACCEPTABLE = 'ACCEPTABLE',
    ACTIVE = 'ACTIVE',
    DRAFT = 'DRAFT',
    SOLVED = 'SOLVED',
    CANCELLED = 'CANCELLED',
    PROPOSED = 'PROPOSED',
    CLEARED = 'CLEARED',
}
export enum HotspotKind {
    LOCATION_OF_INTEREST = 'LOCATION_OF_INTEREST',
    PROBLEM = 'PROBLEM',
    PROTECTION = 'PROTECTION',
    HARMONIC_HOTSPOT = 'HARMONIC_HOTSPOT',
    COLDSPOT = 'COLDSPOT',
    OPTISPOT = 'OPTISPOT',
}
export enum HotspotCriticality {
    NOMINAL = 'NOMINAL',
    NON_NOMINAL = 'NON_NOMINAL',
    CRITICAL = 'CRITICAL',
}
export enum LoadMethodology {
    ENTRY = 'ENTRY',
    OCCUPANCY = 'OCCUPANCY',
    COMPLEXITY = 'COMPLEXITY',
}
export enum HotspotCause {
    CRITICAL_SITUATION = 'CRITICAL_SITUATION',
    REGULATION = 'REGULATION',
    OPTIMISATION = 'OPTIMISATION',
    PROTECTION = 'PROTECTION',
    FREE_CAPACITY = 'FREE_CAPACITY',
}
export interface DCBProblemSolutionDto {
    flights?: Array<DCBProblemSolutionFlightDto>;
    id?: string;
    kpis?: DCBProblemKPIDto;
    overloads?: Array<DCBProblemOverloadDto>;
    simulations?: Array<UserManagedSimulationDto>;
}
export interface DCBProblemSolutionFlightDto {
    delay?: number;
    flightId?: FlightId;
    rerouteId?: string;
    targetTvId?: string;
}
export interface DCBProblemKPIDto {
    delay?: number;
    delayChange?: number;
    delayIncrease?: number;
    extraFlightsInProtectionSpot?: number;
    flightsInColdSpot?: number;
    fuel?: number;
    highImpact?: number;
    knockOnDelay?: number;
    mediumImpact?: number;
    planChange?: number;
    softEntryOverload?: number;
    softPeakOverload?: number;
    softSustainedOverload?: number;
    spike?: number;
    ttoChangeInOptiSpot?: number;
}
export interface DCBProblemOverloadDto {
    applicabilityPeriod?: TimePeriod;
    overload?: number;
    tvId?: string;
    type?: CountType;
}
export enum DCBProblemObjective {
    MEDIUM_IMPACT = 'MEDIUM_IMPACT',
    HIGH_IMPACT = 'HIGH_IMPACT',
    DELAY = 'DELAY',
    KNOCKON_DELAY = 'KNOCKON_DELAY',
    FUEL = 'FUEL',
    SPIKE = 'SPIKE',
    SOFT_ENTRY_OVERLOAD = 'SOFT_ENTRY_OVERLOAD',
    SOFT_PEAK_OVERLOAD = 'SOFT_PEAK_OVERLOAD',
    SOFT_SUSTAINED_OVERLOAD = 'SOFT_SUSTAINED_OVERLOAD',
    DELAY_CHANGE = 'DELAY_CHANGE',
    DELAY_INCREASE = 'DELAY_INCREASE',
    PLAN_CHANGE = 'PLAN_CHANGE',
    FLIGHTS_IN_COLDSPOT = 'FLIGHTS_IN_COLDSPOT',
    TTO_CHANGE_IN_OPTISPOT = 'TTO_CHANGE_IN_OPTISPOT',
    EXTRA_FLIGHTS_IN_PROTECTIONSPOT = 'EXTRA_FLIGHTS_IN_PROTECTIONSPOT',
}
export interface DCBProblemObjectiveAndThresholdDto {
    objective?: DCBProblemObjective;
    priority?: number;
    threshold?: number;
}
export interface DCBProblemDto extends AbstractLoggingEntityDto {
    applicabilityPeriod?: TimePeriod;
    dataId?: string;
    dataset?: DatasetDto;
    exemptedFlights?: Array<FlightId>;
    hotspots?: Array<HotspotDto>;
    id?: string;
    mcdmRegulation?: RegulationDto;
    name?: string;
    netspots?: Array<NetspotDto>;
    objectives?: Array<DCBProblemObjectiveAndThresholdDto>;
    remark?: string;
    solution?: DCBProblemSolutionDto;
    solutionUpToDate?: boolean;
    trafficVolumes?: Array<TrafficVolume>;
}
export interface DCBProblemListRequestDto {
    datasetAndDay?: DatasetAndDayDto;
    timePeriod?: TimePeriod;
    tvIds?: Array<string>;
}
export interface NetspotListRequestDto {
    dataset?: DatasetDto;
    day?: Date;
    tvIds?: Array<string>;
}
export interface NetspotDto extends AbstractLoggingEntityDto {
    applicabilityPeriod?: TimePeriod;
    dataId?: string;
    dataset?: DatasetDto;
    hotspots?: Array<HotspotDto>;
    id?: string;
    name?: string;
    remark?: string;
    status?: HotspotStatus;
}
export interface HotspotIdAndKind {
    id?: HotspotId;
    kind?: HotspotKind;
}
export interface HotspotListRequestDto {
    dataset?: DatasetDto;
    day?: Date;
    durationInMinutes?: number;
    kind?: HotspotKind;
    tvId?: string;
}
export interface FlightHotspotLoc {
    hotspot?: HotspotDto;
    infringer?: boolean;
    refLocation?: RefLocation;
}
export interface HotspotDto extends AbstractLoggingEntityDto {
    cause?: HotspotCause;
    criticality?: HotspotCriticality;
    detectionThreshold?: number;
    hotspotId?: HotspotId;
    initiator?: string;
    kind?: HotspotKind;
    loadMethod?: LoadMethodology;
    location?: TvRefLocation;
    name?: string;
    remark?: string;
    resolutionThreshold?: number;
    severity?: HotspotSeverity;
    status?: HotspotStatus;
    tvDescription?: string;
}
export interface CreateEnrichedHotspotRequestDto {
    dataset?: DatasetDto;
    hotspot?: EnrichedHotspotDto;
}
export interface EnrichedHotspotDto extends HotspotDto {
    peakValue?: number;
    sustainedElapseInMinutes?: number;
    sustainedOccurence?: number;
    sustainedValue?: number;
}
export interface HotspotsForDuration {
    durationInMinutes?: number;
    hotspots?: Array<HotspotDto>;
}
export interface HotspotPlanDto extends TacticalPlan {
    hotspotsForDurations?: Array<HotspotsForDuration>;
    kind?: HotspotKind;
    tvId?: string;
}
export const HOTSPOT_PLAN_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.hotspot.HotspotPlanDto';
export interface HotspotPlansDto extends TacticalPlan {
    kind?: HotspotKind;
    plans?: Array<HotspotPlanDto>;
}
export const HOTSPOT_PLANS_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.hotspot.HotspotPlansDto';
export interface EHelpDeskTicketChoiceDto {
    addFlightsInFmpStamRerouting?: EHelpDeskAddFlightsInFmpStamReroutingDto;
    excludeFlightFromRegulation?: EHelpDeskExcludeReIncludeFlightInRegulationDto;
    extendSlotInRegulation?: EHelpDeskExtendSlotInRegulationDto;
    forceFlightsInRegulation?: EHelpDeskForceFlightsInRegulationDto;
    improveSlotInRegulation?: EHelpDeskImproveSlotInRegulationDto;
    information?: EHelpDeskInformationTicketDto;
    other?: EHelpDeskOtherTicketDto;
    reIncludeFlightInRegulation?: EHelpDeskExcludeReIncludeFlightInRegulationDto;
    removeFlightsFromFmpStamRerouting?: EHelpDeskRemoveFlightsFromFmpStamReroutingDto;
    swapSlotsInRegulation?: EHelpDeskSwapSlotsInRegulationDto;
    unforceFlightsInRegulation?: EHelpDeskUnforceFlightsInRegulationDto;
}
export interface EHelpDeskForceFlightsInRegulationDto {
    flights?: Array<EHelpDeskForceFlightInRegulationDto>;
    mostPenalisingRegulation?: string;
}
export interface EHelpDeskUnforceFlightsInRegulationDto {
    flights?: Array<EHelpDeskUnforceFlightInRegulationDto>;
}
export interface EHelpDeskAddFlightsInFmpStamReroutingDto {
    flights?: Array<EHelpDeskAddFlightInFmpStamReroutingDto>;
    reroutingId?: string;
}
export interface EHelpDeskRemoveFlightsFromFmpStamReroutingDto_Failure {
    flightKeys?: FlightKeys;
    message?: string;
}
export interface EHelpDeskRemoveFlightsFromFmpStamReroutingDto {
    flights?: Array<FlightKeys>;
    reroutingId?: string;
    unsuccessfullyUpdatedFlights?: Array<EHelpDeskRemoveFlightsFromFmpStamReroutingDto_Failure>;
}
export interface EHelpDeskExcludeReIncludeFlightInRegulationDto extends EHelpDeskTicketDto {
    regulations?: Array<string>;
}
export interface EHelpDeskTicketDto {
    flightId?: FlightId;
    requestDetails?: EHelpDeskTicketRequestDetailsDto;
    responseDetails?: EHelpDeskTicketResponseDetailsDto;
    updateTopicId?: string;
}
export enum EHelpDeskImproveSlotInRegulationDto_EHelpDeskImproveSlotInRegulationType {
    AIRPORT_CLOSURE = 'AIRPORT_CLOSURE',
    AIRPORT_CLOSURE_NOISE = 'AIRPORT_CLOSURE_NOISE',
    CONNECTING_PASSENGER = 'CONNECTING_PASSENGER',
    CREW_TIME = 'CREW_TIME',
    DISPROPORTIONATE_DELAY_LATE_FILER_BUSINESS_JET = 'DISPROPORTIONATE_DELAY_LATE_FILER_BUSINESS_JET',
    DISPROPORTIONATE_DELAY_LATE_UPDATER = 'DISPROPORTIONATE_DELAY_LATE_UPDATER',
    DIVERSION = 'DIVERSION',
    LATE_REVIEW_TO_CTOT = 'LATE_REVIEW_TO_CTOT',
    LATE_REVIEW_TO_CTOT_ON_TAXI_TRACK = 'LATE_REVIEW_TO_CTOT_ON_TAXI_TRACK',
    LIVE_STOCK = 'LIVE_STOCK',
    MAINTAIN_SCHEDULE = 'MAINTAIN_SCHEDULE',
    NO_REASON = 'NO_REASON',
    RELIGIOUS_REASON = 'RELIGIOUS_REASON',
    SICK_PASSENGER = 'SICK_PASSENGER',
    VIP_FLIGHT = 'VIP_FLIGHT',
}
export interface EHelpDeskImproveSlotInRegulationDto extends EHelpDeskTicketDto {
    minRequestedCto?: Date;
    minRequestedCtot?: Date;
    subType?: EHelpDeskImproveSlotInRegulationDto_EHelpDeskImproveSlotInRegulationType;
}
export enum EHelpDeskExtendSlotInRegulationDto_EHelpDeskExtendSlotInRegulationType {
    ATC_WILL_NOT_RELEASE = 'ATC_WILL_NOT_RELEASE',
    BAG_REMOVAL = 'BAG_REMOVAL',
    CREW_REPLACEMENT = 'CREW_REPLACEMENT',
    DEICING = 'DEICING',
    LATE_INBOUND_AIRCRAFT = 'LATE_INBOUND_AIRCRAFT',
    LATE_PASSENGER = 'LATE_PASSENGER',
    LOST_BAG = 'LOST_BAG',
    NO_REASON = 'NO_REASON',
    PASSENGER_REMOVAL = 'PASSENGER_REMOVAL',
    SICK_OR_LATE_CREW = 'SICK_OR_LATE_CREW',
    TECHNICAL_PROBLEM = 'TECHNICAL_PROBLEM',
    UNWANTED_LATE_IMPROVEMENT = 'UNWANTED_LATE_IMPROVEMENT',
}
export interface EHelpDeskExtendSlotInRegulationDto extends EHelpDeskTicketDto {
    subType?: EHelpDeskExtendSlotInRegulationDto_EHelpDeskExtendSlotInRegulationType;
}
export enum EHelpDeskSwapSlotsInRegulationDto_EHelpDeskSwapSlotsInRegulationType {
    DIFFERENT_AIRCRAFT_OPERATORS = 'DIFFERENT_AIRCRAFT_OPERATORS',
    SAME_AIRCRAFT_OPERATORS = 'SAME_AIRCRAFT_OPERATORS',
}
export interface EHelpDeskSwapSlotsInRegulationDto extends EHelpDeskTicketDto {
    otherFlightKeys?: FlightKeys;
    subType?: EHelpDeskSwapSlotsInRegulationDto_EHelpDeskSwapSlotsInRegulationType;
}
export enum EHelpDeskInformationTicketDto_EHelpDeskInformationTicketType {
    CANNOT_FIND_FLIGHT = 'CANNOT_FIND_FLIGHT',
    CONTACT_CREW = 'CONTACT_CREW',
    OPERATIONAL_TEL_NUMBERS = 'OPERATIONAL_TEL_NUMBERS',
    OTHER_INFO_REQUEST = 'OTHER_INFO_REQUEST',
    UNCLEAR_HEADLINE_NEWS = 'UNCLEAR_HEADLINE_NEWS',
}
export interface EHelpDeskInformationTicketDto extends EHelpDeskTicketDto {
    subType?: EHelpDeskInformationTicketDto_EHelpDeskInformationTicketType;
}
export enum EHelpDeskOtherTicketDto_EHelpDeskOtherTicketType {
    DEACTIVATE_MY_FLIGHT = 'DEACTIVATE_MY_FLIGHT',
    MILITARY_FORMATION_DIFFERENT_CTOT = 'MILITARY_FORMATION_DIFFERENT_CTOT',
    PROFILE_INCORRECT_CAPTURE = 'PROFILE_INCORRECT_CAPTURE',
    QUERY_COMPETITORS_CTOT = 'QUERY_COMPETITORS_CTOT',
    SUSPENDED_WHAT_TO_DO = 'SUSPENDED_WHAT_TO_DO',
    REQUEST_REROUTING_PROPOSAL = 'REQUEST_REROUTING_PROPOSAL',
}
export interface EHelpDeskOtherTicketDto extends EHelpDeskTicketDto {
    subType?: EHelpDeskOtherTicketDto_EHelpDeskOtherTicketType;
}
export interface EHelpDeskTicketRequestDetailsDto {
    creationTime?: Date;
    inResponseTo?: EHelpDeskTicketFlightInfoDto;
    lastModificationTime?: Date;
    requestText?: string;
}
export interface EHelpDeskTicketResponseDetailsDto {
    automatedResponseRule?: EHelpDeskRuleType;
    generalInterest?: boolean;
    responseFlightInfo?: EHelpDeskTicketFlightInfoDto;
    responseText?: string;
    state?: McdmState;
    supersededByRequestTopicId?: string;
}
export interface EHelpDeskTicketFlightInfoDto {
    ctot?: Date;
    eobt?: Date;
    mpr?: string;
}
export enum EHelpDeskRuleType {
    DUPLICATE_REQUEST_REJECTION = 'DUPLICATE_REQUEST_REJECTION',
    EXCLUDE_REJECTION = 'EXCLUDE_REJECTION',
    FLIGHT_CHANGED_REJECTION = 'FLIGHT_CHANGED_REJECTION',
    FLIGHT_STATUS_REJECTION = 'FLIGHT_STATUS_REJECTION',
    FORCE_REJECTION = 'FORCE_REJECTION',
    GENERAL_AUTO_RESPONSE = 'GENERAL_AUTO_RESPONSE',
    MOST_PENALISING_REGULATION_CHANGED = 'MOST_PENALISING_REGULATION_CHANGED',
    NOT_REGULATED = 'NOT_REGULATED',
    NOT_SUITABLE_FOR_MANUAL_IMPROVEMENT = 'NOT_SUITABLE_FOR_MANUAL_IMPROVEMENT',
    REGULATION_SLOT_IMPROVEMENT_MINIMUM_DELAY = 'REGULATION_SLOT_IMPROVEMENT_MINIMUM_DELAY',
    RE_INCLUDE_REJECTION = 'RE_INCLUDE_REJECTION',
    SIT1_REQUEST_REJECTION = 'SIT1_REQUEST_REJECTION',
    SLOT_EXTENSION = 'SLOT_EXTENSION',
    SLOT_EXTENSION_CDM = 'SLOT_EXTENSION_CDM',
    SLOT_SWAP_REJECTION = 'SLOT_SWAP_REJECTION',
    UNFORCE_REJECTION = 'UNFORCE_REJECTION',
    XSD_OR_RESTRICTION_VIOLATION = 'XSD_OR_RESTRICTION_VIOLATION',
}
export interface EHelpDeskAddFlightInFmpStamReroutingDto extends EHelpDeskTicketDto {}
export interface EHelpDeskUnforceFlightInRegulationDto extends EHelpDeskTicketDto {}
export interface EHelpDeskForceFlightInRegulationDto extends EHelpDeskTicketDto {
    newCto?: Date;
    newCtot?: Date;
}
export interface EHelpDeskFlightId {
    keys?: FlightKeys;
    topicId?: string;
}
export interface EHelpDeskTicketCreationRequestDto extends AbstractRequest {
    dataset?: DatasetDto;
    flightCriticalityIndicator?: FlightCriticalityIndicatorDto;
    ticket?: EHelpDeskTicketChoiceDto;
}
export const E_HELP_DESK_TICKET_CREATION_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.ehelpdesk.EHelpDeskTicketCreationRequestDto';
export interface EHelpDeskTicketRevocationReplyDto_Failure {
    reason?: string;
    topicId?: string;
}
export interface EHelpDeskTicketRevocationReplyDto {
    successfullyRevokedTickets?: Array<string>;
    unsuccessfullyRevokedTickets?: Array<EHelpDeskTicketRevocationReplyDto_Failure>;
}
export interface EHelpDeskTicketRevocationRequestDto extends AbstractRequest {
    dataset?: DatasetDto;
    tickets?: Array<EHelpDeskFlightId>;
}
export const E_HELP_DESK_TICKET_REVOCATION_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.ehelpdesk.EHelpDeskTicketRevocationRequestDto';
export interface EHelpDeskTicketUpdateRequestDto extends AbstractRequest {
    dataset?: DatasetDto;
    flightCriticalityIndicator?: FlightCriticalityIndicatorDto;
    ticket?: EHelpDeskTicketChoiceDto;
}
export const E_HELP_DESK_TICKET_UPDATE_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.ehelpdesk.EHelpDeskTicketUpdateRequestDto';
export interface AircraftTypeData {
    engineType?: EngineType;
    icaoId?: string;
    maxPersonsOnBoard?: number;
    modelName?: string;
    recatWakeTurbulenceCategory?: RecatWakeTurbulenceCategory;
    wakeTurbulenceCategory?: WakeTurbulenceCategory;
    wingSpanInMetres?: number;
}
export enum WakeTurbulenceCategory {
    SUPER = 'SUPER',
    HEAVY = 'HEAVY',
    MEDIUM = 'MEDIUM',
    LIGHT = 'LIGHT',
}
export enum RecatWakeTurbulenceCategory {
    SUPER_HEAVY = 'SUPER_HEAVY',
    UPPER_HEAVY = 'UPPER_HEAVY',
    LOWER_HEAVY = 'LOWER_HEAVY',
    UPPER_MEDIUM = 'UPPER_MEDIUM',
    LOWER_MEDIUM = 'LOWER_MEDIUM',
    LIGHT = 'LIGHT',
}
export enum EngineType {
    JET = 'JET',
    PISTON = 'PISTON',
    TURBOPROP = 'TURBOPROP',
}
export enum IcaoAirplaneDesignCode {
    A = 'A',
    B = 'B',
    C = 'C',
    D = 'D',
    E = 'E',
    F = 'F',
}
export interface AIXMFileDto extends FileDto {}
export enum AIXMTemporality {
    BASELINE = 'BASELINE',
    PERM_DELTA = 'PERM_DELTA',
}
export interface AffectedFeaturesDto {
    items?: Array<AffectedFeaturesItemDto>;
}
export interface AffectedFeaturesItemDto {
    key?: string;
    value?: number;
}
export interface AiracIdentifierDto {
    airacId?: string;
    airacSequenceNumber?: number;
}
export interface CompleteAIXMDatasetReplyDto {
    datasetSummaries?: Array<CompleteDatasetSummaryDto>;
}
export interface CompleteDatasetSummaryDto {
    files?: Array<AIXMFileDto>;
    publicationDate?: Date;
    sourceAIRACs?: Array<AiracIdentifierDto>;
    updateId?: number;
}
export interface CompleteAIXMDatasetRequestDto {
    queryCriteria?: CompleteDatasetQueryCriteriaDto;
}
export interface CompleteDatasetQueryCriteriaDto {
    airac?: AiracIdentifierDto;
    date?: Date;
    publicationPeriod?: TimePeriod;
}
export interface IncrementalAIXMDatasetReplyDto {
    datasetSummaries?: Array<IncrementalDatasetSummaryDto>;
}
export interface IncrementalDatasetSummaryDto {
    affectedFeatures?: AffectedFeaturesDto;
    files?: Array<AIXMFileDto>;
    previousUpdateId?: number;
    publicationDate?: Date;
    sourceAIRACs?: Array<AiracIdentifierDto>;
    updateId?: number;
}
export interface IncrementalAIXMDatasetRequestDto {
    queryCriteria?: IncrementalDatasetQueryCriteriaDto;
    timesliceType?: AIXMTemporality;
}
export interface IncrementalDatasetQueryCriteriaDto {
    airac?: AiracIdentifierDto;
    date?: Date;
    lastKnownUpdateId?: number;
    publicationPeriod?: TimePeriod;
}
export interface AllFtFlightAirspaceCrossing extends FlightAirspaceCrossing {
    entryPoint?: LatLonPoint;
    exitPoint?: LatLonPoint;
}
export enum FlightDataQuality {
    NON = 'NON',
    RPL = 'RPL',
    MFD = 'MFD',
    FPL = 'FPL',
    PFD = 'PFD',
}
export enum FlightSource {
    UNK = 'UNK',
    FPL = 'FPL',
    RPL = 'RPL',
    AFI = 'AFI',
    MFS = 'MFS',
    FNM = 'FNM',
    AFP = 'AFP',
    DIV = 'DIV',
}
export enum AllFtFlightPointDto_Type {
    AERODROME = 'AERODROME',
    DBE_POINT = 'DBE_POINT',
    NAV_POINT = 'NAV_POINT',
    GEOGRAPHICAL_POINT = 'GEOGRAPHICAL_POINT',
    SPLIT_POINT = 'SPLIT_POINT',
    WAY_POINT = 'WAY_POINT',
    VECTOR = 'VECTOR',
}
export interface AllFtFlightPointDto extends FlightPointDto {
    relDist?: number;
    type?: AllFtFlightPointDto_Type;
    vectorPointPosition?: LatLonPoint;
}
export class AllFtFieldType implements FlightFieldType {
    public static readonly IOBT = ['eurocontrol.npp.core.shared.dto.allft.AllFtFieldType', 'IOBT'];
    public static readonly TACT_ID = ['eurocontrol.npp.core.shared.dto.allft.AllFtFieldType', 'TACT_ID'];
    public static readonly NAT = ['eurocontrol.npp.core.shared.dto.allft.AllFtFieldType', 'NAT'];
    public static readonly EOBT = ['eurocontrol.npp.core.shared.dto.allft.AllFtFieldType', 'EOBT'];
    public static readonly EXEMPTION_REASON_DISTANCE = [
        'eurocontrol.npp.core.shared.dto.allft.AllFtFieldType',
        'EXEMPTION_REASON_DISTANCE',
    ];
    public static readonly EXEMPTION_REASON_TYPE = [
        'eurocontrol.npp.core.shared.dto.allft.AllFtFieldType',
        'EXEMPTION_REASON_TYPE',
    ];
    public static readonly FTFM_EET_FIR_LIST = [
        'eurocontrol.npp.core.shared.dto.allft.AllFtFieldType',
        'FTFM_EET_FIR_LIST',
    ];
    public static readonly FTFM_EET_POINT_LIST = [
        'eurocontrol.npp.core.shared.dto.allft.AllFtFieldType',
        'FTFM_EET_POINT_LIST',
    ];
    public static readonly FTFM_REQ_FL_SPEED_LIST = [
        'eurocontrol.npp.core.shared.dto.allft.AllFtFieldType',
        'FTFM_REQ_FL_SPEED_LIST',
    ];
    public static readonly RTFM_REQ_FL_SPEED_LIST = [
        'eurocontrol.npp.core.shared.dto.allft.AllFtFieldType',
        'RTFM_REQ_FL_SPEED_LIST',
    ];
    public static readonly CTFM_REQ_FL_SPEED_LIST = [
        'eurocontrol.npp.core.shared.dto.allft.AllFtFieldType',
        'CTFM_REQ_FL_SPEED_LIST',
    ];
    public static readonly FLIGHT_TYPE = ['eurocontrol.npp.core.shared.dto.allft.AllFtFieldType', 'FLIGHT_TYPE'];
    public static readonly ORIGINAL_FLIGHT_DATA_QUALITY = [
        'eurocontrol.npp.core.shared.dto.allft.AllFtFieldType',
        'ORIGINAL_FLIGHT_DATA_QUALITY',
    ];
    public static readonly FLIGHT_DATA_QUALITY = [
        'eurocontrol.npp.core.shared.dto.allft.AllFtFieldType',
        'FLIGHT_DATA_QUALITY',
    ];
    public static readonly FLIGHT_SOURCE = ['eurocontrol.npp.core.shared.dto.allft.AllFtFieldType', 'FLIGHT_SOURCE'];
    public static readonly CTFM_ICAO_ROUTE = [
        'eurocontrol.npp.core.shared.dto.allft.AllFtFieldType',
        'CTFM_ICAO_ROUTE',
    ];
}
export interface AllFtFlightDto extends FlightDto {
    ctfmIcaoRoute?: string;
    ctfmReqFlSpeedList?: string;
    estimatedOffBlockTime?: Date;
    exemptionReasonDistance?: string;
    exemptionReasonType?: string;
    flightDataQuality?: FlightDataQuality;
    flightType?: FlightType;
    ftfmEetFirList?: string;
    ftfmEetPointList?: string;
    ftfmReqFlSpeedList?: string;
    initialOffBlockTime?: Date;
    northAtlantic?: boolean;
    originalFlightDataQuality?: FlightDataQuality;
    rtfmReqFlSpeedList?: string;
    source?: FlightSource;
    tactId?: string;
}
export const ALL_FT_FLIGHT_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.allft.AllFtFlightDto';
export interface OpLogEntry {
    etfmsId?: number;
    ifplId?: string;
    issuer?: string;
    message?: string;
    summaryFields?: Array<string>;
    timestamp?: Date;
    type?: OpLogEntryType;
}
export enum OpLogEntryType {
    UNDEFINED = 'UNDEFINED',
    INCOMING_MESSAGE = 'INCOMING_MESSAGE',
    ERRONEOUS_INCOMING_MESSAGE = 'ERRONEOUS_INCOMING_MESSAGE',
    OUTGOING_MESSAGE = 'OUTGOING_MESSAGE',
    VIOLATION = 'VIOLATION',
    HISTORY = 'HISTORY',
    WARNING = 'WARNING',
    PROCESS_ERROR = 'PROCESS_ERROR',
    ERROR_MESSAGE = 'ERROR_MESSAGE',
    ENVIRONMENT_MESSAGE = 'ENVIRONMENT_MESSAGE',
    USER_COMMAND = 'USER_COMMAND',
    TEXT_MESSAGE = 'TEXT_MESSAGE',
}
export interface FlightOpLogEntries {
    flightId?: FlightId;
    opLogEntries?: Array<OpLogEntry>;
}
export interface FlightOpLogEntry {
    flight?: FlightId;
    oplog?: OpLogEntry;
}
export interface OpLogRequestDto {
    dataset?: DatasetDto;
    measureId?: MeasureId;
}
export interface TrafficVolumeScenariosDto {
    scenarios?: Array<string>;
    solutionTvId?: string;
    tvMatchingKind?: ScenarioTvMatchingKind;
}
export enum ScenarioTvMatchingKind {
    INDIRECT_OFFLOAD = 'INDIRECT_OFFLOAD',
    OVERLAPPING_REFERENCE_LOCATION = 'OVERLAPPING_REFERENCE_LOCATION',
    SAME_REFERENCE_LOCATION = 'SAME_REFERENCE_LOCATION',
    SAME_TRAFFIC_VOLUME = 'SAME_TRAFFIC_VOLUME',
}
export enum LevelConstraintKind {
    ABOVE = 'ABOVE',
    BELOW = 'BELOW',
}
export interface MeasureIdAndTvDto {
    measureId?: MeasureId;
    offLoadIds?: Array<string>;
    tvId?: string;
}
export interface ScenarioAllMeasureRetrievalRequestDto extends ScenarioMeasureRetrievalRequestDto {
    mcdmOnlyFields?: Array<McdmOnlyFieldType>;
    regulationFields?: Array<RegulationFieldType>;
    reroutingFields?: Array<ReroutingFieldType>;
}
export const SCENARIO_ALL_MEASURE_RETRIEVAL_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.scenario.ScenarioAllMeasureRetrievalRequestDto';
export interface ScenarioMeasureRetrievalRequestDto {
    clazz?: string;
    adaptedMeasureApplicability?: TimePeriod;
    dataset?: DatasetDto;
    scenarioIds?: Array<string>;
}
export const SCENARIO_MEASURE_RETRIEVAL_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.scenario.ScenarioMeasureRetrievalRequestDto';
export interface ScenarioLevelConstraintDto {
    flightLevel?: FlightLevel;
    from?: Array<DbeOrPublishedPointId>;
    levelConstraintKind?: LevelConstraintKind;
    until?: Array<DbeOrPublishedPointId>;
}
export interface ScenarioMcdmOnlyRetrievalRequestDto extends ScenarioMeasureRetrievalRequestDto {
    fields?: Array<McdmOnlyFieldType>;
}
export const SCENARIO_MCDM_ONLY_RETRIEVAL_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.scenario.ScenarioMcdmOnlyRetrievalRequestDto';
export enum ScenarioPublicationStatus {
    DRAFT = 'DRAFT',
    PUBLISHED = 'PUBLISHED',
}
export interface ScenarioRegulationRetrievalRequestDto extends ScenarioMeasureRetrievalRequestDto {
    fields?: Array<RegulationFieldType>;
}
export const SCENARIO_REGULATION_RETRIEVAL_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.scenario.ScenarioRegulationRetrievalRequestDto';
export interface ScenarioReroutingRetrievalRequestDto extends ScenarioMeasureRetrievalRequestDto {
    fields?: Array<ReroutingFieldType>;
}
export const SCENARIO_REROUTING_RETRIEVAL_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.scenario.ScenarioReroutingRetrievalRequestDto';
export enum ScenarioType {
    AR = 'AR',
    FL = 'FL',
    MIXED = 'MIXED',
    RAD = 'RAD',
    RR = 'RR',
    STAM = 'STAM',
}
export enum WeekDayType {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY',
}
export interface WeeklyScheduleDto {
    weeklyScheduleItems?: Array<WeeklyScheduleItemDto>;
}
export interface WeeklyScheduleItemDto {
    dailyPeriod?: TimePeriod;
    globalPeriod?: TimePeriod;
    weekDays?: DaysOfWeekPresence;
}
export interface ScenarioListRequestDto {
    areaPolygon?: Array<LatLonPoint>;
    concerningTrafficVolumeIds?: Array<string>;
    dataset?: DatasetDto;
    fromPublicationIds?: Array<string>;
    fromScenarioIds?: Array<string>;
    includeCapturedCount?: boolean;
    ownerAnuIds?: Array<string>;
    scenarioModifiedSince?: Date;
    timePeriod?: TimePeriod;
    tvIds?: Array<string>;
}
export interface ScenarioTvCaptureDetails {
    flightCount?: number;
    matchingKind?: ScenarioTvMatchingKind;
}
export interface ScenarioAttributesDto {
    alternativeIcaoRoutePortions?: Array<string>;
    alternativeIcaoRoutePortionsDetails?: Array<Array<IcaoPoint>>;
    applicabilityPeriod?: TimePeriod;
    comments?: string;
    disabledRestrictionIds?: Array<string>;
    from?: string;
    ignoredRestrictionIds?: Array<string>;
    lastModifiedTimeStamp?: Date;
    levelConstraints?: Array<ScenarioLevelConstraintDto>;
    offLoadAirspaceIds?: Array<string>;
    onLoadAirspaceIds?: Array<string>;
    ownerAnuIds?: Array<string>;
    problematicCapturedFlights?: Array<FlightId>;
    publicationId?: string;
    publicationStatus?: ScenarioPublicationStatus;
    scenarioCapturedFlights?: number;
    scenarioEvents?: Array<string>;
    scenarioId?: string;
    scenarioImageFiles?: Array<FileDto>;
    scenarioIncludedInRestrictionIds?: Array<string>;
    scenarioMeasures?: Array<MeasureIdAndTvDto>;
    scenarioPublishedLocations?: Array<RefLocation>;
    scenarioPublishedTrafficVolumeIds?: Array<string>;
    scenarioTvCaptureDetailsByTv?: { [key: string]: ScenarioTvCaptureDetails };
    scenarioType?: ScenarioType;
    scenarioValidationErrorsOrWarnings?: string;
    to?: string;
    weeklyApplicability?: WeeklyScheduleDto;
}
export interface UdppFlightParametersExtendedDto {
    nmProcessOrder?: number;
    params?: UdppFlightParametersDto;
}
export interface UdppFlightParametersDto {
    ifplId?: string;
    priorityValue?: number;
    timeNotAfter?: Date;
    timeNotBefore?: Date;
    udppFlightType?: UdppFlightType;
}
export enum UdppFlightType {
    PROTECT = 'PROTECT',
    MARGIN = 'MARGIN',
    DEFAULT_BASELINE = 'DEFAULT_BASELINE',
    NORMAL = 'NORMAL',
}
export interface QueryUdppReplyDto {
    aircraftOperator?: string;
    udppFlights?: Array<UdppFlightResultsDto>;
}
export interface UdppFlightResultsDto {
    mostPenalisingRegulation?: string;
    newCtot?: Date;
    newSuspensionStatus?: SuspensionStatus;
    regulations?: Array<FlightRegLocation>;
    udppFlightParams?: UdppFlightParametersDto;
    udppStatus?: UdppStatus;
}
export enum UdppStatus {
    After_Cut_Off_Time = 'After_Cut_Off_Time',
    Not_Belonging_To_AO = 'Not_Belonging_To_AO',
    Suspended = 'Suspended',
    Valid = 'Valid',
}
export interface QueryUdppRequestDto {
    aircraftOperator?: string;
    dataset?: DatasetDto;
}
export interface SubmitUdppReplyDto {
    aircraftOperator?: string;
    udppFlights?: Array<UdppFlightResultsDto>;
    whatif?: boolean;
}
export interface SubmitUdppRequestDto {
    aircraftOperator?: string;
    dataset?: DatasetDto;
    udppFlights?: Array<UdppFlightParametersDto>;
    whatif?: boolean;
}
export interface FlightDynamicVolumeCrossing {
    activated?: boolean;
    dynamicVolumeId?: string;
    dynamicVolumeSetId?: string;
    firstEntryDistance?: number;
    firstEntryFlightLevel?: FlightLevel;
    firstEntryTime?: Date;
    firstEntryTrend?: VerticalTrendType;
    lastExitDistance?: number;
    lastExitFlightLevel?: FlightLevel;
    lastExitTime?: Date;
    lastExitTrend?: VerticalTrendType;
    middleTrend?: VerticalTrendType;
    occupancyDistance?: number;
    occupanyInMs?: number;
    volumeSetKind?: DynamicVolumeSetKindEnum;
}
export interface FlightListByAresRequestDto extends FlightListByLocationRequestDto {
    aresVolumeSetId?: string;
    volumeId?: string;
}
export const FLIGHT_LIST_BY_ARES_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.flight.FlightListByAresRequestDto';
export interface FlightListByAtcVolumeRequestDto extends FlightListByLocationRequestDto {
    atcVolumeSetId?: string;
    volumeId?: string;
}
export const FLIGHT_LIST_BY_ATC_VOLUME_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.flight.FlightListByAtcVolumeRequestDto';
export interface FlightOrFlightPlanToRerouteDto {
    adepFreezePoint?: string;
    adesFreezePoint?: string;
    flightPlan?: FlightPlanInputDto;
    forExistingFlight?: FlightKeys;
}
export interface InnoveReroutingSourcesAndConstraintsDto extends ReroutingSourcesAndConstraintsDto {
    sourceAndConstraintsId?: number;
}
export enum InnoveRrtProposalOptionsDto_PathGeneratorEngineTypeEnum {
    INNOVE = 'INNOVE',
    NM = 'NM',
}
export interface InnoveRrtProposalOptionsDto {
    applyCASARegulations?: boolean;
    applySTAMDelay?: boolean;
    discardAlternativeTrajectoryWithEnRouteRegulations?: boolean;
    ifpsErrorsOff?: AllowedIfpsErrorViolations;
    nbRoutesPerReroutingSources?: number;
    pathGeneratorEngine?: InnoveRrtProposalOptionsDto_PathGeneratorEngineTypeEnum;
}
export interface MultiRerouteProposalRequestDto {
    datasetDto?: DatasetDto;
    flightModelType?: TrafficType;
    flightOrFlightPlans?: Array<FlightOrFlightPlanToRerouteDto>;
    numberOfRoutesPerReroutingSources?: number;
    requestedFlightFields?: Array<FlightFieldType>;
    sourcesAndConstraints?: Array<InnoveReroutingSourcesAndConstraintsDto>;
}
export interface MultiRerouteProposalReplyDto {
    ifpsErrors?: Array<IfpsError>;
    results?: Array<RerouteProposalsReplyDto>;
}
export interface RerouteProposalsReplyDto {
    aircraftType?: string;
    callsign?: string;
    estimatedTakeOffTime?: Date;
    originalRoute?: RerouteProposalInfoDto;
    proposedRoutes?: Array<RerouteProposalInfoDto>;
}
export interface RerouteProposalInfoDto {
    durationInMin?: number;
    flight?: FlightDto;
    overloadedTvIds?: Array<string>;
    reroutingFlightRouteId?: ReroutingRouteIdDto;
    routeErrors?: Array<IfpsError>;
    sourceAndConstraintsId?: number;
}
export enum DynamicVolumeSetKindEnum {
    ARES_RESERVATION = 'ARES_RESERVATION',
    ATC_VOLUME_DEFINITION = 'ATC_VOLUME_DEFINITION',
}
export interface DynamicVolumeActivationFlexibilityDto {
    flexibleActivationTime?: TimePeriod;
    minimumActivationDuration?: number;
}
export interface DynamicVolumeDto {
    definition?: Volume4DDefinitionDto;
    flexibility?: DynamicVolumeFlexibilityDto;
    id?: string;
    negotiable?: boolean;
    rank?: number;
    uuid?: string;
}
export interface Volume4DDefinitionDto {
    activationTime?: TimePeriod;
    closestPointOnReference?: LatLonPoint;
    closestPointToReference?: LatLonPoint;
    levelBand?: FlightLevelBand;
    referenceAirspaceId?: string;
    shape?: Array<LatLonPoint>;
}
export interface DynamicVolumeFlexibilityDto {
    activationFlexibility?: DynamicVolumeActivationFlexibilityDto;
    levelBandFlexibility?: DynamicVolumeLevelBandFlexibilityDto;
    positionFlexibility?: DynamicVolumePositionFlexibilityDto;
}
export interface DynamicVolumeLevelBandFlexibilityDto {
    flexibleLevelBand?: FlightLevelBand;
    minimumLevelBandSize?: number;
}
export interface DynamicVolumePositionFlexibilityDto {
    endBearingFromReferencePoint?: number;
    maximumDistanceToReferencePointInNM?: number;
    minimumDistanceToReferencePointInNM?: number;
    referencePoint?: FlexibilityReferencePointIdDto;
    startBearingFromReferencePoint?: number;
}
export interface FlexibilityReferencePointIdDto {
    aerodrome?: Aerodrome;
    dynamicVolumeId?: string;
    geographicPosition?: LatLonPoint;
    point?: IcaoPoint;
}
export interface DynamicVolumeOverlapWarningDto {
    dynamicVolumeInOtherSet?: Array<string>;
    otherDynamicVolumeSetId?: string;
    otherDynamicVolumeSetKind?: DynamicVolumeSetKindEnum;
}
export interface DynamicVolumeSetDto {
    creatingUser?: string;
    dataId?: string;
    dataset?: DatasetDto;
    description?: string;
    flexibilityWarning?: DynamicVolumeSetFlexibilityWarningDto;
    id?: string;
    kind?: DynamicVolumeSetKindEnum;
    lastUpdatingUser?: string;
    overlapWarning?: DynamicVolumeSetOverlapWarningDto;
    status?: DynamicVolumeSetStatusEnum;
    statusHistory?: Array<DynamicVolumeSetStatusHistoryEntryDto>;
    timestamp?: Date;
    uuid?: string;
    volume?: Array<DynamicVolumeDto>;
}
export interface DynamicVolumeSetFlexibilityWarningDto {
    activationDurationViolation?: boolean;
    bearingEndViolation?: boolean;
    bearingStartViolation?: boolean;
    distanceFromReferenceViolation?: boolean;
    earliestStartTimeViolation?: boolean;
    latestEndTimeViolation?: boolean;
    levelBandSizeViolation?: boolean;
    maxFlightLevelViolation?: boolean;
    minFlightLevelViolation?: boolean;
}
export enum DynamicVolumeSetStatusEnum {
    INTENT = 'INTENT',
    DRAFT = 'DRAFT',
    FINAL = 'FINAL',
    CANCELLED = 'CANCELLED',
}
export interface DynamicVolumeSetOverlapWarningDto {
    warning?: Array<DynamicVolumeOverlapWarningDto>;
}
export interface DynamicVolumeSetStatusHistoryEntryDto {
    status?: DynamicVolumeSetStatusEnum;
    timestamp?: Date;
}
export interface AbstractDynamicVolumeSetListReplyDto {
    clazz?: string;
    datasetDto?: DatasetDto;
    volumeSet?: Array<DynamicVolumeSetDto>;
}
export const ABSTRACT_DYNAMIC_VOLUME_SET_LIST_REPLY_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.asm.reply.AbstractDynamicVolumeSetListReplyDto';
export interface AbstractDynamicVolumeSetReplyDto {
    clazz?: string;
    volumeSet?: DynamicVolumeSetDto;
}
export const ABSTRACT_DYNAMIC_VOLUME_SET_REPLY_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.asm.reply.AbstractDynamicVolumeSetReplyDto';
export interface AresVolumeSetCreationReplyDto extends AbstractDynamicVolumeSetReplyDto {}
export const ARES_VOLUME_SET_CREATION_REPLY_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.asm.reply.AresVolumeSetCreationReplyDto';
export interface AresVolumeSetListReplyDto extends AbstractDynamicVolumeSetListReplyDto {}
export const ARES_VOLUME_SET_LIST_REPLY_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.asm.reply.AresVolumeSetListReplyDto';
export interface AresVolumeSetUpdateReplyDto extends AbstractDynamicVolumeSetReplyDto {}
export const ARES_VOLUME_SET_UPDATE_REPLY_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.asm.reply.AresVolumeSetUpdateReplyDto';
export interface AresVolumeSetVerificationReplyDto extends AbstractDynamicVolumeSetReplyDto {}
export const ARES_VOLUME_SET_VERIFICATION_REPLY_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.asm.reply.AresVolumeSetVerificationReplyDto';
export interface AtcVolumeSetCreationReplyDto extends AbstractDynamicVolumeSetReplyDto {}
export const ATC_VOLUME_SET_CREATION_REPLY_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.asm.reply.AtcVolumeSetCreationReplyDto';
export interface AtcVolumeSetListReplyDto extends AbstractDynamicVolumeSetListReplyDto {}
export const ATC_VOLUME_SET_LIST_REPLY_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.asm.reply.AtcVolumeSetListReplyDto';
export interface AtcVolumeSetUpdateReplyDto extends AbstractDynamicVolumeSetReplyDto {}
export const ATC_VOLUME_SET_UPDATE_REPLY_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.asm.reply.AtcVolumeSetUpdateReplyDto';
export interface AbstractDynamicVolumeSetListRequestDto extends AbstractRequest {
    creatingUser?: string;
    datasetAndDay?: DatasetAndDayDto;
    dynamicVolumeSetId?: string;
    lastUpdatingUser?: string;
    timestamp?: Date;
    volumeSetStatus?: Array<DynamicVolumeSetStatusEnum>;
}
export const ABSTRACT_DYNAMIC_VOLUME_SET_LIST_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.asm.request.AbstractDynamicVolumeSetListRequestDto';
export interface AbstractDynamicVolumeSetRequestDto extends AbstractRequest {
    volumeSet?: DynamicVolumeSetDto;
}
export const ABSTRACT_DYNAMIC_VOLUME_SET_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.asm.request.AbstractDynamicVolumeSetRequestDto';
export interface AresVolumeSetCreationRequestDto extends AbstractDynamicVolumeSetRequestDto {}
export const ARES_VOLUME_SET_CREATION_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.asm.request.AresVolumeSetCreationRequestDto';
export interface AresVolumeSetListRequestDto extends AbstractDynamicVolumeSetListRequestDto {}
export const ARES_VOLUME_SET_LIST_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.asm.request.AresVolumeSetListRequestDto';
export interface AresVolumeSetUpdateRequestDto extends AbstractDynamicVolumeSetRequestDto {}
export const ARES_VOLUME_SET_UPDATE_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.asm.request.AresVolumeSetUpdateRequestDto';
export interface AresVolumeSetVerificationRequestDto extends AbstractDynamicVolumeSetRequestDto {}
export const ARES_VOLUME_SET_VERIFICATION_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.asm.request.AresVolumeSetVerificationRequestDto';
export interface AtcVolumeSetCreationRequestDto extends AbstractDynamicVolumeSetRequestDto {}
export const ATC_VOLUME_SET_CREATION_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.asm.request.AtcVolumeSetCreationRequestDto';
export interface AtcVolumeSetListRequestDto extends AbstractDynamicVolumeSetListRequestDto {}
export const ATC_VOLUME_SET_LIST_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.asm.request.AtcVolumeSetListRequestDto';
export interface AtcVolumeSetUpdateRequestDto extends AbstractDynamicVolumeSetRequestDto {}
export const ATC_VOLUME_SET_UPDATE_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.innove.asm.request.AtcVolumeSetUpdateRequestDto';
export interface KPITargetDto {
    dataSource?: PlanDataSourceType;
    metricType?: MetricsTypeEnum;
    target?: number;
    targetType?: KPITargetTypeEnum;
}
export enum KPITargetTypeEnum {
    MAX = 'MAX',
    TOTAL = 'TOTAL',
    AVERAGE = 'AVERAGE',
}
export interface KPITargetsPlanDto extends TacticalPlan {
    airspaceId?: string;
    targets?: Array<KPITargetDto>;
}
export const K_P_I_TARGETS_PLAN_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.innove.kpi.target.KPITargetsPlanDto';
export interface KPITargetsPlanRetrievalRequestDto {
    airspace?: string;
    datasetAndDay?: DatasetAndDayDto;
}
export interface KPITargetsPlanUpdateRequestDto {
    plan?: KPITargetsPlanDto;
}
export enum MetricsTypeEnum {
    EXTRAFUEL = 'EXTRAFUEL',
    DELAY = 'DELAY',
    ROUTE_EXTENSION = 'ROUTE_EXTENSION',
}
export interface MetricsDto {
    maxPerFlight?: number;
    numberOfFlights?: number;
    total?: number;
    type?: MetricsTypeEnum;
}
export interface TrafficMetricsByAirspaceReplyDto extends TrafficMetricsReplyDto {
    airspace?: string;
    calculationType?: CountType;
}
export interface TrafficMetricsReplyDto {
    dataset?: DatasetDto;
    metrics?: Array<MetricsDto>;
    trafficType?: TrafficType;
}
export interface TrafficMetricsByAirspaceRequestDto extends TrafficMetricsRequestDto {
    airspace?: string;
    calculationType?: CountType;
}
export interface TrafficMetricsRequestDto {
    dataset?: DatasetDto;
    includeProposalFlights?: boolean;
    metricTypes?: Array<MetricsTypeEnum>;
    trafficType?: TrafficType;
}
export interface BackboneDto extends TacticalPlan {
    airspaceId?: string;
    schedule?: Array<BackbonePlannedResourcesDto>;
}
export const BACKBONE_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.innove.rnest.BackboneDto';
export interface BackbonePlannedResourcesDto {
    applicabilityPeriod?: TimePeriod;
    datasource?: PlanDataSourceType;
    numberControlPositions?: number;
}
export interface BackboneRetrievalRequestDto {
    airspaceId?: string;
    dataset?: DatasetDto;
    day?: Date;
}
export interface BackboneUpdateRequestDto {
    backbone?: BackboneDto;
}
export enum CountingMethodDto_CountsType {
    ENTRY = 'ENTRY',
    OCCUPANCY = 'OCCUPANCY',
    WORKLOAD = 'WORKLOAD',
}
export interface CountingMethodDto {
    countMethod?: CountingMethodDto_CountsType;
    entryCountTimeStepInMin?: number;
    monitorOneMinuteBorderConflict?: number;
    monitorOneMinuteClimbing?: number;
    monitorOneMinuteCruising?: number;
    monitorOneMinuteDescending?: number;
    monitorOneMinuteInternalConflict?: number;
    nbTriggeringOverload?: number;
    occupancyObservationDurationInMin?: number;
    occupancyTimeStepInMin?: number;
    sustainedEvaluationPeriodInMin?: number;
    workloadCountTimeStepInMin?: number;
}
export interface FRAReroutingCreationRequestDto {
    airspaceId?: string;
    datasetAndDay?: DatasetAndDayDto;
}
export interface ReroutingMetricsDto {
    numberConflicts?: number;
    totalFlightDuration?: number;
    totalFuelConsumption?: number;
    totalRouteLength?: number;
}
export interface FlightReroutedMetrics {
    estimatedElapsedTimeInMsAfter?: number;
    estimatedElapsedTimeInMsBefore?: number;
    flightId?: FlightId;
    routeLenghtBefore?: number;
    routeLengthAfter?: number;
}
export interface FRAReroutingResultsRetrievalRequestDto {
    futureResultId?: string;
}
export interface OptimisationParametersDto {
    backboneConstraint?: OsBackboneConstraintEnum;
    maxNbOpenedSectors?: number;
    minConfigDurationInMin?: number;
    minSectorDurationInMin?: number;
    openedSectorsMonitored?: boolean;
}
export enum OsBackboneConstraintEnum {
    UPTOBACKBONE = 'UPTOBACKBONE',
    ATBACKBONE = 'ATBACKBONE',
    UNLIMITED = 'UNLIMITED',
}
export interface OptimiseDMALocationRequestDto {
    airspaceId?: string;
    datasetAndDay?: DatasetAndDayDto;
    dynamicVolumeId?: string;
    dynamicVolumeSetId?: string;
}
export interface OptimiseDMALocationResultsRetrievalReplyDto {}
export interface OptimiseDMALocationResultsRetrievalRequestDto {
    futureResultId?: string;
}
export interface OptimiseSectorConfigurationPlanRequestDto {
    airspaceId?: string;
    countingMethodology?: CountingMethodDto;
    datasetAndDay?: DatasetAndDayDto;
    optimisationStrategy?: OptimisationParametersDto;
}
export interface OptimiseSectorConfigurationPlanResultsRetrievalRequestDto {
    futureResultId?: string;
}
export interface FRAReroutingResultsRetrievalReplyDto {
    afterRerouting?: ReroutingMetricsDto;
    airspaceId?: string;
    beforeRerouting?: ReroutingMetricsDto;
    dataset?: DatasetDto;
    numberRerouted?: number;
    reroutedFlightMetrics?: { [key: string]: FlightReroutedMetrics };
    reroutedFlights?: Array<FlightId>;
    trafficType?: TrafficType;
}
export interface ComplexityPerFlightDto {
    applicabilityPeriod?: TimePeriod;
    complexity?: Array<ComplexitySharingDto>;
    flightId?: FlightId;
    tvId?: string;
}
export interface ComplexitySharingDto {
    colour?: ComplexitySharingColourEnum;
    type?: ComplexiySharingTypeEnum;
    value?: number;
}
export enum ComplexiySharingTypeEnum {
    ABSOLUTE = 'ABSOLUTE',
    RELATIVE = 'RELATIVE',
}
export enum ComplexitySharingColourEnum {
    RED = 'RED',
    ORANGE = 'ORANGE',
    YELLOW = 'YELLOW',
    GREEN = 'GREEN',
}
export interface ComplexitySharingReplyDto {
    complexity?: Array<ComplexityPerTrafficVolumeDto>;
}
export interface ComplexitySharingUpdateReplyDto {
    complexity?: ComplexityPerTrafficVolumeDto;
}
export interface ComplexitySharingRequestDto {
    applicabilityPeriod?: TimePeriod;
    tvId?: string;
}
export interface ComplexitySharingUpdateRequestDto {
    applicabilityPeriod?: TimePeriod;
    complexity?: Array<ComplexitySharingDto>;
    complexityPerFlight?: Array<ComplexityPerFlightDto>;
    tvId?: string;
}
export interface ComplexityPerTrafficVolumeDto {
    applicabilityPeriod?: TimePeriod;
    complexity?: ComplexitySharingDto;
    complexityPerFlight?: Array<ComplexityPerFlightDto>;
    tvId?: string;
}
export enum LoadClassification {
    UNDEFINED = 'UNDEFINED',
    COLD = 'COLD',
    NORMAL = 'NORMAL',
    LOW_THRESHOLD = 'LOW_THRESHOLD',
    HIGH_THRESHOLD = 'HIGH_THRESHOLD',
    OVERLOAD = 'OVERLOAD',
}
export interface MonitoredOccupancyLoadValues {
    durationInMin?: number;
    hotSpotPeriods?: Array<TimePeriod>;
    occupancyLoadValues?: Array<MonitoredLoadValue>;
}
export interface MonitoredLoadValue {
    loadClassification?: LoadClassification;
    nonRelevant?: boolean;
    timePeriod?: TimePeriod;
}
export interface SimpleMonitoredTv {
    countType?: CountType;
    hotSpotPeriods?: Array<TimePeriod>;
    loadValues?: Array<MonitoredLoadValue>;
    regulatedPeriods?: Array<TimePeriod>;
    timeRange?: TimeRange;
    tvId?: string;
}
export interface SimpleMonitoredTvWithProposal extends SimpleMonitoredTv {
    proposalLoadValues?: Array<MonitoredLoadValue>;
}
export interface AbstractMonitored {
    refLocation?: MonitoredRefLocation;
}
export interface MonitoredRefLocation {
    id?: string;
    type?: MonitoredLocationType;
}
export enum MonitoredLocationType {
    TV = 'TV',
    REG = 'REG',
    TV_GROUP = 'TV_GROUP',
}
export interface AirspaceMonitorDto {
    monitoredAtcConfigs?: Array<MonitoredAtcConfiguration>;
    monitoredRegulations?: Array<MonitoredRegulation>;
    summaryMonitoredRegulation?: MonitoredRegulation;
    timePeriod?: TimePeriod;
}
export interface MonitoredAtcConfiguration extends MonitoredTvGroup {}
export interface MonitoredTvGroup {
    id?: string;
    monitoredTvs?: Array<MonitoredTv>;
    summaryMonitoredTv?: MonitoredTv;
}
export interface MonitoredRegulation extends AbstractMonitored {
    cancelledTime?: Date;
    delayValues?: Array<MonitoredDelayValue>;
    totalDelay?: number;
}
export interface MonitoredDelayValue {
    delayClassification?: AverageDelayClassification;
    timePeriod?: TimePeriod;
}
export enum AverageDelayClassification {
    LESS_THAN_15 = 'LESS_THAN_15',
    LESS_THAN_30 = 'LESS_THAN_30',
    LESS_THAN_45 = 'LESS_THAN_45',
    GREATHER_THAN_45 = 'GREATHER_THAN_45',
}
export interface MonitoredTv extends AbstractMonitored {
    loadValues?: Array<MonitoredLoadValue>;
    occupancyLoadValues?: Array<MonitoredOccupancyLoadValues>;
    regulatedPeriods?: Array<TimePeriod>;
}
export interface AirspaceMonitorRequest extends AbstractFlightRelatedRequest {
    atcConfigIds?: Array<string>;
    auaOrClusterId?: string;
    capacityModel?: CapacityModel;
    entryCountsAlgorithm?: CountsAlgorithm;
    includeForecastFlights?: boolean;
    monitorableTvsOnly?: boolean;
    occupancyCountsAlgorithm?: CountsAlgorithm;
    timePeriod?: TimePeriod;
    tvFilterList?: Array<string>;
}
export const AIRSPACE_MONITOR_REQUEST_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.traffic.monitor.AirspaceMonitorRequest';
export interface MonitoredTvSet extends MonitoredTvGroup {
    monitoredRegulations?: Array<MonitoredRegulation>;
    summaryMonitoredRegulation?: MonitoredRegulation;
}
export interface TrafficMonitorDto {
    monitoredTvSets?: Array<MonitoredTvSet>;
    timePeriod?: TimePeriod;
}
export interface TrafficMonitorRequest extends AbstractFlightRelatedRequest {
    adhocTvList?: Array<string>;
    capacityModel?: CapacityModel;
    entryCountsAlgorithm?: CountsAlgorithm;
    includeForecastFlights?: boolean;
    occupancyCountsAlgorithm?: CountsAlgorithm;
    timePeriod?: TimePeriod;
    tvSetList?: Array<string>;
}
export const TRAFFIC_MONITOR_REQUEST_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.traffic.monitor.TrafficMonitorRequest';
export interface TvSetActivationReply_TvActivation {
    activePeriods?: Array<TimePeriod>;
    occupancyDurationsInMin?: Array<number>;
    tvId?: string;
}
export interface TvSetActivationReply {
    request?: TvSetActivationRequestDto;
    tvActivations?: Array<TvSetActivationReply_TvActivation>;
}
export interface TvSetActivationRequestDto {
    dataset?: DatasetDto;
    determineOtmvDurations?: boolean;
    ensureHourlyCapacityExists?: boolean;
    timePeriod?: TimePeriod;
    tvSetIds?: Array<string>;
}
export interface NiaImpactOnTv {
    countType?: CountType;
    deltaCounts?: Array<TvDeltaCounts>;
    durationInMin?: number;
    intervalInMin?: number;
    tvId?: string;
}
export interface NiaImpactOnHotspot {
    deltaCounts?: Array<TvDeltaCounts>;
    hotspotId?: HotspotId;
    hotspotKind?: HotspotKind;
}
export interface TvDeltaCounts extends DeltaCountsDto {
    timePeriod?: TimePeriod;
}
export interface DeltaCountsDto {
    alertsAfter?: Array<OtmvAlert>;
    alertsBefore?: Array<OtmvAlert>;
    entryCapacity?: number;
    totalCountsAfter?: Array<number>;
    totalCountsBefore?: Array<number>;
}
export interface ConcernedRegulationTimeOverDto {
    excluded?: boolean;
    exempted?: boolean;
    exitTime?: Date;
    timeOver?: Date;
    timeOverInRegPeriod?: TargetTimeDto_IntervalPosition;
}
export interface DeltaAtfcmSituationCountsDto {
    afterSlotDepartureFlightDeltaCount?: SignificantDeltaCountDto;
    airborneFlightDeltaCount?: SignificantDeltaCountDto;
    atfmMeasureSuspendedFlightDeltaCount?: SignificantDeltaCountDto;
    beforeSlotDepartureFlightDeltaCount?: SignificantDeltaCountDto;
    delayedFlightDeltaCount?: SignificantDeltaCountDto;
    expectedFlightDeltaCount?: SignificantDeltaCountDto;
    famSuspendedFlightDeltaCount?: SignificantDeltaCountDto;
    forecastFlightDeltaCount?: SignificantDeltaCountDto;
    landedFlightDeltaCount?: SignificantDeltaCountDto;
    significantlyDelayedFlightDeltaCount?: SignificantDeltaCountDto;
    slotCompliantFlightDeltaCount?: SignificantDeltaCountDto;
    undefinedSlotComplianceFlightDeltaCount?: SignificantDeltaCountDto;
}
export interface SignificantDeltaCountDto {
    afterCount?: number;
    beforeCount?: number;
    significantChange?: boolean;
}
export interface DeltaAtfcmSituationDelaysDto_ReasonDelay {
    delay?: SignificantDeltaDurationDto;
    reason?: RegulationReasonType;
}
export interface DeltaAtfcmSituationDelaysDto {
    airportDelay?: SignificantDeltaDurationDto;
    enRouteDelay?: SignificantDeltaDurationDto;
    reasonDelays?: Array<DeltaAtfcmSituationDelaysDto_ReasonDelay>;
}
export interface SignificantDeltaDurationDto {
    afterInMin?: number;
    beforeInMin?: number;
    significantChange?: boolean;
}
export interface DeltaAtfcmSituationDto {
    countChanges?: DeltaAtfcmSituationCountsDto;
    delayChanges?: DeltaAtfcmSituationDelaysDto;
    regulationChanges?: Array<DeltaAtfcmSituationRegulationDto>;
}
export interface DeltaAtfcmSituationRegulationDto {
    afterSituation?: AtfcmSituationRegulation;
    beforeDelayInMin?: number;
    beforeImpactedFlightCount?: number;
    significantChange?: boolean;
}
export interface NetworkImpactAssessmentDto {
    atfcmSituationChanges?: DeltaAtfcmSituationDto;
    flightChanges?: Array<NetworkImpactAssessmentFlightChangesDto>;
    lastUpdated?: Date;
    tvImpacts?: Array<NiaImpactOnTv>;
}
export interface NetworkImpactAssessmentFlightChangesDto {
    afterFlightData?: NetworkImpactFlightDataDto;
    beforeFlightData?: NetworkImpactFlightDataDto;
    concernedRegulations?: Array<NetworkImpactFlightRegulationChangeDto>;
    flightKeys?: FlightKeys;
    topicId?: string;
}
export interface NetworkImpactFlightDataDto {
    calculatedTakeOffTime?: Date;
    errorsAndWarnings?: Array<string>;
    ifpsErrors?: Array<IfpsError>;
    mostPenalisingRegulation?: string;
    readyEstimatedOffBlockTime?: Date;
    suspensionStatus?: SuspensionStatus;
}
export interface NetworkImpactFlightRegulationChangeDto {
    afterRegulationSpecificErrorsAndWarnings?: Array<string>;
    afterTimeOver?: ConcernedRegulationTimeOverDto;
    beforeRegulationSpecificErrorsAndWarnings?: Array<string>;
    beforeTimeOver?: ConcernedRegulationTimeOverDto;
    regulationId?: string;
}
export interface NetworkImpactAssessmentFilterDto {
    additionalTvIds?: Array<string>;
    tvIds?: Array<string>;
    tvSetIds?: Array<string>;
}
export enum NetworkImpactAssessmentKind {
    FOR_EHELPDESK_TICKETS = 'FOR_EHELPDESK_TICKETS',
    FOR_MEASURE_MODIFICATION = 'FOR_MEASURE_MODIFICATION',
    FROM_INITIAL_SIMULATION_STATE = 'FROM_INITIAL_SIMULATION_STATE',
}
export interface NetworkImpactAssessmentPayloadDto {
    computeFlightsChanges?: boolean;
    computeOtmvAlerts?: boolean;
}
export interface NetworkImpactAssessmentRetrievalRequestDto {
    dataset?: DatasetDto;
    filter?: NetworkImpactAssessmentFilterDto;
    forMeasure?: MeasureId;
    kind?: NetworkImpactAssessmentKind;
    payload?: NetworkImpactAssessmentPayloadDto;
}
export interface AtfcmSituationRegulation {
    delayInMin?: number;
    impactedFlightCount?: number;
    protectedAerodrome?: string;
    reason?: RegulationReasonType;
    regulId?: string;
    state?: RegulationState;
    timePeriod?: TimePeriod;
    tvId?: string;
}
export interface AtfcmSituationCounts {
    afterSlotDepartureFlightCount?: number;
    airborneFlightCount?: number;
    atfmMeasureSuspendedFlightCount?: number;
    beforeSlotDepartureFlightCount?: number;
    delayedFlightCount?: number;
    expectedFlightCount?: number;
    famSuspendedFlightCount?: number;
    forecastFlightCount?: number;
    landedFlightCount?: number;
    significantlyDelayedFlightCount?: number;
    slotCompliantFlightCount?: number;
    undefinedSlotComplianceFlightCount?: number;
}
export interface AtfcmSituationDelays_ReasonDelay {
    delayInMin?: number;
    reason?: RegulationReasonType;
}
export interface AtfcmSituationDelays {
    airportDelayInMin?: number;
    enRouteDelayInMin?: number;
    reasonDelays?: Array<AtfcmSituationDelays_ReasonDelay>;
}
export interface AtfcmSituationDto {
    counts?: AtfcmSituationCounts;
    delays?: AtfcmSituationDelays;
    lastUpdated?: Date;
    regulations?: Array<AtfcmSituationRegulation>;
}
export interface AtfcmSituationRequestDto {
    dataset?: DatasetDto;
    day?: Date;
}
export interface AccMonitorRequest {
    algorithm?: CountsAlgorithm;
    anuId?: string;
    capacityModel?: CapacityModel;
    comparisonFlightFields?: Array<FlightFieldType>;
    dataset?: DatasetDto;
    flightFields?: Array<FlightFieldType>;
    foreignMeasureId?: string;
    includeForecastFlights?: boolean;
    mcdmOnlyFields?: Array<McdmOnlyFieldType>;
    measureMcdmTopicFields?: Array<McdmTopicFieldType>;
    proposalContexts?: Array<string>;
    regulationFields?: Array<RegulationFieldType>;
    regulationProposalFields?: Array<RegulationProposalFieldType>;
    reroutingFields?: Array<ReroutingFieldType>;
    selectedTvs?: Array<AccTvSelection>;
    subtotals?: CountSubtotalsType;
    timePeriod?: TimePeriod;
    trafficTypes?: Array<TrafficType>;
    tvSetIds?: Array<string>;
}
export interface AccMonitorTrafficAlert {
    averageOverBarThreshold?: number;
    flightIds?: Array<FlightId>;
    numAlertingCountBars?: number;
}
export interface AccTvSelection {
    countType?: CountType;
    durationInMin?: number;
    intervalInMin?: number;
    tvId?: string;
}
export interface AccMonitorReply {
    request?: AccMonitorRequest;
    tvDataList?: Array<AccMonitorTvData>;
    tvSetEditableMeasures?: Array<MeasureAndTopic>;
    tvSetRegulations?: Array<string>;
}
export interface AccMonitorTvData {
    countsAndFlights?: TrafficCountsAndFlightListComparisonDto;
    monitoredTv?: SimpleMonitoredTv;
    trafficAlert?: AccMonitorTrafficAlert;
}
export interface CometaComplexity {
    complexityCounts?: Array<TimeSliceComplexityData>;
    overallFlightComplexity?: Array<FlightComplexity>;
}
export interface FlightComplexity {
    complexity?: number;
    complexityFactors?: Array<FlightComplexityFactor>;
    flight?: FlightId;
}
export interface TimeSliceComplexityData {
    contributionFactors?: Array<TimeSliceSubComplexityData>;
    flightsComplexity?: Array<FlightContributionComplexity>;
    total?: number;
}
export interface FlightContributionComplexity {
    contribution?: number;
    flight?: FlightId;
}
export interface TimeSliceSubComplexityData {
    factorName?: string;
    flightContributionList?: Array<FlightContributionComplexity>;
    total?: number;
}
export interface FlightComplexityFactor {
    complexity?: number;
    factorName?: string;
}
export interface CometaComplexityRequestDto extends AbstractFlightRelatedRequest {
    countType?: CountType;
    durationInMin?: number;
    fields?: Array<FlightFieldType>;
    intervalInMin?: number;
    tcRequest?: TrafficCountsRequestDto;
    timePeriod?: TimePeriod;
    trafficType?: TrafficType;
    tvId?: string;
}
export const COMETA_COMPLEXITY_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.traffic.cometa.CometaComplexityRequestDto';
export interface CometaComplexityReplyDto {
    complexity?: CometaComplexity;
    complexityFactors?: Array<string>;
    counts?: TrafficCountsDto;
    flights?: Array<FlightDto>;
    timeRange?: TimeRange;
}
export interface FlightImpactAssessmentRequest extends AbstractFlightRelatedRequest {
    algorithm?: CountsAlgorithm;
    capacityModel?: CapacityModel;
    flightId?: FlightId;
    includeForecastFlights?: boolean;
    loadingCalculation?: LoadingCalculationApproach;
    searchFromTime?: Date;
    searchScope?: ImpactSearchScope;
    tvSetId?: string;
}
export const FLIGHT_IMPACT_ASSESSMENT_REQUEST_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.traffic.fia.FlightImpactAssessmentRequest';
export enum FlightTvOverloadClassification {
    MEASURE = 'MEASURE',
    HOTSPOT = 'HOTSPOT',
    OVERLOAD_WORSENING = 'OVERLOAD_WORSENING',
    OVERLOAD_NOT_WORSENING = 'OVERLOAD_NOT_WORSENING',
    NO_OVERLOAD = 'NO_OVERLOAD',
}
export enum LoadingCalculationApproach {
    ENTRY_ONLY = 'ENTRY_ONLY',
    OCCUPANCY_FIRST = 'OCCUPANCY_FIRST',
    ENTRY_AND_OCCUPANCY = 'ENTRY_AND_OCCUPANCY',
}
export enum ImpactSearchScope {
    EFFICIENT = 'EFFICIENT',
    EXHAUSTIVE = 'EXHAUSTIVE',
}
export enum FlightNoGoZonesRequest_NoGoZoneTimeReference {
    ETOT = 'ETOT',
    FPL_EOBT = 'FPL_EOBT',
}
export interface FlightNoGoZonesRequest extends AbstractFlightRelatedRequest {
    flightId?: FlightId;
    futureOnly?: boolean;
    includeHotspots?: boolean;
    timeReference?: FlightNoGoZonesRequest_NoGoZoneTimeReference;
}
export const FLIGHT_NO_GO_ZONES_REQUEST_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.traffic.fia.FlightNoGoZonesRequest';
export interface FlightImpactAssessment {
    hotspots?: Array<FlightHotspotLoc>;
    measureLocations?: Array<FlightAtfcmMeasureLoc>;
    measures?: Array<MeasureDto>;
    mostPenalisingRegulation?: string;
    request?: FlightImpactAssessmentRequest;
    tvImpacts?: Array<FlightTvImpact>;
}
export enum FlightNoGoZone_NoGoZoneType {
    HOTSPOT = 'HOTSPOT',
    REGULATION = 'REGULATION',
    REROUTING = 'REROUTING',
}
export interface FlightNoGoZone {
    hotspot?: HotspotDto;
    noGoPeriod?: TimePeriod;
    regulationSituation?: AtfcmSituationRegulation;
    rerouting?: ReroutingDto;
    tvRefLocation?: TvRefLocation;
}
export interface FlightNoGoZones {
    currentlyUsedTaxiTimeInMs?: number;
    flightId?: FlightId;
    noGoZones?: Array<FlightNoGoZone>;
    referenceTime?: Date;
    taxiTimeInMs?: number;
}
export interface FlightTvImpact {
    entryExitTime?: TimePeriod;
    monitoredTv?: SimpleMonitoredTvWithProposal;
    overloadClassification?: FlightTvOverloadClassification;
    proposalEntryExitTime?: TimePeriod;
    refLocation?: TvRefLocation;
    summaryLoadClassification?: LoadClassification;
    summaryProposalLoadClassification?: LoadClassification;
    tvId?: string;
}
export interface NidRequest {
    algorithm?: CountsAlgorithm;
    capacityModel?: CapacityModel;
    countFlightFields?: Array<FlightFieldType>;
    dataset?: DatasetDto;
    day?: Date;
    includeForecastFlights?: boolean;
    measureFlightFields?: Array<FlightFieldType>;
    measureId?: MeasureId;
    tvSetId?: string;
    whatIfFlightsOnly?: boolean;
}
export interface TvSetImpactedPeriodRequest {
    dataset?: DatasetDto;
    day?: Date;
    flightId?: FlightId;
    includeForecastFlights?: boolean;
    measureId?: MeasureId;
    proposalContexts?: Array<string>;
    tvSetIds?: Array<string>;
}
export interface NidReply_NidFlightData {
    flight?: FlightDto;
    worstClassification?: LoadClassification;
    worstTvId?: string;
}
export interface NidReply {
    regulationFlights?: Array<NidReply_NidFlightData>;
    tvDataList?: Array<NidTvData>;
}
export interface NidTvData {
    countsAndFlights?: TrafficCountsAndFlightListComparisonDto;
    monitoredTv?: SimpleMonitoredTvWithProposal;
}
export enum AtvFlightStatusInbound {
    AIR = 'AIR',
    CNX = 'CNX',
    DBC = 'DBC',
    DBR = 'DBR',
    DIV = 'DIV',
    FIR = 'FIR',
    FNL = 'FNL',
    GOA = 'GOA',
    IBK = 'IBK',
    IDH = 'IDH',
    INI = 'INI',
    SCH = 'SCH',
    TMA = 'TMA',
    TXI = 'TXI',
}
export enum ImpactSeverityIndicator {
    E = 'E',
    EI = 'EI',
    L = 'L',
    LI = 'LI',
    LIP = 'LIP',
    OT = 'OT',
}
export enum AtvFlightStatusOutbound {
    BRC = 'BRC',
    BRD = 'BRD',
    CNX = 'CNX',
    DEI = 'DEI',
    DEP = 'DEP',
    INI = 'INI',
    OBK = 'OBK',
    RDI = 'RDI',
    RDY = 'RDY',
    RET = 'RET',
    RPO = 'RPO',
    RTN = 'RTN',
    SCH = 'SCH',
    TXD = 'TXD',
}
export interface ApiReplyDto extends FlightInformationUpdateReplyDto {}
export interface FlightInformationUpdateReplyDto {
    additionalInfo?: string;
    atfmComments?: Array<AtfmComment>;
}
export interface AtfmComment {
    code?: AtfmCommentType;
    message?: string;
}
export enum AtfmCommentType {
    AD_AS_PT_NOT_AVAILABLE = 'AD_AS_PT_NOT_AVAILABLE',
    ARCTYPE_INCONSISTENT_WITH_FPL = 'ARCTYPE_INCONSISTENT_WITH_FPL',
    ATFM_MSGS_AT_EOBT_MINUS_2_HOURS = 'ATFM_MSGS_AT_EOBT_MINUS_2_HOURS',
    CCACS_NO_CODE_YET = 'CCACS_NO_CODE_YET',
    CLOSURE_DUE_TO_ZERO_DATE = 'CLOSURE_DUE_TO_ZERO_DATE',
    CTOT_ALREADY_EXTENDED = 'CTOT_ALREADY_EXTENDED',
    CTOT_OUTSIDE_RANGE = 'CTOT_OUTSIDE_RANGE',
    DO_NOT_CONFIRM_NON_SUSPENDED_FLIGHT = 'DO_NOT_CONFIRM_NON_SUSPENDED_FLIGHT',
    DPI_MSGS_INCORRECT_SEQUENCE = 'DPI_MSGS_INCORRECT_SEQUENCE',
    EOBT_BEFORE_LAST_OBT = 'EOBT_BEFORE_LAST_OBT',
    EOBT_DLA_EXPECTED = 'EOBT_DLA_EXPECTED',
    EOBT_INCONSISTENT_WITH_FPL = 'EOBT_INCONSISTENT_WITH_FPL',
    FCM_CONFIRMING_DELAY_ONLY_AFTER_SIT1 = 'FCM_CONFIRMING_DELAY_ONLY_AFTER_SIT1',
    FCM_IGNORED_FOR_FAM_SUSPENDED = 'FCM_IGNORED_FOR_FAM_SUSPENDED',
    FCM_IGNORED_FOR_PAST_TOT = 'FCM_IGNORED_FOR_PAST_TOT',
    FIX_NOT_ON_ROUTE = 'FIX_NOT_ON_ROUTE',
    FIX_UNKNOWN = 'FIX_UNKNOWN',
    FILING_TIME_OUTSIDE_RANGE = 'FILING_TIME_OUTSIDE_RANGE',
    FLIGHT_ALREADY_ACTIVATED = 'FLIGHT_ALREADY_ACTIVATED',
    FLIGHT_ALREADY_IN_THAT_STATE = 'FLIGHT_ALREADY_IN_THAT_STATE',
    FLIGHT_ALREADY_READY = 'FLIGHT_ALREADY_READY',
    FLIGHT_ALREADY_TERMINATED = 'FLIGHT_ALREADY_TERMINATED',
    FLIGHT_ALREADY_UNDER_ATC_CONTROL = 'FLIGHT_ALREADY_UNDER_ATC_CONTROL',
    FLIGHT_HAS_RECEIVED_ARR_MSG = 'FLIGHT_HAS_RECEIVED_ARR_MSG',
    FLIGHT_IS_CANCELLED = 'FLIGHT_IS_CANCELLED',
    FLIGHT_IS_MANUALLY_SUSPENDED = 'FLIGHT_IS_MANUALLY_SUSPENDED',
    FLIGHT_IS_SUPPOSED_AIRBORNE = 'FLIGHT_IS_SUPPOSED_AIRBORNE',
    FLIGHT_IS_SUSPENDED = 'FLIGHT_IS_SUSPENDED',
    FLIGHT_IS_SUSPENDED_DUE_TO_INVALID_ROUTE = 'FLIGHT_IS_SUSPENDED_DUE_TO_INVALID_ROUTE',
    FLIGHT_NOT_YET_CONFIRMED_BY_FPL = 'FLIGHT_NOT_YET_CONFIRMED_BY_FPL',
    FLIGHT_REROUTED_BY_AO = 'FLIGHT_REROUTED_BY_AO',
    FLIGHT_REROUTED_FPL_CANCELED = 'FLIGHT_REROUTED_FPL_CANCELED',
    FLIGHT_SUSPENDED_BY_IFPS_REV = 'FLIGHT_SUSPENDED_BY_IFPS_REV',
    GENERALLY_EXEMPTED = 'GENERALLY_EXEMPTED',
    HOURLY_LIMIT_FOR_AUTOMATIC_CTOT_EXTENSIONS_EXCEEDED = 'HOURLY_LIMIT_FOR_AUTOMATIC_CTOT_EXTENSIONS_EXCEEDED',
    INCONSISTENT_IFPLID = 'INCONSISTENT_IFPLID',
    INVALID_DPI_STATUS = 'INVALID_DPI_STATUS',
    INVALID_ROUTE_BY_IFPS_REVAL = 'INVALID_ROUTE_BY_IFPS_REVAL',
    INVALID_ROUTE_DUE_TO_TTOT_OR_SID_CHANGE = 'INVALID_ROUTE_DUE_TO_TTOT_OR_SID_CHANGE',
    IRRELEVANT_REGULATIONS = 'IRRELEVANT_REGULATIONS',
    METEO_UPDATE = 'METEO_UPDATE',
    MINLINEUP_OUTSIDE_RANGE = 'MINLINEUP_OUTSIDE_RANGE',
    MISSING_RVR_OR_REGUL = 'MISSING_RVR_OR_REGUL',
    NOT_AUTHORISED = 'NOT_AUTHORISED',
    NOT_EXISTING_FLIGHT = 'NOT_EXISTING_FLIGHT',
    NOT_IN_VALID_PERIOD = 'NOT_IN_VALID_PERIOD',
    NOT_REPORTED_AIRBORNE = 'NOT_REPORTED_AIRBORNE',
    NOT_REPORTED_OFF_BLOCK = 'NOT_REPORTED_OFF_BLOCK',
    NOT_SUBJECT_TO_REGUL = 'NOT_SUBJECT_TO_REGUL',
    NO_MATCHING_FPL_AND_AERODROMES_UNDEFINED = 'NO_MATCHING_FPL_AND_AERODROMES_UNDEFINED',
    NO_MATCHING_FPL_AND_AERODROMES_UNKNOWN = 'NO_MATCHING_FPL_AND_AERODROMES_UNKNOWN',
    NO_MATCHING_FPL_AND_SAME_ADEP_ADES = 'NO_MATCHING_FPL_AND_SAME_ADEP_ADES',
    NO_MORE_SSR_CODES = 'NO_MORE_SSR_CODES',
    NO_REGMARK_FPL = 'NO_REGMARK_FPL',
    NO_SLOT_ISSUED = 'NO_SLOT_ISSUED',
    PUSHED_BY_DPI_TTOT_INSIDE_SLOT_TOLERANCE = 'PUSHED_BY_DPI_TTOT_INSIDE_SLOT_TOLERANCE',
    REGMARK_INCONSISTENT_WITH_FPL = 'REGMARK_INCONSISTENT_WITH_FPL',
    REJECTED_DUE_TO_FORCED_CTOT = 'REJECTED_DUE_TO_FORCED_CTOT',
    REJECTED_DUE_TO_FORCED_CTOT_AND_TTOT_AFTER_STW = 'REJECTED_DUE_TO_FORCED_CTOT_AND_TTOT_AFTER_STW',
    REROUTE_CONDITION_CHANGED = 'REROUTE_CONDITION_CHANGED',
    REROUTE_TIMEOUT = 'REROUTE_TIMEOUT',
    RVR_CRITERIA_NOT_MET = 'RVR_CRITERIA_NOT_MET',
    RVR_UNKNOWN = 'RVR_UNKNOWN',
    SMM_FOR_SUSPENDED_FLIGHT = 'SMM_FOR_SUSPENDED_FLIGHT',
    SMM_RECEIVED = 'SMM_RECEIVED',
    SPA_BUT_NO_SIP = 'SPA_BUT_NO_SIP',
    SPA_BUT_RRP_ONGOING = 'SPA_BUT_RRP_ONGOING',
    SUSPENDED_BY_DEP_AIRPORT = 'SUSPENDED_BY_DEP_AIRPORT',
    SUSPENDED_DELAY_EXCEEDING_THRESHOLD = 'SUSPENDED_DELAY_EXCEEDING_THRESHOLD',
    TAKE_OFF_TIME_OUT_OF_BOUNDS = 'TAKE_OFF_TIME_OUT_OF_BOUNDS',
    TAXI_TIME_OUT_OF_RANGE = 'TAXI_TIME_OUT_OF_RANGE',
    TIME_OUT_OF_RANGE = 'TIME_OUT_OF_RANGE',
    TOO_EARLY = 'TOO_EARLY',
    TOO_EARLY_OR_TOO_LATE = 'TOO_EARLY_OR_TOO_LATE',
    TOO_LATE = 'TOO_LATE',
    TTOT_OUSIDE_TOLERANCE_WINDOW = 'TTOT_OUSIDE_TOLERANCE_WINDOW',
    TTO_OUTSIDE_REGUL = 'TTO_OUTSIDE_REGUL',
    UNABLE_TO_ASSIGN_A_CODE = 'UNABLE_TO_ASSIGN_A_CODE',
    UNDER_CDM_AT_DEP_AIRPORT = 'UNDER_CDM_AT_DEP_AIRPORT',
    UNIT_DIFFERENT_THAN_ASSIGNING_UNIT = 'UNIT_DIFFERENT_THAN_ASSIGNING_UNIT',
    UNREALISTIC_TTO = 'UNREALISTIC_TTO',
}
export interface ArrivalPlanningInformationRequestDto extends FlightInformationUpdateRequestDto {
    arrivalProcedure?: TerminalProcedureOrDct;
    flightStatusInbound?: AtvFlightStatusInbound;
}
export const ARRIVAL_PLANNING_INFORMATION_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.aop.ArrivalPlanningInformationRequestDto';
export interface FlightInformationUpdateRequestDto extends AbstractRequest {
    adep?: string;
    ades?: string;
    aircraftId?: string;
    eobt?: Date;
    ifplId?: string;
}
export const FLIGHT_INFORMATION_UPDATE_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.aop.FlightInformationUpdateRequestDto';
export interface AtcDpiRequestDto extends UpdateDpiRequestDto {
    actualOffBlockTime?: Date;
    depstatusTwrUpdate?: boolean;
}
export const ATC_DPI_REQUEST_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.aop.AtcDpiRequestDto';
export interface UpdateDpiRequestDto extends DeparturePlanningInformationRequestDto {
    aircraftIdInbound?: string;
    aircraftType?: string;
    aircraftTypeIata?: string;
    consolidatedTargetTakeOffTime?: Date;
    deicingStatus?: DeicingStatus;
    departureApronStand?: string;
    departureProcedure?: TerminalProcedureOrDct;
    departureRunway?: string;
    departureTerminal?: string;
    depstatusDeicing?: boolean;
    earliestTargetTakeOffTime?: Date;
    ifplIdInbound?: string;
    registrationMark?: string;
    registrationMarkInbound?: string;
    targetOffBlockTime?: Date;
    targetTakeOffTime?: Date;
    taxiTimeInMs?: number;
    turnaroundTargetTakeOffTime?: Date;
}
export const UPDATE_DPI_REQUEST_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.aop.UpdateDpiRequestDto';
export interface DeparturePlanningInformationRequestDto extends FlightInformationUpdateRequestDto {
    flightStatusOutbound?: AtvFlightStatusOutbound;
}
export const DEPARTURE_PLANNING_INFORMATION_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.aop.DeparturePlanningInformationRequestDto';
export enum DeicingStatus {
    COMPLETED = 'COMPLETED',
    IN_PROGRESS = 'IN_PROGRESS',
    PLANNED = 'PLANNED',
}
export interface CancelDpiRequestDto extends DeparturePlanningInformationRequestDto {
    reason?: DpiCancelReasonType;
}
export const CANCEL_DPI_REQUEST_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.aop.CancelDpiRequestDto';
export interface DpiReplyDto extends FlightInformationUpdateReplyDto {}
export interface EarlyDpiRequestDto extends UpdateDpiRequestDto {
    scheduledOffBlockTime?: Date;
}
export const EARLY_DPI_REQUEST_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.aop.EarlyDpiRequestDto';
export interface GeneralApiRequestDto extends ArrivalPlanningInformationRequestDto {
    aircraftIataId?: string;
    aircraftType?: string;
    airportSlotArrival?: Date;
    arrivalApronStand?: string;
    arrivalRunway?: string;
    arrivalTaxiTimeInMs?: number;
    arrivalTerminal?: string;
    impactSeverityIndicator?: ImpactSeverityIndicator;
    inBlockTime?: Date;
    landingTime?: Date;
    minimumTurnaroundTimeInMs?: number;
    registrationMark?: string;
    scheduledInBlockTime?: Date;
}
export const GENERAL_API_REQUEST_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.aop.GeneralApiRequestDto';
export interface PredictedDpiRequestDto extends UpdateDpiRequestDto {
    adepIata?: string;
    adesIata?: string;
    aircraftIdIata?: string;
    airportSlotDeparture?: Date;
    scheduledOffBlockTime?: Date;
}
export const PREDICTED_DPI_REQUEST_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.aop.PredictedDpiRequestDto';
export interface TargetApiRequestDto extends ArrivalPlanningInformationRequestDto {
    coordinationFix?: PointOrAerodromeId;
    useCase?: TargetApiUseCase;
}
export const TARGET_API_REQUEST_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.aop.TargetApiRequestDto';
export enum TargetApiUseCase {
    Remove = 'Remove',
    Update = 'Update',
}
export interface TargetDpiRequestDto extends UpdateDpiRequestDto {
    targetStartupApprovalTime?: Date;
}
export const TARGET_DPI_REQUEST_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.aop.TargetDpiRequestDto';
export interface TargetDpiSequencedRequestDto extends TargetDpiRequestDto {}
export const TARGET_DPI_SEQUENCED_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.aop.TargetDpiSequencedRequestDto';
export interface TargetDpiTargetRequestDto extends TargetDpiRequestDto {}
export const TARGET_DPI_TARGET_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.aop.TargetDpiTargetRequestDto';
export interface TargetTakeOffApiRequestDto extends TargetApiRequestDto {
    consolidatedTargetTimeOver?: Date;
    earliestTargetTimeOver?: Date;
    regulationId?: string;
}
export const TARGET_TAKE_OFF_API_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.aop.TargetTakeOffApiRequestDto';
export interface TargetTimeOverApiRequestDto extends TargetApiRequestDto {
    targetTimeOver?: Date;
}
export const TARGET_TIME_OVER_API_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.aop.TargetTimeOverApiRequestDto';
export interface AbstractRequest {
    clazz?: string;
    onBehalfOfUnit?: string;
}
export const ABSTRACT_REQUEST_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.service.AbstractRequest';
export enum NmVersionId {
    R18 = 'R18',
    R18_5 = 'R18_5',
    R19 = 'R19',
    R19_5 = 'R19_5',
    R20 = 'R20',
    R20_5 = 'R20_5',
    R21 = 'R21',
    R21_5 = 'R21_5',
    R22 = 'R22',
    R22_5 = 'R22_5',
    R23 = 'R23',
    R23_5 = 'R23_5',
    R24 = 'R24',
    R25 = 'R25',
    R26 = 'R26',
    R27 = 'R27',
}
export enum AsyncProcessStatus {
    RUNNING = 'RUNNING',
    COMPLETE = 'COMPLETE',
    FAILED_TIMEOUT = 'FAILED_TIMEOUT',
    FAILED_ERROR = 'FAILED_ERROR',
}
export interface AsyncProgress {
    percentageComplete?: number;
    progressMessage?: string;
}
export interface AsyncReply<T> extends Reply<T> {
    currentProgress?: AsyncProgress;
    futureResultId?: string;
    processStatus?: AsyncProcessStatus;
}
export interface Reply<T> {
    data?: T;
    error?: ErrorResponse;
    technicalInfo?: ReplyTechnicalInfo;
}
export enum ErrorResponse_ErrorType {
    CONFLICTING_UPDATE = 'CONFLICTING_UPDATE',
    NM_INTERNAL_ERROR = 'NM_INTERNAL_ERROR',
    INVALID_DATASET = 'INVALID_DATASET',
    INVALID_INPUT = 'INVALID_INPUT',
    INVALID_OUTPUT = 'INVALID_OUTPUT',
    SECURITY_ERROR = 'SECURITY_ERROR',
    ID_ALREADY_EXISTS = 'ID_ALREADY_EXISTS',
    UNKNOWN_ID = 'UNKNOWN_ID',
    OBJECT_OUTDATED = 'OBJECT_OUTDATED',
    OVERLOAD = 'OVERLOAD',
    SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
    TOO_MANY_RESULTS = 'TOO_MANY_RESULTS',
    EXCEPTION = 'EXCEPTION',
    OTHER_DSR_SERVER_ERROR = 'OTHER_DSR_SERVER_ERROR',
    OTHER_NM_B2B_ERROR = 'OTHER_NM_B2B_ERROR',
    NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
}
export interface ErrorResponse {
    details?: string;
    message?: string;
    type?: ErrorResponse_ErrorType;
}
export interface ReplyTechnicalInfo {
    replySendTime?: Date;
    requestId?: string;
    requestReceptionTime?: Date;
}
export enum NmSystemInstance {
    OPS = 'OPS',
    PSEUDO_OPS = 'PSEUDO_OPS',
    OPEVAL = 'OPEVAL',
    PREOPS = 'PREOPS',
    NMVP = 'NMVP',
    TESTX = 'TESTX',
    TESTA = 'TESTA',
    PRI = 'PRI',
    ICA = 'ICA',
    PRV = 'PRV',
    CSA = 'CSA',
    DBSIM001 = 'DBSIM001',
    DBSIM002 = 'DBSIM002',
    DBSIM003 = 'DBSIM003',
    NMSIM001 = 'NMSIM001',
    NMSIM002 = 'NMSIM002',
    NMSIM003 = 'NMSIM003',
    ITESTA = 'ITESTA',
    ITESTB = 'ITESTB',
    ITEST7 = 'ITEST7',
    ISASOFTA = 'ISASOFTA',
    ISASOFTB = 'ISASOFTB',
    ISASOFTC = 'ISASOFTC',
    ISASOFTD = 'ISASOFTD',
    ISASOFTE = 'ISASOFTE',
    ISASOFTF = 'ISASOFTF',
    ITESTVMA = 'ITESTVMA',
    ITESTVMB = 'ITESTVMB',
    ITESTVMC = 'ITESTVMC',
    ALLFT = 'ALLFT',
    EFD = 'EFD',
    OPLOG = 'OPLOG',
    SHADOW = 'SHADOW',
}
export interface ReplyErrorException {
    errorResponse?: ErrorResponse;
    message?: string;
}
export interface ResponseId {
    lastUpdateTime?: number;
    serverStartupTime?: number;
}
export enum UpdateType {
    PARTIAL_UPDATE = 'PARTIAL_UPDATE',
    FULL_UPDATE = 'FULL_UPDATE',
    RESET_AND_FULL_UPDATE = 'RESET_AND_FULL_UPDATE',
}
export interface AbstractFlightRelatedRequest extends AbstractRequest {
    dataset?: DatasetDto;
    proposalContexts?: Array<string>;
}
export const ABSTRACT_FLIGHT_RELATED_REQUEST_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.service.AbstractFlightRelatedRequest';
export interface AtcConfigOpening {
    configId?: string;
    lastUpdateTimestamp?: Date;
    planDataSource?: PlanDataSourceType;
    timePeriod?: TimePeriod;
}
export interface AtcConfiguration {
    airspaceIds?: Array<string>;
    configId?: string;
}
export interface AtcConfigurationScheme {
    acc?: string;
    configurations?: Array<AtcConfiguration>;
}
export interface AtcOpeningScheme {
    acc?: string;
    openings?: Array<AtcConfigOpening>;
}
export interface SectorConfigurationPlanDto extends TacticalPlan {
    accId?: string;
    clientSchedule?: Array<AtcConfigOpening>;
    knownConfigs?: AtcConfigurationScheme;
    nmSchedule?: Array<AtcConfigOpening>;
}
export const SECTOR_CONFIGURATION_PLAN_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.atc.SectorConfigurationPlanDto';
export interface SectorConfigurationPlanRequestDto {
    auaOrClusterId?: string;
    dataset?: DatasetDto;
    day?: Date;
}
export interface AbstractEAupCdrRequestDto {
    applicability?: TimePeriod;
    cdrClosures?: boolean;
    cdrOpenings?: boolean;
    flightLevelRange?: FlightLevelBand;
    irFilter?: IrFilterDto;
    routeDesignators?: Array<string>;
    routeUuids?: Array<string>;
}
export interface IrFilterDto {
    irDesignatorFilter?: IrDesignatorFilterDto;
    irUuidFilter?: IrUuidFilterDto;
}
export interface IrUuidFilterDto {
    firUuids?: Array<string>;
    logicalOperator?: LogicalOperator;
    uirUuids?: Array<string>;
}
export interface IrDesignatorFilterDto {
    firDesignators?: Array<string>;
    logicalOperator?: LogicalOperator;
    uirDesignators?: Array<string>;
}
export enum LogicalOperator {
    AND = 'AND',
    OR = 'OR',
}
export interface AbstractEAupRsaRequestDto {
    applicability?: TimePeriod;
    explicit?: boolean;
    flightLevelRange?: FlightLevelBand;
    implicit?: boolean;
    irFilter?: IrFilterDto;
    rsaDesignators?: Array<string>;
    rsaUuids?: Array<string>;
}
export enum AirspaceActivationDto_AirspaceStatus {
    AVBL_FOR_ACTIVATION = 'AVBL_FOR_ACTIVATION',
    ACTIVE = 'ACTIVE',
    IN_USE = 'IN_USE',
    INACTIVE = 'INACTIVE',
    INTERMITTENT = 'INTERMITTENT',
    OTHER = 'OTHER',
}
export interface AirspaceActivationDto {
    activity?: string;
    airspaceId?: string;
    levelBand?: FlightLevelBand;
    status?: AirspaceActivationDto_AirspaceStatus;
    timePeriod?: TimePeriod;
}
export interface AupChainDto {
    amcId?: string;
    aups?: Array<AupSummaryDto>;
    chainDate?: Date;
}
export interface AupSummaryDto {
    amcId?: string;
    aupId?: string;
    aupState?: AupState;
    aupType?: AupType;
    chainDate?: Date;
    expandedAup?: boolean;
    lastUpdate?: LastUpdateDto;
    nilAup?: boolean;
    note?: Array<string>;
    originatingAupId?: string;
    p3?: boolean;
    releaseTime?: Date;
    remark?: string;
    validityPeriod?: TimePeriod;
}
export enum AupType {
    BASELINE = 'BASELINE',
    UPDATE = 'UPDATE',
}
export enum AupState {
    DRAFT = 'DRAFT',
    READY = 'READY',
    RELEASED = 'RELEASED',
}
export interface LastUpdateDto {
    anuId?: string;
    timestamp?: Date;
    userId?: string;
}
export interface AupChainRetrievalRequestDto {
    amcIds?: Array<string>;
    day?: Date;
}
export interface AupComputedEntriesDto {
    implicitCDRs?: Array<RouteAvailabilityDto>;
    implicitRSAs?: Array<AirspaceActivationDto>;
    mergedCDRs?: Array<RouteAvailabilityDto>;
}
export enum RouteAvailabilityDto_RouteAvailabilityStatus {
    OPEN = 'OPEN',
    CLSD = 'CLSD',
    COND = 'COND',
    OTHER = 'OTHER',
}
export enum RouteAvailabilityDto_RouteDirectionType {
    FOREWARD = 'FOREWARD',
    BACKWARD = 'BACKWARD',
    BOTH = 'BOTH',
    OTHER = 'OTHER',
}
export enum RouteAvailabilityDto_ConditionalRouteType {
    CDR_1 = 'CDR_1',
    CDR_2 = 'CDR_2',
    CDR_3 = 'CDR_3',
}
export interface RouteAvailabilityDto {
    conditionalRouteType?: RouteAvailabilityDto_ConditionalRouteType;
    direction?: RouteAvailabilityDto_RouteDirectionType;
    levelBand?: FlightLevelBand;
    p3?: boolean;
    routeId?: string;
    status?: RouteAvailabilityDto_RouteAvailabilityStatus;
    timePeriod?: TimePeriod;
}
export interface AupCreationRequestDto {
    aup?: AupDto;
    returnComputed?: boolean;
}
export interface AupDto {
    aupComputedEntries?: AupComputedEntriesDto;
    aupManualEntries?: AupManualEntriesDto;
    summary?: AupSummaryDto;
}
export interface AupManualEntriesDto {
    cdrs?: Array<RouteAvailabilityDto>;
    rsas?: Array<AirspaceActivationDto>;
}
export interface AupDeletionRequestDto {
    aupId?: string;
    lastUpdate?: LastUpdateDto;
}
export interface AupGetManageableRouteSegmentsForAmcAndRouteRequestDto {
    amcId?: string;
    period?: TimePeriod;
    routeUuid?: string;
}
export interface AupGetManageableRoutesForAmcReplyDto {
    closeableRouteUUids?: Array<string>;
    openableRouteUUids?: Array<string>;
}
export interface AupGetManageableRoutesForAmcRequestDto {
    amcId?: string;
    period?: TimePeriod;
}
export interface AupRetrievalRequestDto {
    aupId?: string;
    returnComputed?: boolean;
}
export interface AupRsaAllocationExpansionRequestDto {
    expansionPeriod?: TimePeriod;
    rsaAllocations?: Array<AirspaceActivationDto>;
}
export interface AupServiceConfigurationReplyDto {
    plannedUpdateStartTimes?: Array<Date>;
}
export interface AupServiceConfigurationRequestDto {}
export interface AupUpdateRequestDto {
    aup?: AupDto;
    returnComputed?: boolean;
}
export interface AupValidationRequestDto {
    aup?: AupDto;
}
export interface DraftEAupCdrRequestDto extends AbstractEAupCdrRequestDto {
    dayOfOperation?: Date;
}
export interface DraftEAupRsaRequestDto extends AbstractEAupRsaRequestDto {
    dayOfOperation?: Date;
}
export interface DraftEAupSummaryDto {
    releaseTime?: Date;
    validityPeriod?: TimePeriod;
}
export interface DraftEAupsRetrievalRequestDto {
    dayOfOperation?: Date;
}
export interface EAupCdrCompareReplyDto {
    cdrOpeningsClosuresIn1Only?: Array<RouteAvailabilityDto>;
    cdrOpeningsClosuresIn2Only?: Array<RouteAvailabilityDto>;
    commonCDROpeningsClosures?: Array<RouteAvailabilityDto>;
}
export interface EAupCdrCompareRequestDto extends AbstractEAupCdrRequestDto {
    eaupId1?: EAupIdentificationDto;
    eaupId2?: EAupIdentificationDto;
}
export interface EAupIdentificationDto {
    chainDate?: Date;
    sequenceNumber?: number;
}
export interface EAupCdrRequestDto extends AbstractEAupCdrRequestDto {
    eaupId?: EAupIdentificationDto;
}
export interface EAupChainDto {
    chainDate?: Date;
    eaups?: Array<EAupSummaryDto>;
}
export interface EAupSummaryDto {
    eaupId?: EAupIdentificationDto;
    releaseTime?: Date;
    validityPeriod?: TimePeriod;
}
export interface EAupChainRetrievalRequestDto {
    chainDate?: Date;
}
export interface EAupRsaCompareReplyDto {
    commonRSAAllocations?: Array<AirspaceActivationDto>;
    rsaAllocationsIn1Only?: Array<AirspaceActivationDto>;
    rsaAllocationsIn2Only?: Array<AirspaceActivationDto>;
}
export interface EAupRsaCompareRequestDto extends AbstractEAupRsaRequestDto {
    eaupId1?: EAupIdentificationDto;
    eaupId2?: EAupIdentificationDto;
}
export interface EAupRsaRequestDto extends AbstractEAupRsaRequestDto {
    eaupId?: EAupIdentificationDto;
}
export interface CapacityPlanDto extends TacticalPlan {
    clientValues?: Array<CapacityValue>;
    location?: CapacityRefLocation;
    nmValues?: Array<CapacityValue>;
}
export const CAPACITY_PLAN_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.capacity.CapacityPlanDto';
export interface CapacityValue {
    dataSource?: PlanDataSourceType;
    hourlyCapacity?: number;
    timePeriod?: TimePeriod;
}
export interface CapacityRefLocation {
    refName?: string;
    refType?: CapacityReferenceType;
}
export enum CapacityReferenceType {
    AS = 'AS',
    PT = 'PT',
    AZ = 'AZ',
    AD = 'AD',
    TV = 'TV',
}
export interface CapacityPlanRequestDto {
    dataset?: DatasetDto;
    day?: Date;
    tvId?: string;
}
export interface Otmv {
    dataSource?: PlanDataSourceType;
    durationInMin?: number;
    peakValue?: number;
    sustainedElapseInMinutes?: number;
    sustainedOccurence?: number;
    sustainedValue?: number;
    timePeriod?: TimePeriod;
    tvId?: string;
}
export interface OtmvDurationsDto {
    durations?: Array<number>;
    tvId?: string;
}
export interface OtmvDurationsRequestDto {
    dataset?: DatasetDto;
    day?: Date;
    tvId?: string;
}
export interface OtmvPlanDto extends TacticalPlan {
    otmvPlans?: Array<OtmvPlanForDuration>;
    tvId?: string;
}
export const OTMV_PLAN_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.capacity.OtmvPlanDto';
export interface OtmvPlanForDuration {
    clientValues?: Array<Otmv>;
    durationInMinutes?: number;
    nmValues?: Array<Otmv>;
}
export interface OtmvPlanRequestDto {
    dataset?: DatasetDto;
    day?: Date;
    tvId?: string;
}
export interface TvIdAndDuration {
    durationInMinutes?: number;
    tvId?: string;
}
export interface DelayCountsDto {
    influencedRegulations?: Array<DelayCountsInfluenceDto>;
    influencingRegulations?: Array<DelayCountsInfluenceDto>;
    overallDelayData?: DelayData;
    regulation?: RegulationDto;
    timeRange?: TimeRange;
    timeSliceDelayData?: Array<DelayData>;
}
export interface DelayData {
    expectedNumSlots?: number;
    maxDelayInMin?: number;
    numOfConcernedButNotMprFlights?: number;
    numOfDelayedFlights?: number;
    numOfMprFlights?: number;
    numOfUnconcernedFlights?: number;
    totalAllocatedDelayInMin?: number;
    totalDelayInMin?: number;
}
export interface DelayCountsInfluenceDto {
    numFlightsInTimeSlices?: Array<number>;
    numberOfFlights?: number;
    regulId?: string;
}
export interface DelayCountsAndFlightListRequestDto {
    dcRequest?: DelayCountsRequestDto;
    delayCountsRequest?: DelayCountsRequestDto;
    flightFields?: Array<FlightFieldType>;
}
export interface DelayCountsRequestDto extends AbstractFlightRelatedRequest {
    day?: Date;
    durationInMin?: number;
    includeForecastFlights?: boolean;
    intervalInMin?: number;
    regulationFields?: Array<RegulationFieldType>;
    regulationId?: string;
    trafficType?: TrafficType;
}
export const DELAY_COUNTS_REQUEST_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.delay.DelayCountsRequestDto';
export interface DelayCountsAndFlightListDto {
    counts?: DelayCountsDto;
    flightList?: FlightListDto;
}
export interface EntityDTO {
    clazz?: string;
    id?: number;
    name?: string;
}
export const ENTITY_D_T_O_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.entity.EntityDTO';
export interface AtmServiceProviderTypeDto {
    provider?: PersonOrOrganizationTypeDto;
    providerType?: RoleTypeEnum;
}
export enum RoleTypeEnum {
    FFICE_PARTICIPANT = 'FFICE_PARTICIPANT',
    NON_FFICE_PARTICIPANT = 'NON_FFICE_PARTICIPANT',
}
export interface FficeFiledFlightPlanReplyDto {
    filingStatus?: FficeMessageTypeDto;
    submissionResponse?: FficeMessageTypeDto;
}
export interface FficeMessageTypeDto {
    extension?: Array<FficeMessageExtensionTypeDto>;
    filingStatus?: FilingStatusTypeDto;
    flight?: FlightTypeDto;
    forwardingProvider?: PersonOrOrganizationTypeDto;
    informationRequest?: RequestedInformationChoiceTypeDo;
    operatorFlightPlanVersion?: number;
    originator?: PersonOrOrganizationTypeDto;
    planningStatus?: PlanningStatusTypeDto;
    recipient?: Array<PersonOrOrganizationTypeDto>;
    referencedMessageIdentifier?: UniversallyUniqueIdentifierTypeDto;
    relevantAtmServiceProvider?: Array<AtmServiceProviderTypeDto>;
    submissionStatus?: SubmissionStatusTypeDto;
    timestamp?: Date;
    translationProvider?: PersonOrOrganizationTypeDto;
    translationRecipient?: Array<PersonOrOrganizationTypeDto>;
    type?: FficeMessageTypeEnum;
    uniqueMessageIdentifier?: UniversallyUniqueIdentifierTypeDto;
}
export interface FficeMessageExtensionTypeDto {
    clazz?: string;
}
export const FFICE_MESSAGE_EXTENSION_TYPE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.ffice.FficeMessageExtensionTypeDto';
export interface FilingStatusTypeDto {
    expectedEvaluationTime?: Date;
    explanation?: Array<string>;
    originator?: PersonOrOrganizationTypeDto;
    trajectoryPurpose?: TrajectoryPurposeEnum;
    value?: FilingStatusValueEnum;
}
export interface RequestedInformationChoiceTypeDo {
    other?: string;
    type?: RequestedInformationChoiceEnum;
}
export interface PlanningStatusTypeDto {
    explanation?: Array<string>;
    value?: PlanningStatusValueEnum;
}
export interface SubmissionStatusTypeDto {
    explanation?: Array<string>;
    extension?: Array<SubmissionStatusExtensionTypeDto>;
    originator?: PersonOrOrganizationTypeDto;
    value?: SubmissionStateValueEnum;
}
export enum FficeMessageTypeEnum {
    FILED_FLIGHT_PLAN = 'FILED_FLIGHT_PLAN',
    FILING_STATUS = 'FILING_STATUS',
    FLIGHT_ARRIVAL = 'FLIGHT_ARRIVAL',
    FLIGHT_CANCELLATION = 'FLIGHT_CANCELLATION',
    FLIGHT_DATA_REQUEST = 'FLIGHT_DATA_REQUEST',
    FLIGHT_DATA_RESPONSE = 'FLIGHT_DATA_RESPONSE',
    FLIGHT_DEPARTURE = 'FLIGHT_DEPARTURE',
    FLIGHT_PLAN_UPDATE = 'FLIGHT_PLAN_UPDATE',
    PLANNING_STATUS = 'PLANNING_STATUS',
    PRELIMINARY_FLIGHT_PLAN = 'PRELIMINARY_FLIGHT_PLAN',
    SUBMISSION_RESPONSE = 'SUBMISSION_RESPONSE',
    TRIAL_REQUEST = 'TRIAL_REQUEST',
    TRIAL_RESPONSE = 'TRIAL_RESPONSE',
}
export interface SubmissionStatusExtensionTypeDto {
    clazz?: string;
}
export const SUBMISSION_STATUS_EXTENSION_TYPE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.ffice.SubmissionStatusExtensionTypeDto';
export enum SubmissionStateValueEnum {
    ACK = 'ACK',
    MAN = 'MAN',
    REJ = 'REJ',
}
export enum PlanningStatusValueEnum {
    CONCUR = 'CONCUR',
    NON_CONCUR = 'NON_CONCUR',
    NEGOTIATE = 'NEGOTIATE',
}
export enum RequestedInformationChoiceEnum {
    FLIGHT_PLAN = 'FLIGHT_PLAN',
    FLIGHT_STATUS = 'FLIGHT_STATUS',
    SUPPLEMENTARY_FLIGHT_PLAN = 'SUPPLEMENTARY_FLIGHT_PLAN',
}
export enum FilingStatusValueEnum {
    ACCEPTABLE = 'ACCEPTABLE',
    NOT_ACCEPTABLE = 'NOT_ACCEPTABLE',
}
export enum TrajectoryPurposeEnum {
    ATC_CHANGE = 'ATC_CHANGE',
    SYNCH = 'SYNCH',
}
export interface FficeFiledFlightPlanRequestDto {
    flightPlan?: FficeMessageTypeDto;
}
export interface FficeFilingStatusMessageTypeDto {
    filingStatus?: FilingStatusTypeDto;
    flight?: FlightTypeDto;
    messageIdentifier?: UniversallyUniqueIdentifierTypeDto;
    operatorFlightPlanVersion?: number;
    originator?: PersonOrOrganizationTypeDto;
    recipient?: Array<PersonOrOrganizationTypeDto>;
    timestamp?: Date;
}
export interface FficeFlightDataReplyDto {
    filingStatus?: FficeMessageTypeDto;
    flightDataResponse?: FficeMessageTypeDto;
    submissionResponse?: FficeMessageTypeDto;
}
export interface FficeFlightDataRequestDto {
    completeTrajectoryData?: boolean;
    flightKeys?: FlightKeys;
    gufi?: UniversallyUniqueIdentifierTypeDto;
}
export interface FficeFlightFinderRequestDto {
    adep?: string;
    ades?: string;
    callsign?: string;
    day?: Date;
    ffIceOnly?: boolean;
}
export interface FficeFlightPlanHistoryReplyDto_FficeFlightPlanHistoryElementDto {
    message?: FficeMessageTypeDto;
    timestamp?: Date;
}
export interface FficeFlightPlanHistoryReplyDto {
    flightId?: FlightId;
    history?: Array<FficeFlightPlanHistoryReplyDto_FficeFlightPlanHistoryElementDto>;
}
export interface FficeFlightPlanHistoryRequestDto {
    flightId?: FlightId;
    mostRecentOnly?: boolean;
}
export interface FficeFlightPlanUpdateReplyDto {
    filingStatus?: FficeMessageTypeDto;
    submissionResponse?: FficeMessageTypeDto;
}
export interface FficeFlightPlanUpdateRequestDto {
    flightPlanUpdate?: FficeMessageTypeDto;
}
export interface FficeTrialRequestDto {
    evaluateFlowImpact?: boolean;
    trialRequest?: FficeMessageTypeDto;
}
export interface NmFficeMessageExtensionTypeDto extends FficeMessageExtensionTypeDto {
    negotiatingTrajectoryRequested?: boolean;
}
export const NM_FFICE_MESSAGE_EXTENSION_TYPE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.ffice.NmFficeMessageExtensionTypeDto';
export interface NmFlightTrajectoryExtensionTypeDto extends RouteTrajectoryGroupContainerExtensionTypeDto {
    modelType?: FlightModelType;
    trajectory?: RouteTrajectoryGroupTypeDto;
}
export const NM_FLIGHT_TRAJECTORY_EXTENSION_TYPE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.ffice.NmFlightTrajectoryExtensionTypeDto';
export interface NmSubmissionStatusExtensionTypeDto extends SubmissionStatusExtensionTypeDto {
    filingId?: string;
}
export const NM_SUBMISSION_STATUS_EXTENSION_TYPE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.ffice.NmSubmissionStatusExtensionTypeDto';
export interface FficeTrialReplyDto {
    evaluateFlowImpactData?: EvaluateFlowImpactReplyDto;
    submissionResponse?: FficeMessageTypeDto;
    trialResponse?: FficeMessageTypeDto;
}
export interface FficeFlightFinderReplyDto_FlightPlanInfo {
    averageVerticalDiffInFeet?: number;
    filedProfileDurationInSec?: number;
    hasConstraints?: boolean;
    maxVerticalDiffInFeet?: number;
    nmProfileDurationInSec?: number;
    numMissingNamedPoints?: number;
    topOfDescentDiffInNm?: number;
}
export interface FficeFlightFinderReplyDto_FlightInfo {
    flightId?: FlightId;
    flightPlanInfo?: FficeFlightFinderReplyDto_FlightPlanInfo;
}
export interface FficeFlightFinderReplyDto {
    flights?: Array<FficeFlightFinderReplyDto_FlightInfo>;
}
export interface FirstDesiredFlightTrajectoryExtensionTypeDto extends RouteTrajectoryGroupContainerExtensionTypeDto {
    trajectory?: RouteTrajectoryGroupTypeDto;
}
export const FIRST_DESIRED_FLIGHT_TRAJECTORY_EXTENSION_TYPE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.ffice.FirstDesiredFlightTrajectoryExtensionTypeDto';
export interface PersonOrOrganizationTypeDto {
    contact?: ContactInformationTypeDto;
    identifier?: string;
    identifierDomain?: string;
    name?: string;
}
export interface ContactInformationTypeDto {
    address?: PostalAddressTypeDto;
    name?: string;
    onlineContact?: Array<OnlineContactTypeDto>;
    phoneFax?: TelephoneContactTypeDto;
    title?: string;
}
export interface PostalAddressTypeDto {
    administrativeArea?: string;
    city?: string;
    countryCode?: string;
    countryName?: string;
    deliveryPoint?: string;
    postalCode?: string;
}
export interface OnlineContactTypeDto {
    email?: string;
    linkage?: string;
    network?: NetworkChoiceTypeDto;
}
export interface TelephoneContactTypeDto {
    facsimile?: string;
    voice?: string;
}
export interface NetworkChoiceTypeDto {
    other?: string;
    type?: TelecomNetworkEnum;
}
export enum TelecomNetworkEnum {
    AFTN = 'AFTN',
    INTERNET = 'INTERNET',
}
export interface FlightTypeDto {
    aircraft?: AircraftTypeDto;
    arrival?: ArrivalTypeDto;
    departure?: DepartureTypeDto;
    enRoute?: EnRouteTypeDto;
    extension?: Array<FlightExtensionTypeDto>;
    flightConstraint?: Array<FlightConstraintTypeDto>;
    flightIdentification?: FlightIdentificationTypeDto;
    flightPlanOriginator?: PersonOrOrganizationTypeDto;
    flightPlanSubmitter?: PersonOrOrganizationTypeDto;
    flightRulesCategory?: FlightRulesCategoryEnum;
    flightType?: TypeOfFlightEnum;
    operator?: AircraftOperatorTypeDto;
    remarks?: string;
    routeTrajectoryGroup?: RouteTrajectoryGroupContainerTypeDto;
    specialHandling?: Array<SpecialHandlingReasonCodeEnum>;
    supplementaryInformation?: SupplementaryInformationTypeDto;
}
export interface UniversallyUniqueIdentifierTypeDto {
    codeSpace?: string;
    value?: string;
}
export interface AircraftTypeDto {
    aircraftAddress?: string;
    aircraftApproachCategory?: AircraftApproachCategoryEnum;
    aircraftType?: Array<AircraftTypeTypeDto>;
    capabilities?: FlightCapabilitiesTypeDto;
    coloursAndMarkings?: string;
    registration?: Array<string>;
    wakeTurbulence?: WakeTurbulenceCategoryTypeEnum;
}
export interface ArrivalTypeDto {
    actualTimeOfArrival?: ActualTimeOfArrivalTypeDto;
    airportSlotIdentification?: string;
    arrivalAerodrome?: AerodromeReferenceTypeDto;
    destinationAerodrome?: AerodromeReferenceTypeDto;
    destinationAerodromeAlternate?: Array<AerodromeReferenceTypeDto>;
    destinationAerodromePrevious?: AerodromeReferenceTypeDto;
    reclearanceInFlight?: ReclearanceInFlightTypeDto;
    runwayDirection?: RunwayDirectionDesignatorTypeDto;
}
export interface DepartureTypeDto {
    actualTimeOfDeparture?: ActualTimeOfDepartureTypeDto;
    airfileIndicator?: AirfileIndicatorEnum;
    airportSlotIdentification?: string;
    departureAerodrome?: AerodromeReferenceTypeDto;
    departureAerodromePrevious?: AerodromeReferenceTypeDto;
    departurePoint?: DeparturePointChoiceTypeDto;
    departurePointPrevious?: DeparturePointChoiceTypeDto;
    estimatedOffBlockTime?: Date;
    estimatedOffBlockTimePrevious?: Date;
    estimatedRouteStartTime?: Date;
    estimatedRouteStartTimePrevious?: Date;
    runwayDirection?: RunwayDirectionDesignatorTypeDto;
    takeoffAlternateAerodrome?: Array<AerodromeReferenceTypeDto>;
}
export interface EnRouteTypeDto {
    alternateAerodrome?: Array<AerodromeReferenceTypeDto>;
    boundaryCrossingCoordination?: BoundaryCrossingTypeDto;
    currentModeACode?: string;
}
export interface FlightExtensionTypeDto {
    clazz?: string;
}
export const FLIGHT_EXTENSION_TYPE_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.fixm.FlightExtensionTypeDto';
export interface FlightConstraintTypeDto {
    applicability?: string;
    impact?: string;
    restrictionReference?: RestrictionReferenceTypeDto;
}
export interface FlightIdentificationTypeDto {
    aircraftIdentification?: string;
    aircraftIdentificationPrevious?: string;
    extension?: Array<FlightIdentificationExtensionTypeDto>;
    gufi?: GloballyUniqueFlightIdentifierTypeDto;
    gufiLegacy?: UniversallyUniqueIdentifierTypeDto;
    iataFlightDesignator?: IataFlightDesignatorTypeDto;
}
export enum FlightRulesCategoryEnum {
    I = 'I',
    V = 'V',
    Y = 'Y',
    Z = 'Z',
}
export enum TypeOfFlightEnum {
    M = 'M',
    G = 'G',
    N = 'N',
    S = 'S',
    X = 'X',
}
export interface AircraftOperatorTypeDto {
    designatorIcao?: string;
    operatingOrganization?: PersonOrOrganizationTypeDto;
}
export enum RouteTrajectoryGroupContainerTypeDto_Version {
    AGREED = 'AGREED',
    CURRENT = 'CURRENT',
    DESIRED = 'DESIRED',
    NEGOTIATING = 'NEGOTIATING',
}
export interface RouteTrajectoryGroupContainerTypeDto {
    agreed?: RouteTrajectoryGroupTypeDto;
    current?: RouteTrajectoryGroupTypeDto;
    desired?: RouteTrajectoryGroupTypeDto;
    extension?: Array<RouteTrajectoryGroupContainerExtensionTypeDto>;
    negotiating?: RouteTrajectoryGroupTypeDto;
}
export enum SpecialHandlingReasonCodeEnum {
    ALTRV = 'ALTRV',
    ATFMX = 'ATFMX',
    FFR = 'FFR',
    FLTCK = 'FLTCK',
    HAZMAT = 'HAZMAT',
    HEAD = 'HEAD',
    HOSP = 'HOSP',
    HUM = 'HUM',
    MARSA = 'MARSA',
    MEDEVAC = 'MEDEVAC',
    NONRVSM = 'NONRVSM',
    SAR = 'SAR',
    STATE = 'STATE',
}
export interface SupplementaryInformationTypeDto {
    fuelEnduranceInSec?: number;
    personsOnBoard?: number;
    pilotInCommand?: PersonOrOrganizationTypeDto;
    supplementaryInformationSource?: SupplementaryInformationSourceChoiceTypeDto;
}
export interface SupplementaryInformationSourceChoiceTypeDto {
    personOrOrganization?: PersonOrOrganizationTypeDto;
    unit?: AtcUnitReferenceTypeDto;
}
export interface AtcUnitReferenceTypeDto {
    atcUnitNameOrAlternate?: string;
    controlSectorDesignator?: AirspaceDesignatorTypeDto;
    href?: string;
    locationIndicator?: string;
    position?: GeographicalPositionTypeDto;
}
export interface AirspaceDesignatorTypeDto {
    href?: string;
    value?: string;
}
export interface GeographicalPositionTypeDto {
    pos?: Array<number>;
    srsName?: string;
}
export interface RouteTrajectoryGroupContainerExtensionTypeDto {
    clazz?: string;
}
export const ROUTE_TRAJECTORY_GROUP_CONTAINER_EXTENSION_TYPE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.fixm.RouteTrajectoryGroupContainerExtensionTypeDto';
export interface RouteTrajectoryGroupTypeDto {
    climbProfile?: PerformanceProfileTypeDto;
    climbSchedule?: SpeedScheduleTypeDto;
    descentProfile?: PerformanceProfileTypeDto;
    descentSchedule?: SpeedScheduleTypeDto;
    element?: Array<RouteTrajectoryElementTypeDto>;
    routeInformation?: FlightRouteInformationTypeDto;
    takeoffMass?: MassTypeDto;
}
export interface PerformanceProfileTypeDto {
    profilePoint?: Array<ProfilePointTypeDto>;
}
export interface SpeedScheduleTypeDto {
    initialSpeed?: IndicatedAirspeedTypeDto;
    subsequentSpeed?: IndicatedAirspeedTypeDto;
}
export interface RouteTrajectoryElementTypeDto {
    alongRouteDistance?: DistanceTypeDto;
    constraint?: Array<RouteTrajectoryConstraintTypeDto>;
    elementStartPoint?: SignificantPointChoiceTypeDto;
    extension?: Array<RouteTrajectoryElementExtensionTypeDto>;
    flightRulesChange?: FlightRulesEnum;
    modified?: ModifiedRouteItemIndicatorEnum;
    modifiedRouteItemReference?: string;
    plannedDelay?: PlannedDelayTypeDto;
    point4D?: TrajectoryPoint4DTypeDto;
    routeChange?: RouteChangeTypeDto;
    routeDesignatorToNextElement?: RouteDesignatorToNextElementChoiceTypeDto;
    routeTruncationIndicator?: RouteTruncationIndicatorEnum;
    seqNum?: number;
}
export interface FlightRouteInformationTypeDto {
    airacReference?: Date;
    cruisingLevel?: FlightLevelOrAltitudeOrVfrChoiceTypeDto;
    cruisingSpeed?: TrueAirspeedTypeDto;
    estimatedElapsedTime?: Array<EstimatedElapsedTimeTypeDto>;
    extension?: Array<FlightRouteInformationExtensionTypeDto>;
    routeText?: string;
    totalEstimatedElapsedTimeInSec?: number;
}
export interface MassTypeDto {
    uom?: UomMassEnum;
    value?: number;
}
export enum UomMassEnum {
    KG = 'KG',
    LB = 'LB',
}
export interface FlightRouteInformationExtensionTypeDto {
    clazz?: string;
}
export const FLIGHT_ROUTE_INFORMATION_EXTENSION_TYPE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.fixm.FlightRouteInformationExtensionTypeDto';
export interface FlightLevelOrAltitudeOrVfrChoiceTypeDto {
    altitude?: AltitudeTypeDto;
    level?: FlightLevelTypeDto;
    visualFlightRules?: VisualFlightRulesLevelEnum;
}
export interface TrueAirspeedTypeDto {
    uom?: UomAirspeedEnum;
    value?: number;
}
export interface EstimatedElapsedTimeTypeDto {
    elapsedTimeInSec?: number;
    location?: ElapsedTimeLocationChoiceTypeDto;
    seqNum?: number;
}
export interface ElapsedTimeLocationChoiceTypeDto {
    longitude?: number;
    point?: SignificantPointChoiceTypeDto;
    region?: string;
}
export interface SignificantPointChoiceTypeDto {
    aerodromeReferencePoint?: AerodromeReferenceTypeDto;
    designatedPoint?: DesignatedPointTypeDto;
    navaid?: NavaidTypeDto;
    position?: GeographicalPositionTypeDto;
    relativePoint?: RelativePointTypeDto;
}
export interface AerodromeReferenceTypeDto {
    href?: string;
    iataDesignator?: string;
    locationIndicator?: string;
    name?: string;
    referencePoint?: GeographicalPositionTypeDto;
    referenceRelativePoint?: RelativePointTypeDto;
}
export interface DesignatedPointTypeDto {
    designator?: string;
    href?: string;
    position?: GeographicalPositionTypeDto;
}
export interface NavaidTypeDto {
    designator?: string;
    href?: string;
    navaidServiceType?: NavaidServiceTypeEnum;
    position?: GeographicalPositionTypeDto;
}
export interface RelativePointTypeDto {
    bearing?: BearingTypeDto;
    distance?: DistanceTypeDto;
    position?: GeographicalPositionTypeDto;
    referencePoint?: NavaidTypeDto;
}
export interface BearingTypeDto extends AngleTypeDto {
    uom?: UomAngleEnum;
    value?: number;
    zeroBearingType?: ZeroBearingEnum;
}
export interface AngleTypeDto {
    uom?: UomAngleEnum;
    value?: number;
}
export interface DistanceTypeDto extends LengthTypeDto {}
export interface LengthTypeDto {
    uom?: UomLengthEnum;
    value?: number;
}
export enum UomLengthEnum {
    CM = 'CM',
    FT = 'FT',
    IN = 'IN',
    KM = 'KM',
    M = 'M',
    MI = 'MI',
    MM = 'MM',
    NM = 'NM',
}
export enum ZeroBearingEnum {
    TRUE_NORTH = 'TRUE_NORTH',
    MAGNETIC_NORTH = 'MAGNETIC_NORTH',
}
export enum UomAngleEnum {
    DEG = 'DEG',
}
export enum NavaidServiceTypeEnum {
    DF = 'DF',
    DME = 'DME',
    ILS = 'ILS',
    ILS_DME = 'ILS_DME',
    LOC = 'LOC',
    LOC_DME = 'LOC_DME',
    MKR = 'MKR',
    MLS = 'MLS',
    MLS_DME = 'MLS_DME',
    NDB = 'NDB',
    NDB_DME = 'NDB_DME',
    NDB_MKR = 'NDB_MKR',
    SDF = 'SDF',
    TACAN = 'TACAN',
    TLS = 'TLS',
    VOR = 'VOR',
    VORTAC = 'VORTAC',
    VOR_DME = 'VOR_DME',
}
export enum UomAirspeedEnum {
    KM_H = 'KM_H',
    KT = 'KT',
    MACH = 'MACH',
}
export interface AltitudeTypeDto {
    uom?: UomAltitudeEnum;
    value?: number;
}
export interface FlightLevelTypeDto {
    uom?: UomFlightLevelEnum;
    value?: number;
}
export enum VisualFlightRulesLevelEnum {
    VFR = 'VFR',
}
export enum UomFlightLevelEnum {
    FL = 'FL',
    SM = 'SM',
}
export enum UomAltitudeEnum {
    FT = 'FT',
    M = 'M',
}
export interface RouteTrajectoryElementExtensionTypeDto {
    clazz?: string;
}
export const ROUTE_TRAJECTORY_ELEMENT_EXTENSION_TYPE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.fixm.RouteTrajectoryElementExtensionTypeDto';
export interface RouteTrajectoryConstraintTypeDto {
    departureOrArrivalIndicator?: DepartureOrArrivalIndicatorEnum;
    description?: string;
    level?: LevelConstraintTypeDto;
    restrictionReference?: RestrictionReferenceTypeDto;
    speed?: SpeedConstraintTypeDto;
    time?: TimeConstraintTypeDto;
}
export interface PlannedDelayTypeDto {
    delayReason?: string;
    delayReference?: string;
    delayType?: PlannedDelayTypeEnum;
    delayValueInSec?: number;
}
export enum FlightRulesEnum {
    IFR = 'IFR',
    VFR = 'VFR',
}
export enum ModifiedRouteItemIndicatorEnum {
    MODIFIED_ROUTE_ITEM = 'MODIFIED_ROUTE_ITEM',
}
export interface TrajectoryPoint4DTypeDto {
    altimeterSetting?: PressureTypeDto;
    level?: FlightLevelOrAltitudeChoiceTypeDto;
    metData?: MeteorologicalDataTypeDto;
    pointProperty?: Array<TrajectoryPointPropertyTypeDto>;
    position?: GeographicalPositionTypeDto;
    predictedAirspeed?: IndicatedAirspeedTypeDto;
    predictedGroundspeed?: GroundSpeedTypeDto;
    time?: Point4DTimeChoiceTypeDto;
    verticalRange?: VerticalRangeTypeDto;
}
export interface RouteChangeTypeDto {
    cruiseClimbStart?: CruiseClimbStartTypeDto;
    level?: CruisingLevelChangeTypeDto;
    speed?: CruisingSpeedChangeTypeDto;
}
export interface RouteDesignatorToNextElementChoiceTypeDto {
    otherRouteDesignator?: OtherRouteDesignatorEnum;
    routeDesignator?: RouteDesignatorTypeDto;
    standardInstrumentArrival?: SidStarReferenceTypeDto;
    standardInstrumentDeparture?: SidStarReferenceTypeDto;
}
export enum RouteTruncationIndicatorEnum {
    ROUTE_TRUNCATION = 'ROUTE_TRUNCATION',
}
export enum OtherRouteDesignatorEnum {
    DIRECT = 'DIRECT',
    UNSPECIFIED = 'UNSPECIFIED',
    LAST_POINT = 'LAST_POINT',
}
export interface RouteDesignatorTypeDto {
    href?: string;
    value?: string;
}
export interface SidStarReferenceTypeDto {
    abbreviatedDesignator?: string;
    designator?: string;
    href?: string;
}
export interface CruiseClimbStartTypeDto {
    lowerLevel?: FlightLevelOrAltitudeChoiceTypeDto;
    speed?: TrueAirspeedTypeDto;
    upperLevel?: UpperLevelChoiceTypeDto;
}
export interface CruisingLevelChangeTypeDto {
    activation?: ActivationEnum;
    level?: FlightLevelOrAltitudeChoiceTypeDto;
}
export interface CruisingSpeedChangeTypeDto {
    activation?: ActivationEnum;
    speed?: TrueAirspeedTypeDto;
}
export enum ActivationEnum {
    PLAN_TO_COMMENCE = 'PLAN_TO_COMMENCE',
    PLAN_TO_ATTAIN = 'PLAN_TO_ATTAIN',
}
export interface FlightLevelOrAltitudeChoiceTypeDto {
    altitude?: AltitudeTypeDto;
    flightLevel?: FlightLevelTypeDto;
}
export interface UpperLevelChoiceTypeDto {
    altitude?: AltitudeTypeDto;
    atOrAbove?: AtOrAboveIndicatorEnum;
    level?: FlightLevelTypeDto;
}
export enum AtOrAboveIndicatorEnum {
    AT_OR_ABOVE_LOWER_LEVEL = 'AT_OR_ABOVE_LOWER_LEVEL',
}
export interface PressureTypeDto {
    uom?: UomPressureEnum;
    value?: number;
}
export interface MeteorologicalDataTypeDto {
    temperature?: TemperatureTypeDto;
    windDirection?: WindDirectionTypeDto;
    windSpeed?: WindSpeedTypeDto;
}
export interface TrajectoryPointPropertyTypeDto {
    description?: string;
    propertyType?: TrajectoryPointPropertyTypeEnum;
    reference?: TrajectoryPointReferenceTypeDto;
}
export interface IndicatedAirspeedTypeDto {
    uom?: UomAirspeedEnum;
    value?: number;
}
export interface GroundSpeedTypeDto {
    uom?: UomGroundSpeedEnum;
    value?: number;
}
export interface Point4DTimeChoiceTypeDto {
    absoluteTime?: Date;
    relativeTimeFromInitialPredictionPointInSec?: number;
}
export interface VerticalRangeTypeDto {
    lowerBound?: FlightLevelOrAltitudeChoiceTypeDto;
    upperBound?: FlightLevelOrAltitudeChoiceTypeDto;
}
export enum TrajectoryPointPropertyTypeEnum {
    TOP_OF_CLIMB = 'TOP_OF_CLIMB',
    TOP_OF_DESCENT = 'TOP_OF_DESCENT',
    CROSSOVER_ALTITUDE = 'CROSSOVER_ALTITUDE',
    TRANSITION_ALTITUDE_OR_LEVEL = 'TRANSITION_ALTITUDE_OR_LEVEL',
    TCP_VERTICAL = 'TCP_VERTICAL',
    TCP_SPEED = 'TCP_SPEED',
    TCP_LATERAL = 'TCP_LATERAL',
    DEPARTURE_RUNWAY_END = 'DEPARTURE_RUNWAY_END',
    START_TAKEOFF_ROLL = 'START_TAKEOFF_ROLL',
    END_LANDING_ROLL = 'END_LANDING_ROLL',
    WHEELS_OFF = 'WHEELS_OFF',
    WHEELS_ON = 'WHEELS_ON',
    ENTRY_RESTRICTED_OR_RESERVED_AIRSPACE = 'ENTRY_RESTRICTED_OR_RESERVED_AIRSPACE',
    EXIT_RESTRICTED_OR_RESERVED_AIRSPACE = 'EXIT_RESTRICTED_OR_RESERVED_AIRSPACE',
    CROSSING_CONSTRAINED_AIRSPACE = 'CROSSING_CONSTRAINED_AIRSPACE',
    EXIT_CONSTRAINED_AIRSPACE = 'EXIT_CONSTRAINED_AIRSPACE',
    INITIAL_PREDICTION_POINT = 'INITIAL_PREDICTION_POINT',
    END_PREDICTION_POINT = 'END_PREDICTION_POINT',
    HOLD_ENTRY = 'HOLD_ENTRY',
    HOLD_EXIT = 'HOLD_EXIT',
    BEGIN_STAY = 'BEGIN_STAY',
    END_STAY = 'END_STAY',
    START_EXPECT_VECTORS = 'START_EXPECT_VECTORS',
    END_EXPECT_VECTORS = 'END_EXPECT_VECTORS',
    CONSTRAINT_POINT = 'CONSTRAINT_POINT',
    FIR_BOUNDARY_CROSSING_POINT = 'FIR_BOUNDARY_CROSSING_POINT',
    RUNWAY_THRESHOLD = 'RUNWAY_THRESHOLD',
    PRESCRIBED_EET_POINT = 'PRESCRIBED_EET_POINT',
    ENTRY_CONSTRAINED_AIRSPACE = 'ENTRY_CONSTRAINED_AIRSPACE',
    AIRPORT_REFERENCE_LOCATION = 'AIRPORT_REFERENCE_LOCATION',
}
export enum UomGroundSpeedEnum {
    KM_H = 'KM_H',
    KT = 'KT',
}
export interface TrajectoryPointReferenceTypeDto {
    href?: string;
    identifier?: string;
    type?: string;
}
export interface TemperatureTypeDto {
    uom?: UomTemperatureEnum;
    value?: number;
}
export interface WindDirectionTypeDto extends AngleTypeDto {}
export interface WindSpeedTypeDto {
    uom?: UomWindSpeedEnum;
    value?: number;
}
export enum UomWindSpeedEnum {
    KM_H = 'KM_H',
    KT = 'KT',
    M_SEC = 'M_SEC',
    MPH = 'MPH',
}
export enum UomTemperatureEnum {
    C = 'C',
    F = 'F',
    K = 'K',
    R = 'R',
}
export enum UomPressureEnum {
    ATM = 'ATM',
    BAR = 'BAR',
    HPA = 'HPA',
    INHG = 'INHG',
    MBAR = 'MBAR',
    PA = 'PA',
    PSI = 'PSI',
    TORR = 'TORR',
}
export enum PlannedDelayTypeEnum {
    OPERATOR_REQUEST_POINT = 'OPERATOR_REQUEST_POINT',
    OPERATOR_REQUEST_SEGMENT = 'OPERATOR_REQUEST_SEGMENT',
    OPERATOR_REQUEST_AIRSPACE = 'OPERATOR_REQUEST_AIRSPACE',
    OPERATOR_REQUEST_AERODROME = 'OPERATOR_REQUEST_AERODROME',
    OPERATOR_REQUEST_HOLDING = 'OPERATOR_REQUEST_HOLDING',
    ATFM = 'ATFM',
}
export enum DepartureOrArrivalIndicatorEnum {
    DEPARTURE = 'DEPARTURE',
    ARRIVAL = 'ARRIVAL',
}
export interface LevelConstraintTypeDto {
    activation?: ActivationEnum;
    level?: FlightLevelOrAltitudeOrRangeChoiceTypeDto;
}
export interface RestrictionReferenceTypeDto {
    href?: string;
    restrictionIdentifier?: string;
    restrictionType?: string;
}
export interface SpeedConstraintTypeDto {
    activation?: ActivationEnum;
    speed?: TrueAirspeedChoiceTypeDto;
}
export interface TimeConstraintTypeDto {
    timeSpecification?: TimeChoiceTypeDto;
}
export interface TimeChoiceTypeDto {
    range?: TimePeriod;
    value?: Date;
}
export interface TrueAirspeedChoiceTypeDto {
    range?: TrueAirspeedRangeTypeDto;
    value?: TrueAirspeedTypeDto;
}
export interface TrueAirspeedRangeTypeDto {
    lowerSpeed?: TrueAirspeedTypeDto;
    upperSpeed?: TrueAirspeedTypeDto;
}
export interface FlightLevelOrAltitudeOrRangeChoiceTypeDto {
    altitude?: AltitudeTypeDto;
    level?: FlightLevelTypeDto;
    range?: VerticalRangeTypeDto;
}
export interface ProfilePointTypeDto {
    airspeed?: TrueAirspeedTypeDto;
    distance?: DistanceTypeDto;
    level?: FlightLevelOrAltitudeChoiceTypeDto;
    seqNum?: number;
    timeInSec?: number;
}
export interface FlightIdentificationExtensionTypeDto {
    clazz?: string;
}
export const FLIGHT_IDENTIFICATION_EXTENSION_TYPE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.fixm.FlightIdentificationExtensionTypeDto';
export interface GloballyUniqueFlightIdentifierTypeDto extends UniversallyUniqueIdentifierTypeDto {
    creationTime?: Date;
    namespaceDomain?: NamespaceDomainEnum;
    namespaceIdentifier?: string;
}
export interface IataFlightDesignatorTypeDto {
    flightNumber?: number;
    iataOperatorCode?: string;
    operationalSuffix?: string;
}
export enum NamespaceDomainEnum {
    FULLY_QUALIFIED_DOMAIN_NAME = 'FULLY_QUALIFIED_DOMAIN_NAME',
    LOCATION_INDICATOR = 'LOCATION_INDICATOR',
    OPERATING_AGENCY_DESIGNATOR = 'OPERATING_AGENCY_DESIGNATOR',
}
export interface BoundaryCrossingTypeDto {
    altitudeInTransition?: AltitudeInTransitionTypeDto;
    clearedLevel?: FlightLevelOrAltitudeChoiceTypeDto;
    crossingPoint?: SignificantPointChoiceTypeDto;
    crossingTime?: Date;
}
export interface AltitudeInTransitionTypeDto {
    crossingCondition?: BoundaryCrossingConditionEnum;
    level?: FlightLevelOrAltitudeChoiceTypeDto;
}
export enum BoundaryCrossingConditionEnum {
    AT_OR_ABOVE = 'AT_OR_ABOVE',
    AT_OR_BELOW = 'AT_OR_BELOW',
}
export interface ActualTimeOfDepartureTypeDto {
    position?: GeographicalPositionTypeDto;
    time?: Date;
    type?: DepartureTimeTypeEnum;
}
export interface DeparturePointChoiceTypeDto {
    designatedPoint?: DesignatedPointTypeDto;
    navaid?: NavaidTypeDto;
    position?: GeographicalPositionTypeDto;
    relativePoint?: RelativePointTypeDto;
}
export enum AirfileIndicatorEnum {
    AIRFILE = 'AIRFILE',
}
export interface RunwayDirectionDesignatorTypeDto {
    href?: string;
    value?: string;
}
export enum DepartureTimeTypeEnum {
    OFF_BLOCKS = 'OFF_BLOCKS',
    START_TAKEOFF_ROLL = 'START_TAKEOFF_ROLL',
    WHEELS_OFF = 'WHEELS_OFF',
}
export interface ReclearanceInFlightTypeDto {
    filedRevisedDestinationAerodrome?: AerodromeReferenceTypeDto;
    routeToRevisedDestination?: string;
}
export interface ActualTimeOfArrivalTypeDto {
    position?: GeographicalPositionTypeDto;
    time?: Date;
    type?: ArrivalTimeTypeEnum;
}
export enum ArrivalTimeTypeEnum {
    END_LANDING_ROLL = 'END_LANDING_ROLL',
    IN_BLOCKS = 'IN_BLOCKS',
    WHEELS_ON = 'WHEELS_ON',
}
export enum AircraftApproachCategoryEnum {
    A = 'A',
    B = 'B',
    C = 'C',
    D = 'D',
    E = 'E',
    H = 'H',
}
export interface AircraftTypeTypeDto {
    aircraftCount?: number;
    icaoAircraftTypeDesignator?: string;
    otherAircraftType?: string;
}
export interface FlightCapabilitiesTypeDto {
    communication?: CommunicationCapabilitiesTypeDto;
    navigation?: NavigationCapabilitiesTypeDto;
    standardCapabilities?: StandardCapabilitiesIndicatorEnum;
    surveillance?: SurveillanceCapabilitiesTypeDto;
    survival?: SurvivalCapabilitiesTypeDto;
}
export enum WakeTurbulenceCategoryTypeEnum {
    L = 'L',
    M = 'M',
    H = 'H',
    J = 'J',
}
export interface CommunicationCapabilitiesTypeDto {
    communicationCapabilityCode?: Array<CommunicationCapabilityCodeEnum>;
    datalinkCommunicationCapabilityCode?: Array<DatalinkCommunicationCapabilityCodeEnum>;
    otherCommunicationCapabilities?: string;
    otherDatalinkCapabilities?: string;
    selectiveCallingCode?: string;
}
export interface NavigationCapabilitiesTypeDto {
    navigationCapabilityCode?: Array<NavigationCapabilityCodeEnum>;
    otherNavigationCapabilities?: string;
    performanceBasedCode?: Array<PerformanceBasedNavigationCapabilityCodeEnum>;
    requiredRunwayVisualRange?: DistanceTypeDto;
}
export enum StandardCapabilitiesIndicatorEnum {
    STANDARD = 'STANDARD',
}
export interface SurveillanceCapabilitiesTypeDto {
    otherSurveillanceCapabilities?: string;
    surveillanceCapabilityCode?: Array<SurveillanceCapabilityCodeEnum>;
}
export interface SurvivalCapabilitiesTypeDto {
    carriedEltHexIdentifier?: Array<string>;
    dinghyInformation?: DinghiesTypeDto;
    emergencyRadioCapabilityType?: Array<EmergencyRadioCapabilityEnum>;
    lifeJacketType?: Array<LifeJacketEnum>;
    survivalEquipmentRemarks?: string;
    survivalEquipmentType?: Array<SurvivalEquipmentEnum>;
}
export interface DinghiesTypeDto {
    colour?: string;
    covered?: DinghyCoverIndicatorEnum;
    number?: number;
    totalCapacity?: number;
}
export enum EmergencyRadioCapabilityEnum {
    ULTRA_HIGH_FREQUENCY = 'ULTRA_HIGH_FREQUENCY',
    VERY_HIGH_FREQUENCY = 'VERY_HIGH_FREQUENCY',
    EMERGENCY_LOCATOR_TRANSMITTER = 'EMERGENCY_LOCATOR_TRANSMITTER',
}
export enum LifeJacketEnum {
    FLUORESCENCE = 'FLUORESCENCE',
    VERY_HIGH_FREQUENCY = 'VERY_HIGH_FREQUENCY',
    LIGHTS = 'LIGHTS',
    ULTRA_HIGH_FREQUENCY = 'ULTRA_HIGH_FREQUENCY',
}
export enum SurvivalEquipmentEnum {
    POLAR = 'POLAR',
    DESERT = 'DESERT',
    MARITIME = 'MARITIME',
    JUNGLE = 'JUNGLE',
}
export enum DinghyCoverIndicatorEnum {
    COVERED = 'COVERED',
}
export enum SurveillanceCapabilityCodeEnum {
    A = 'A',
    B_1 = 'B_1',
    B_2 = 'B_2',
    C = 'C',
    D_1 = 'D_1',
    E = 'E',
    G_1 = 'G_1',
    H = 'H',
    I = 'I',
    L = 'L',
    P = 'P',
    S = 'S',
    U_1 = 'U_1',
    U_2 = 'U_2',
    V_1 = 'V_1',
    V_2 = 'V_2',
    X = 'X',
}
export enum NavigationCapabilityCodeEnum {
    A = 'A',
    B = 'B',
    C = 'C',
    D = 'D',
    F = 'F',
    G = 'G',
    I = 'I',
    K = 'K',
    L = 'L',
    O = 'O',
    T = 'T',
    W = 'W',
    X = 'X',
}
export enum PerformanceBasedNavigationCapabilityCodeEnum {
    A_1 = 'A_1',
    B_1 = 'B_1',
    B_2 = 'B_2',
    B_3 = 'B_3',
    B_4 = 'B_4',
    B_5 = 'B_5',
    B_6 = 'B_6',
    C_1 = 'C_1',
    C_2 = 'C_2',
    C_3 = 'C_3',
    C_4 = 'C_4',
    D_1 = 'D_1',
    D_2 = 'D_2',
    D_3 = 'D_3',
    D_4 = 'D_4',
    L_1 = 'L_1',
    O_1 = 'O_1',
    O_2 = 'O_2',
    O_3 = 'O_3',
    O_4 = 'O_4',
    S_1 = 'S_1',
    S_2 = 'S_2',
    T_1 = 'T_1',
    T_2 = 'T_2',
}
export enum CommunicationCapabilityCodeEnum {
    E_1 = 'E_1',
    E_2 = 'E_2',
    E_3 = 'E_3',
    H = 'H',
    M_1 = 'M_1',
    M_2 = 'M_2',
    M_3 = 'M_3',
    P_1 = 'P_1',
    P_2 = 'P_2',
    P_3 = 'P_3',
    P_4 = 'P_4',
    P_5 = 'P_5',
    P_6 = 'P_6',
    P_7 = 'P_7',
    P_8 = 'P_8',
    P_9 = 'P_9',
    U = 'U',
    V = 'V',
    Y = 'Y',
}
export enum DatalinkCommunicationCapabilityCodeEnum {
    J_1 = 'J_1',
    J_2 = 'J_2',
    J_3 = 'J_3',
    J_4 = 'J_4',
    J_5 = 'J_5',
    J_6 = 'J_6',
    J_7 = 'J_7',
}
export enum AltitudeSourceEnum {
    BAROMETRIC = 'BAROMETRIC',
    GNSS = 'GNSS',
}
export interface AltitudeTypeWithSourceDto extends AltitudeTypeDto {
    source?: AltitudeSourceEnum;
    uom?: UomAltitudeEnum;
    value?: number;
}
export enum EuropeanIndicatorEnum {
    OAT = 'OAT',
    PROTECTED = 'PROTECTED',
}
export enum MilitaryFlightRulesEnum {
    GAT = 'GAT',
    OAT = 'OAT',
}
export interface NmFlightExtensionTypeDto extends FlightExtensionTypeDto {
    aoWhatIfReRouteIndicator?: number;
    eurSpecialHandling?: EuropeanIndicatorEnum;
    ifpsFlightPlanIndicator?: Array<string>;
    ifpsIdentifier?: string;
    replacementFlightPlanIndicator?: number;
    stayInformation?: Array<string>;
}
export const NM_FLIGHT_EXTENSION_TYPE_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.fixm.NmFlightExtensionTypeDto';
export interface NmFlightIdentificationExtensionTypeDto extends FlightIdentificationExtensionTypeDto {
    iataFlightDesignator?: string;
}
export const NM_FLIGHT_IDENTIFICATION_EXTENSION_TYPE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.fixm.NmFlightIdentificationExtensionTypeDto';
export interface NmFlightRouteInformationExtensionTypeDto extends FlightRouteInformationExtensionTypeDto {
    estimatedElapsedTime?: Array<EstimatedElapsedTimeTypeDto>;
    routeText?: string;
}
export const NM_FLIGHT_ROUTE_INFORMATION_EXTENSION_TYPE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.fixm.NmFlightRouteInformationExtensionTypeDto';
export interface NmRouteTrajectoryElementExtensionTypeDto extends RouteTrajectoryElementExtensionTypeDto {
    militaryFlightRulesChange?: MilitaryFlightRulesEnum;
    weight?: MassTypeDto;
}
export const NM_ROUTE_TRAJECTORY_ELEMENT_EXTENSION_TYPE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.fixm.NmRouteTrajectoryElementExtensionTypeDto';
export interface NmRouteTrajectoryGroupContainerExtensionTypeDto extends RouteTrajectoryGroupContainerExtensionTypeDto {
    proposedRoute?: string;
    rejected?: RouteTrajectoryGroupTypeDto;
}
export const NM_ROUTE_TRAJECTORY_GROUP_CONTAINER_EXTENSION_TYPE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.fixm.NmRouteTrajectoryGroupContainerExtensionTypeDto';
export interface NmSupplementaryDataTypeDto {
    aoWhatIfReRouteIndicator?: number;
    europeanSpecialHandling?: EuropeanIndicatorEnum;
    ifpsFlightPlanIndicator?: Array<string>;
    replacementFlightPlanIndicator?: number;
    runwayVisibilityRange?: DistanceTypeDto;
    stayInformation?: Array<string>;
}
export interface RankedTrajectoryTypeDto {
    identifier?: string;
    routeTrajectory?: RouteTrajectoryGroupTypeDto;
    seqNum?: number;
}
export interface SimulatedTakeOff {
    flightId?: FlightId;
    inFlightCache?: boolean;
    realAtot?: Date;
    reallyAirborne?: boolean;
    reportedAirborne?: boolean;
    simulatedAtot?: Date;
    simulatedAtotBaseline?: Date;
}
export interface SimulatedTakeOffList {
    actualDistributions?: Array<RangeProbability>;
    probabilites?: Array<RangeProbability>;
    simulatedTakeOffs?: Array<SimulatedTakeOff>;
}
export interface RangeProbability {
    probability?: number;
    range?: DoubleRange;
}
export interface DescriptiveStatsDto extends SummaryStatsDto {
    median?: number;
    percentile25?: number;
    percentile75?: number;
}
export interface SummaryStatsDto {
    max?: number;
    mean?: number;
    min?: number;
    n?: number;
    stdDev?: number;
    sum?: number;
}
export enum FlowOrigin {
    UPSTREAM = 'UPSTREAM',
    DOWNSTREAM = 'DOWNSTREAM',
}
export interface Flow {
    elements?: Array<FlowElement>;
    id?: string;
}
export interface FlowElement extends RefLocation {
    flowOrigin?: FlowOrigin;
    seqNumber?: number;
}
export interface UserManagedSimulationDto extends SimulationDto {
    creatorAnuId?: string;
    creatorUserId?: string;
    datasetReference?: DatasetReferenceDto;
}
export const USER_MANAGED_SIMULATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.simulation.UserManagedSimulationDto';
export interface SimulationDto {
    clazz?: string;
    dataset?: DatasetDto;
    description?: string;
    knownSimulations?: Array<SimulationDto>;
    publicationTime?: Date;
    simulationEngineId?: string;
    simulationName?: string;
    simulationPeriod?: TimePeriod;
}
export const SIMULATION_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.simulation.SimulationDto';
export interface DatasetReferenceDto {
    simulationId?: string;
    type?: DatasetReferenceType;
}
export enum DatasetReferenceType {
    FORECAST = 'FORECAST',
    OPERATIONAL = 'OPERATIONAL',
    STANDALONE_SIMEX = 'STANDALONE_SIMEX',
}
export interface NmocManagedSimulationDto extends SimulationDto {
    datasetReference?: DatasetReferenceDto;
}
export const NMOC_MANAGED_SIMULATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.simulation.NmocManagedSimulationDto';
export interface SimulationAvailabilityDto {
    numAvailableSimulations?: number;
    numSimulationsInUse?: number;
    simulatablePeriod?: TimePeriod;
}
export interface SimulationAvailabilityPerReference {
    datasetReference?: DatasetReferenceDto;
    simulationAvailabilities?: Array<SimulationAvailabilityDto>;
}
export interface SimulationListRequestDto {
    datasetReference?: DatasetReferenceDto;
    simulationId?: string;
}
export interface SimulationMeasureRevertRequestDto {
    dataset?: DatasetDto;
    measureId?: MeasureId;
}
export interface StandaloneSimexDto extends SimulationDto {}
export const STANDALONE_SIMEX_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.simulation.StandaloneSimexDto';
export interface IcaoRouteError_InvalidRouteError extends IcaoRouteError {}
export interface IcaoRouteError_DBEPointConflictError extends IcaoRouteError {}
export enum IcaoRouteError_ErrorType {
    UNKNOWN_ROUTE = 'UNKNOWN_ROUTE',
    INVALID_ROUTE = 'INVALID_ROUTE',
    UNKNOWN_POINT = 'UNKNOWN_POINT',
    DBE_POINT_CONFLICT = 'DBE_POINT_CONFLICT',
}
export interface IcaoRouteError {
    message?: string;
    type?: IcaoRouteError_ErrorType;
}
export enum ComputeMode {
    VARIABILITY = 'VARIABILITY',
    DELAY = 'DELAY',
}
export interface AirportDashboardKpiRequest {
    aerodromeIds?: Array<string>;
    computeMode?: ComputeMode;
    futureTimePeriodInMs?: number;
    pastTimePeriodInMs?: number;
}
export interface AirportDashboardKpis {
    accuracyAtaCta?: DescriptiveStatsDto;
    accuracyAtaEta?: DescriptiveStatsDto;
    accuracyAtcTtot?: DescriptiveStatsDto;
    accuracyCtot?: DescriptiveStatsDto;
    accuracyNonRegEtot?: DescriptiveStatsDto;
    accuracyPreSeqTtot?: DescriptiveStatsDto;
    airportDelayInFuture?: DescriptiveStatsDto;
    airportDelayInPast?: DescriptiveStatsDto;
    atfmDelayInFuture?: DescriptiveStatsDto;
    atfmDelayInPast?: DescriptiveStatsDto;
    query?: AirportDashboardKpiRequest;
}
export interface AirportTrendKpiRequest {
    aerodromeIds?: Array<string>;
    timeRange?: TimeRange;
}
export interface AirportTrendKpis_TimeSliceData {
    airportDelayInMin?: number;
    atfcmDelayInMin?: number;
    numDepartedFlights?: number;
    numFlights?: number;
    numOffBlockFlights?: number;
    numRegulatedFlights?: number;
    numSequencedFlights?: number;
    numSuspendedFlights?: number;
    numTargetedFlights?: number;
    takeOffDelayInMin?: number;
}
export interface AirportTrendKpis {
    demandDelayTrend?: Array<AirportTrendKpis_TimeSliceData>;
    request?: AirportTrendKpiRequest;
    timeRange?: TimeRange;
}
export interface ArrivalVariabilityKpiRequest {
    aerodromeIds?: Array<string>;
    computeMode?: ComputeMode;
    futureTimePeriodInMs?: number;
    ignoreNonDeparted?: boolean;
    pastTimePeriodInMs?: number;
    timeDeltaRangeInMs?: LongRange;
    tvId?: string;
}
export interface ArrivalVariabilityKpis {
    actualCalculatedInFuture?: DescriptiveStatsDto;
    actualCalculatedInPast?: DescriptiveStatsDto;
    actualEstimatedInFuture?: DescriptiveStatsDto;
    actualEstimatedInPast?: DescriptiveStatsDto;
    ataCtaInFuture?: DescriptiveStatsDto;
    ataCtaInPast?: DescriptiveStatsDto;
    ataEtaInFuture?: DescriptiveStatsDto;
    ataEtaInPast?: DescriptiveStatsDto;
    flights?: Array<FlightDto>;
    request?: ArrivalVariabilityKpiRequest;
}
export interface HistoricalLoadComparison {
    countType?: CountType;
    historicalData?: HistoricalLoadData;
    hourlyEntryCapacity?: Array<CapacityValue>;
    liveTimeRange?: TimeRange;
    liveTotals?: Array<number>;
    otmvDefns?: Array<Otmv>;
}
export interface HistoricalLoadData_TimeSliceData {
    averageTotal?: number;
    maxTotal?: number;
    percentageHighDays?: number;
    percentageLowDays?: number;
}
export interface HistoricalLoadData {
    loadData?: Array<HistoricalLoadData_TimeSliceData>;
    numDaysUsed?: number;
}
export interface HistoricalLoadComparisonRequest extends AbstractFlightRelatedRequest {
    algorithm?: CountsAlgorithm;
    countType?: CountType;
    durationInMin?: number;
    includeForecastFlights?: boolean;
    intervalInMin?: number;
    timePeriod?: TimePeriod;
    tvId?: string;
}
export const HISTORICAL_LOAD_COMPARISON_REQUEST_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.kpi.historical.HistoricalLoadComparisonRequest';
export interface MeasureKpisDto {
    flightDeltas?: Array<MeasureFlightDeltas>;
    measureId?: MeasureId;
    tvId?: string;
}
export enum MeasureKpisRequestDto_ComparisonMode {
    COMPARE_WITH_OTHER_DATASET = 'COMPARE_WITH_OTHER_DATASET',
    COMPARE_PROPOSAL_TO_NORMAL = 'COMPARE_PROPOSAL_TO_NORMAL',
}
export interface MeasureKpisRequestDto {
    comparisonMode?: MeasureKpisRequestDto_ComparisonMode;
    dataset?: DatasetDto;
    day?: Date;
    measureId?: MeasureId;
    otherDataset?: DatasetDto;
}
export interface ReroutedFlightDeltas extends MeasureFlightDeltas {
    newEetInMs?: number;
    newFuelConsumptionInKg?: number;
    newRoute?: string;
    newRouteChargesInEuros?: number;
    newRouteLengthInNm?: number;
    origEetInMs?: number;
    origFuelConsumptionInKg?: number;
    origRoute?: string;
    origRouteChargesInEuros?: number;
    origRouteLengthInNm?: number;
}
export const REROUTED_FLIGHT_DELTAS_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.kpi.measure.ReroutedFlightDeltas';
export interface MeasureFlightDeltas {
    clazz?: string;
    acType?: string;
    flightId?: FlightId;
    newCtot?: Date;
    newDelayInMs?: number;
    newSuspensionStatus?: SuspensionStatus;
    newWorstMcdmState?: McdmState;
    origCtot?: Date;
    origDelayInMs?: number;
}
export const MEASURE_FLIGHT_DELTAS_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.kpi.measure.MeasureFlightDeltas';
export interface FlightListCharacteristics {
    numAirborne?: number;
    numAirborneFirst10Minutes?: number;
    numAllocatedSlot?: number;
    numAtCdmAirport?: number;
    numNotYetCdmPreSequenced?: number;
    numOnGround?: number;
    numPreAllocatedSlot?: number;
    numSuspended?: number;
}
export interface OccupancyEntryLoadComparisonRequest extends AbstractFlightRelatedRequest {
    algorithm?: CountsAlgorithm;
    dataset?: DatasetDto;
    entryDurationInMin?: number;
    entryIntervalInMin?: number;
    occDurationInMin?: number;
    proposalContexts?: Array<string>;
    timePeriod?: TimePeriod;
    tvId?: string;
}
export const OCCUPANCY_ENTRY_LOAD_COMPARISON_REQUEST_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.kpi.occupancy.OccupancyEntryLoadComparisonRequest';
export interface OccupancyVariabilityKpiRequest extends AbstractFlightRelatedRequest {
    algorithm?: CountsAlgorithm;
    capacityModel?: CapacityModel;
    durationInMin?: number;
    extraFlightWindowInMinutes?: number;
    tvId?: string;
    unt?: Date;
    wef?: Date;
}
export const OCCUPANCY_VARIABILITY_KPI_REQUEST_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.kpi.occupancy.OccupancyVariabilityKpiRequest';
export interface OccupancyEntryLoadComparison {
    entryCounts?: TrafficCountsDto;
    request?: OccupancyEntryLoadComparisonRequest;
    summaryOccupancyCounts?: Array<SummaryStatsDto>;
}
export interface OccupancyVariabilityKpi {
    counts?: TrafficCountsDto;
    flightCharacteristics?: FlightListCharacteristics;
    flights?: Array<FlightDto>;
    observationTime?: Date;
    request?: OccupancyVariabilityKpiRequest;
    summaryLoading?: MonitoredOccupancyLoadValues;
}
export interface RegulationComplianceFlightEntry {
    atDepartureAirport?: boolean;
    deltaFlightLevel?: number;
    deltaInMs?: number;
    flightId?: FlightId;
    measureId?: MeasureId;
    orWasAirborne?: boolean;
}
export interface RegulationComplianceKpi {
    entries?: Array<RegulationComplianceFlightEntry>;
    measures?: Array<MeasureId>;
    request?: RegulationComplianceKpiRequest;
    totalDelay?: DescriptiveStatsDto;
}
export interface RegulationComplianceKpiRequest {
    computeMode?: ComputeMode;
    datasetDto?: DatasetDto;
    day?: Date;
    tvSet?: string;
}
export interface RegulationSituation_InfluencingRegulation {
    numConcernedFlights?: number;
    regulationId?: string;
    totalConcernedFlightDelayInMin?: number;
}
export interface RegulationSituation_InfluencedRegulation {
    numMprFlights?: number;
    regulationId?: string;
    totalRegulationDelayInMin?: number;
}
export interface RegulationSituation {
    influencedRegulations?: Array<RegulationSituation_InfluencedRegulation>;
    influencingRegulations?: Array<RegulationSituation_InfluencingRegulation>;
    numConcernedFlights?: number;
    numConcernedFlightsPreTactAct?: number;
    numMprFlights?: number;
    numMprFlightsPreTactAct?: number;
    numUnconcernedFlights?: number;
    numUnconcernedFlightsDueToExemption?: number;
    numUnconcernedFlightsDueToForce?: number;
    regulation?: RegulationDto;
    totalConcernedFlightDelayInMin?: number;
    totalConcernedFlightPreTactActDelayInMin?: number;
    totalRegulationAllocatedDelayInMin?: number;
    totalRegulationDelayInMin?: number;
    totalRegulationPreTactActDelayInMin?: number;
    totalUnconcernedFlightDelayInMin?: number;
}
export interface RegulationSituationKpis {
    overallInfluencedRegulations?: Array<RegulationSituation_InfluencedRegulation>;
    overallInfluencingRegulations?: Array<RegulationSituation_InfluencingRegulation>;
    regulationSituations?: Array<RegulationSituation>;
    request?: RegulationSituationKpisRequest;
}
export interface RegulationSituationKpisRequest extends AbstractFlightRelatedRequest {
    day?: Date;
    ignoreUnconcerned?: boolean;
    ignoreZeroDelayRegulations?: boolean;
    includeForecastFlights?: boolean;
    reasons?: Array<RegulationReasonType>;
    states?: Array<RegulationState>;
    trafficType?: TrafficType;
    tvSetIds?: Array<string>;
}
export const REGULATION_SITUATION_KPIS_REQUEST_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.kpi.regulation.situation.RegulationSituationKpisRequest';
export interface TvEntryKpiRequest {
    computeMode?: ComputeMode;
    futureTimePeriodInMs?: number;
    ignoreNonDeparted?: boolean;
    ignoreZeroDelayFlights?: boolean;
    pastTimePeriodInMs?: number;
    timeDeltaRangeInMs?: LongRange;
    tvId?: string;
}
export interface TvEntryKpis {
    atoCtoInFuture?: DescriptiveStatsDto;
    atoCtoInPast?: DescriptiveStatsDto;
    atoEtoInFuture?: DescriptiveStatsDto;
    atoEtoInPast?: DescriptiveStatsDto;
    flights?: Array<FlightDto>;
    numIntruders?: number;
    request?: TvEntryKpiRequest;
}
export interface AerodromeListRequest {
    aerodrometWildcardIds?: Array<string>;
    bounds?: LatLongBounds;
    dataset?: DatasetDto;
}
export interface AirspaceIdList {
    airspaceIdList?: Array<AirspaceRef>;
}
export interface AirspaceIdListRequest {
    airspaceWildcardIds?: Array<string>;
    bounds?: LatLongBounds;
    dataset?: DatasetDto;
    levelBand?: FlightLevelBand;
    types?: Array<AirspaceType>;
}
export interface AirspaceIdsWithSectorConfigurationRequest {
    airspaceWildcardIds?: Array<string>;
    bounds?: LatLongBounds;
    dataset?: DatasetDto;
}
export interface AirspaceList {
    airspaceList?: Array<Airspace>;
}
export interface AirspaceListRequest {
    airspaceReferences?: Array<AirspaceRef>;
    dataset?: DatasetDto;
}
export interface AirspaceSummaryListRequest {
    airspaceWildcardIds?: Array<string>;
    bounds?: LatLongBounds;
    dataset?: DatasetDto;
    recursive?: boolean;
    types?: Array<AirspaceType>;
}
export interface KmlSectorConfigurationPlansRequest {
    auaOrClusters?: Array<string>;
    dataset?: DatasetDto;
    day?: Date;
}
export interface MapSectorConfigurationPlan {
    airspaceList?: Array<Airspace>;
    configPlan?: SectorConfigurationPlanDto;
}
export interface MapSectorConfigurationPlanRequest {
    airspaceId?: string;
    dataset?: DatasetDto;
    day?: Date;
    retrieveOnlyUsedAirspace?: boolean;
}
export enum NamedPoint_Type {
    NAVPOINT = 'NAVPOINT',
    AERODROME = 'AERODROME',
}
export interface NamedPoint {
    id?: string;
    position?: LatLonPoint;
    type?: NamedPoint_Type;
}
export interface NavigationPointListRequest {
    bounds?: LatLongBounds;
    dataset?: DatasetDto;
    navPtWildcardIds?: Array<string>;
    types?: Array<NavPointType>;
}
export interface TvMapLocation {
    airspace?: Airspace;
    point?: NamedPoint;
}
export interface MapAresVolumeSetListRequestDto extends AresVolumeSetListRequestDto {
    airspaceRef?: AirspaceRef;
    bounds?: LatLongBounds;
    forceSelection?: boolean;
    unt?: Date;
    wef?: Date;
}
export const MAP_ARES_VOLUME_SET_LIST_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.map.asm.MapAresVolumeSetListRequestDto';
export interface MapAtcVolumeSetListRequestDto extends AtcVolumeSetListRequestDto {
    airspaceRef?: AirspaceRef;
    bounds?: LatLongBounds;
    forceSelection?: boolean;
    unt?: Date;
    wef?: Date;
}
export const MAP_ATC_VOLUME_SET_LIST_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.map.asm.MapAtcVolumeSetListRequestDto';
export interface TvImpactedByAresVolumeSetReplyDto_TvAndTimePeriod {
    impactedPeriod?: TimePeriod;
    tvId?: string;
}
export interface TvImpactedByAresVolumeSetReplyDto {
    airspaceReservation?: DynamicVolumeSetDto;
    impactedTvs?: Array<TvImpactedByAresVolumeSetReplyDto_TvAndTimePeriod>;
    request?: TvImpactedByAresVolumeSetRequestDto;
}
export interface TvImpactedByAresVolumeSetRequestDto {
    activeTvsOnly?: boolean;
    dataset?: DatasetDto;
    day?: Date;
    dynamicVolumeId?: string;
    dynamicVolumeSetId?: string;
    tvSetId?: string;
}
export interface EnvDataReference {
    id?: string;
    type?: EnvDataType;
}
export enum EnvDataType {
    ASP = 'ASP',
    AB = 'AB',
    FLOW = 'FLOW',
    TV = 'TV',
    TVSET = 'TVSET',
    AD = 'AD',
    AZ = 'AZ',
    PT = 'PT',
}
export interface EnvWhereUsedReply {
    request?: EnvWhereUsedRequest;
    usedReferences?: Array<EnvDataReference>;
}
export interface EnvWhereUsedRequest {
    dataset?: DatasetDto;
    envReference?: EnvDataReference;
}
export interface VpdDynamicVolumeOutlineDto {
    active?: boolean;
    centroid?: LevelAndTime;
    dynamicVolumeId?: string;
    dynamicVolumeSetId?: string;
    kind?: DynamicVolumeSetKindEnum;
    polygon?: Array<LevelAndTime>;
    status?: DynamicVolumeSetStatusEnum;
}
export interface VpdAirblockDto {
    airblockId?: string;
    levelBand?: FlightLevelBand;
    timePeriod?: TimePeriod;
}
export interface VpdAirspaceDto {
    airspaceId?: string;
    vpdAirblocks?: Array<VpdAirblockDto>;
}
export interface MapFlightsDataDto {
    airspaces?: Array<Airspace>;
    flights?: Array<FlightDto>;
    tvMapLocations?: Array<TvMapLocation>;
    vpdFlightDataList?: Array<VpdFlightDataDto>;
}
export interface VpdFlightDataDto {
    ctfmAirspaceCrossingProfile?: VpdFlightAirspaceCrossingProfileDto;
    flightId?: EnrichedFlightId;
    ftfmAirspaceCrossingProfile?: VpdFlightAirspaceCrossingProfileDto;
    rtfmAirspaceCrossingProfile?: VpdFlightAirspaceCrossingProfileDto;
}
export interface VpdFlightAirspaceCrossingProfileDto {
    airspaceCrossings?: Array<VpdAirspaceOutlineDto>;
    airspaceReservationsOfInterest?: Array<VpdDynamicVolumeOutlineDto>;
    otherAirspaceOfInterest?: Array<VpdAirspaceOutlineDto>;
}
export interface VpdAirspaceOutlineDto {
    airspaceId?: string;
    centroid?: LevelAndTime;
    hasMpr?: boolean;
    hotspots?: Array<HotspotDto>;
    polygon?: Array<LevelAndTime>;
    regulationIds?: Array<string>;
}
export interface MapFlightsDataRequestDto extends AbstractFlightRelatedRequest {
    airspaceIdList?: Array<string>;
    allFlightProfiles?: boolean;
    extraFlightAndDatasets?: Array<FlightIdAndDataset>;
    extraNeededFlightFields?: Array<FlightFieldType>;
    flights?: Array<FlightId>;
    includeHotspots?: boolean;
    retrieveVpdDynamicVolumeOfInterest?: boolean;
    retrieveVpdFlightData?: boolean;
    retrieveVpdOtherAirspaceOfInterest?: boolean;
    tvIdList?: Array<string>;
}
export const MAP_FLIGHTS_DATA_REQUEST_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.map.flights.MapFlightsDataRequestDto';
export interface MapHotspotListRequest {
    activeOnly?: boolean;
    bounds?: LatLongBounds;
    dataset?: DatasetDto;
    kind?: HotspotKind;
    levelBand?: FlightLevelBand;
    minSeverity?: HotspotSeverity;
    timePeriod?: TimePeriod;
}
export interface MapHotspot {
    hotspotDto?: HotspotDto;
    mapTrafficVolume?: MapTrafficVolume;
}
export interface MapHotspotListReply {
    hotspots?: Array<MapHotspot>;
}
export interface FlowListRequest {
    dataset?: DatasetDto;
    flowWildcardIds?: Array<string>;
}
export interface MapTrafficVolumeListRequest {
    dataset?: DatasetDto;
    tvIdList?: Array<string>;
}
export enum TrafficVolumeListRequest_IdType {
    TV = 'TV',
    TVSET = 'TVSET',
}
export interface TrafficVolumeListRequest {
    bounds?: LatLongBounds;
    dataset?: DatasetDto;
    idType?: TrafficVolumeListRequest_IdType;
    levelBand?: FlightLevelBand;
    refLocTypes?: Array<RefLocationType>;
    wildcardIds?: Array<string>;
}
export interface TrafficVolumeSetIdListRequest {
    bounds?: LatLongBounds;
    dataset?: DatasetDto;
    tvSetWildcardIds?: Array<string>;
}
export interface TrafficVolumeSetListRequest {
    bounds?: LatLongBounds;
    dataset?: DatasetDto;
    tvSetWildcardIds?: Array<string>;
}
export interface MapTrafficVolume {
    location?: TvMapLocation;
    trafficVolume?: TrafficVolume;
}
export interface NavPointList {
    navPointList?: Array<NavPoint>;
}
export enum MapTileProvider {
    OSGEO = 'OSGEO',
    CARTO_DB = 'CARTO_DB',
}
export interface MapRegulationSituationListRequest {
    activeOnly?: boolean;
    bounds?: LatLongBounds;
    dataset?: DatasetDto;
    levelBand?: FlightLevelBand;
    timePeriod?: TimePeriod;
}
export interface MapRegulationSituation {
    mapTrafficVolume?: MapTrafficVolume;
    regulation?: AtfcmSituationRegulation;
}
export interface MapRegulationSituationListReply {
    regulations?: Array<MapRegulationSituation>;
    regulationsNotProcessed?: Array<string>;
}
export interface MapRouteListReply {
    routes?: Array<Route>;
}
export interface MapRouteListRequest {
    bounds?: LatLongBounds;
    dataset?: DatasetDto;
    day?: Date;
    levelBand?: FlightLevelBand;
    routeId?: string;
    types?: Array<RouteType>;
}
export interface Route {
    clazz?: string;
    biDirectional?: boolean;
    id?: string;
    routeTrack?: Array<RouteSegment>;
    type?: RouteType;
    uuid?: string;
}
export const ROUTE_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.route.Route';
export enum RouteType {
    ENROUTE = 'ENROUTE',
    SID = 'SID',
    STAR = 'STAR',
    IAP = 'IAP',
}
export interface RouteSegment {
    end?: RoutePoint;
    maxLevel?: FlightLevel;
    minLevel?: FlightLevel;
    start?: RoutePoint;
}
export interface RoutePoint {
    aerodrome?: Aerodrome;
    navPoint?: NavPoint;
}
export interface RoutePortion {
    fromPoint?: string;
    routeId?: string;
    toPoint?: string;
}
export interface EnRoute extends Route {}
export const EN_ROUTE_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.route.EnRoute';
export interface IapRoute extends Route {
    aerodrome?: Aerodrome;
}
export const IAP_ROUTE_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.route.IapRoute';
export interface OTSRoute extends EnRoute {
    routeAvailabilities?: Array<OTSRouteAvailability>;
}
export const O_T_S_ROUTE_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.route.OTSRoute';
export interface OTSRouteAvailability {
    availabilityPeriod?: TimePeriod;
    routeTrack?: Array<RouteSegment>;
}
export interface SidRoute extends Route {
    aerodrome?: Aerodrome;
}
export const SID_ROUTE_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.route.SidRoute';
export interface StarRoute extends Route {
    aerodrome?: Aerodrome;
}
export const STAR_ROUTE_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.route.StarRoute';
export enum ATSMessageType {
    AFP = 'AFP',
    ARR = 'ARR',
    CHG = 'CHG',
    CNL = 'CNL',
    DEP = 'DEP',
    DLA = 'DLA',
    FNM = 'FNM',
    FPL = 'FPL',
    MFS = 'MFS',
    RQP = 'RQP',
    RQS = 'RQS',
    OTHER = 'OTHER',
}
export interface AicraftOperatorFilterDto {
    aircraftOperatorsArcId?: Array<string>;
    aircraftOperatorsOpr?: Array<string>;
    operatingAircraftOperators?: Array<string>;
}
export interface AirspaceDataMessageFilterDto extends SubscriptionMessageFilterDto {
    airspaceDataFilter?: AirspaceDataFilterDto;
    datasetTypes?: Array<AixmDatasetType>;
}
export const AIRSPACE_DATA_MESSAGE_FILTER_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.AirspaceDataMessageFilterDto';
export interface SubscriptionMessageFilterDto {
    clazz?: string;
}
export const SUBSCRIPTION_MESSAGE_FILTER_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.SubscriptionMessageFilterDto';
export interface AirspaceDataSubscriptionCreationRequestDto extends SubscriptionCreationRequestDto {
    messageFilter?: AirspaceDataMessageFilterDto;
}
export interface SubscriptionCreationRequestDto {
    description?: string;
    queueName?: string;
}
export interface AirspaceDataSubscriptionDto extends SubscriptionDto {
    messageFilter?: AirspaceDataMessageFilterDto;
}
export const AIRSPACE_DATA_SUBSCRIPTION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.AirspaceDataSubscriptionDto';
export interface SubscriptionDto {
    clazz?: string;
    summary?: SubscriptionSummaryDto;
}
export const SUBSCRIPTION_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.pubsub.SubscriptionDto';
export interface SubscriptionSummaryDto {
    anuId?: string;
    creationDate?: Date;
    description?: string;
    heartbeatEnabled?: boolean;
    lastUpdateComment?: string;
    lastUpdateReason?: SubscriptionUpdateReason;
    lastUpdatedBy?: string;
    lastUpdatedOn?: Date;
    nmVersionId?: NmVersionId;
    queueName?: string;
    state?: SubscriptionState;
    topic?: SubscriptionTopic;
    uuid?: string;
    version?: number;
}
export enum SubscriptionTopic {
    AIRSPACE_DATA = 'AIRSPACE_DATA',
    ATM_INFORMATION = 'ATM_INFORMATION',
    EAUP = 'EAUP',
    FLIGHT_DATA = 'FLIGHT_DATA',
    FFICE_FLIGHT_FILING = 'FFICE_FLIGHT_FILING',
    FLIGHT_FILING_RESULT = 'FLIGHT_FILING_RESULT',
    FLIGHT_PLANS = 'FLIGHT_PLANS',
    MCDM = 'MCDM',
    REGULATIONS = 'REGULATIONS',
    REROUTINGS = 'REROUTINGS',
    FFICE_PUBLICATION = 'FFICE_PUBLICATION',
    DYNAMIC_VOLUME_SETS = 'DYNAMIC_VOLUME_SETS',
    BACKBONE = 'BACKBONE',
    SECTOR_CONFIGURATION_PLAN = 'SECTOR_CONFIGURATION_PLAN',
    KPI_TARGETS_PLAN = 'KPI_TARGETS_PLAN',
}
export enum SubscriptionState {
    ACTIVE = 'ACTIVE',
    DELETED = 'DELETED',
    PAUSED = 'PAUSED',
    SUSPENDED_ACTIVE = 'SUSPENDED_ACTIVE',
    SUSPENDED_PAUSED = 'SUSPENDED_PAUSED',
}
export enum SubscriptionUpdateReason {
    MAINTENANCE = 'MAINTENANCE',
    MSG_EXPIRED = 'MSG_EXPIRED',
    USER_REQUEST = 'USER_REQUEST',
    NM_UPDATE = 'NM_UPDATE',
    QUEUE_OVERFLOW = 'QUEUE_OVERFLOW',
}
export interface AirspaceDataSubscriptionRetrievalRequestDto extends SubscriptionRetrievalRequestDto {}
export interface SubscriptionRetrievalRequestDto {
    uuid?: string;
    version?: number;
}
export interface AirspaceDataSubscriptionUpdateRequestDto extends SubscriptionUpdateRequestDto {
    messageFilter?: AirspaceDataMessageFilterDto;
}
export interface SubscriptionUpdateRequestDto {
    description?: string;
    subscriptionUuid?: string;
}
export interface BackboneMessageDto extends BusinessPubSubMessageDto {
    backbone?: BackboneDto;
}
export const BACKBONE_MESSAGE_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.pubsub.BackboneMessageDto';
export interface BusinessPubSubMessageDto extends PubSubMessageDto {
    parentMessageId?: string;
    subscriptionUuid?: string;
    subscriptionVersion?: number;
    topic?: SubscriptionTopic;
}
export const BUSINESS_PUB_SUB_MESSAGE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.BusinessPubSubMessageDto';
export interface PubSubMessageDto extends MessageDto {
    type?: PubSubMessageType;
}
export const PUB_SUB_MESSAGE_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.pubsub.PubSubMessageDto';
export interface MessageDto {
    clazz?: string;
    mep?: MessageExchangePattern;
    timestamp?: Date;
    uuid?: string;
}
export const MESSAGE_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.pubsub.MessageDto';
export enum PubSubMessageType {
    BUSINESS_MESSAGE = 'BUSINESS_MESSAGE',
    TECHNICAL_MESSAGE = 'TECHNICAL_MESSAGE',
}
export enum MessageExchangePattern {
    PUBLISH_SUBSCRIBE = 'PUBLISH_SUBSCRIBE',
    REQUEST_REPLY = 'REQUEST_REPLY',
}
export interface BackboneMessageFilterDto extends SubscriptionMessageFilterDto {
    airspaceId?: string;
    day?: Date;
}
export const BACKBONE_MESSAGE_FILTER_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.BackboneMessageFilterDto';
export interface BackboneSubscriptionCreationRequestDto extends SubscriptionCreationRequestDto {
    messageFilter?: BackboneMessageFilterDto;
}
export interface BackboneSubscriptionDto extends SubscriptionDto {
    messageFilter?: BackboneMessageFilterDto;
}
export const BACKBONE_SUBSCRIPTION_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.pubsub.BackboneSubscriptionDto';
export interface BackboneSubscriptionRetrievalRequestDto extends SubscriptionRetrievalRequestDto {}
export interface BackboneSubscriptionUpdateRequestDto extends SubscriptionUpdateRequestDto {
    messageFilter?: BackboneMessageFilterDto;
}
export interface DynamicVolumeSetMessageDto extends BusinessPubSubMessageDto {
    dynamicVolumeSet?: DynamicVolumeSetDto;
}
export const DYNAMIC_VOLUME_SET_MESSAGE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.DynamicVolumeSetMessageDto';
export interface DynamicVolumeSetMessageFilterDto extends SubscriptionMessageFilterDto {
    creatingUser?: string;
    dynamicVolumeSetKind?: DynamicVolumeSetKindEnum;
    dynamicVolumes?: Array<string>;
    dynamicVolumesSets?: Array<string>;
}
export const DYNAMIC_VOLUME_SET_MESSAGE_FILTER_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.DynamicVolumeSetMessageFilterDto';
export interface DynamicVolumeSetSubscriptionCreationRequestDto extends SubscriptionCreationRequestDto {
    messageFilter?: DynamicVolumeSetMessageFilterDto;
}
export interface DynamicVolumeSetSubscriptionDto extends SubscriptionDto {
    messageFilter?: DynamicVolumeSetMessageFilterDto;
}
export const DYNAMIC_VOLUME_SET_SUBSCRIPTION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.DynamicVolumeSetSubscriptionDto';
export interface DynamicVolumeSetSubscriptionRetrievalRequestDto extends SubscriptionRetrievalRequestDto {}
export interface DynamicVolumeSetSubscriptionUpdateRequestDto extends SubscriptionUpdateRequestDto {
    messageFilter?: DynamicVolumeSetMessageFilterDto;
}
export interface EAupPayloadConfigurationDto extends SubscriptionPayloadConfigurationDto {
    includeCDROpeningsClosures?: boolean;
    includeRSAAllocations?: boolean;
}
export const E_AUP_PAYLOAD_CONFIGURATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.EAupPayloadConfigurationDto';
export interface SubscriptionPayloadConfigurationDto {
    clazz?: string;
}
export const SUBSCRIPTION_PAYLOAD_CONFIGURATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.SubscriptionPayloadConfigurationDto';
export interface EAupSubscriptionCreationRequestDto extends SubscriptionCreationRequestDto {
    payloadConfiguration?: EAupPayloadConfigurationDto;
}
export interface EAupSubscriptionDto extends SubscriptionDto {
    payloadConfiguration?: EAupPayloadConfigurationDto;
}
export const E_AUP_SUBSCRIPTION_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.pubsub.EAupSubscriptionDto';
export interface EAupSubscriptionRetrievalRequestDto extends SubscriptionRetrievalRequestDto {}
export interface EAupSubscriptionUpdateRequestDto extends SubscriptionUpdateRequestDto {
    payloadConfiguration?: EAupPayloadConfigurationDto;
}
export interface FlightDataMessageDto extends BusinessPubSubMessageDto {
    concernedUnits?: Array<string>;
    eventType?: FlightEventType;
    flight?: FlightDto;
}
export const FLIGHT_DATA_MESSAGE_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.pubsub.FlightDataMessageDto';
export interface FlightDataMessageFilterDto extends SubscriptionMessageFilterDto {
    dataset?: DatasetDto;
    flightSet?: Array<FlightSetDefinitionElementDto>;
    includeProposalFlights?: boolean;
}
export const FLIGHT_DATA_MESSAGE_FILTER_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.FlightDataMessageFilterDto';
export interface FlightSetDefinitionElementDto {
    aerodromesOfArrival?: Array<string>;
    aerodromesOfDeparture?: Array<string>;
    aircraftOperators?: Array<string>;
    aircraftRegistrations?: Array<string>;
    alternateAerodromes?: Array<string>;
    anuIds?: Array<string>;
    flightPlanOriginators?: Array<string>;
}
export interface FlightDataPayloadConfigurationDto extends SubscriptionPayloadConfigurationDto {
    concernedUnits?: boolean;
    flightFields?: Array<FlightFieldType>;
    trafficVolumeSelection?: TrafficVolumeSelectionDto;
}
export const FLIGHT_DATA_PAYLOAD_CONFIGURATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.FlightDataPayloadConfigurationDto';
export interface TrafficVolumeSelectionDto {
    tvsets?: Array<string>;
}
export interface FlightDataSubscriptionCreationRequestDto extends SubscriptionCreationRequestDto {
    messageFilter?: FlightDataMessageFilterDto;
    payloadConfiguration?: FlightDataPayloadConfigurationDto;
}
export interface FlightDataSubscriptionDto extends SubscriptionDto {
    messageFilter?: FlightDataMessageFilterDto;
    payloadConfiguration?: FlightDataPayloadConfigurationDto;
}
export const FLIGHT_DATA_SUBSCRIPTION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.FlightDataSubscriptionDto';
export interface FlightDataSubscriptionRetrievalRequestDto extends SubscriptionRetrievalRequestDto {}
export interface FlightDataSubscriptionUpdateRequestDto extends SubscriptionUpdateRequestDto {
    messageFilter?: FlightDataMessageFilterDto;
    payloadConfiguration?: FlightDataPayloadConfigurationDto;
}
export interface FlightFilingFilterDto {
    automaticStatus?: Array<FilingStatus>;
    manualStatus?: Array<ManualProcessingFilingStatus>;
}
export enum ManualProcessingFilingStatus {
    ACCEPTED = 'ACCEPTED',
    INVALID_REJECTED = 'INVALID_REJECTED',
}
export interface FlightFilingResultMessageDto extends BusinessPubSubMessageDto {
    aircraftRegistration?: string;
    comments?: Array<string>;
    displayMessage?: string;
    filingId?: string;
    filingOriginator?: MessageOriginatorDto;
    filingResult?: FilingReplyDto;
    filingTime?: Date;
    flightId?: FlightId;
    manualTreatment?: boolean;
    originalMessage?: string;
    originalMessageReceptionTime?: Date;
    originalMessageType?: ATSMessageType;
}
export const FLIGHT_FILING_RESULT_MESSAGE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.FlightFilingResultMessageDto';
export interface FlightFilingResultMessageFilterDto extends SubscriptionMessageFilterDto {
    aircraftOperators?: AicraftOperatorFilterDto;
    filingStatus?: FlightFilingFilterDto;
    messageOriginators?: Array<string>;
    messageTypes?: Array<ATSMessageType>;
}
export const FLIGHT_FILING_RESULT_MESSAGE_FILTER_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.FlightFilingResultMessageFilterDto';
export interface FlightFilingResultSubscriptionCreationRequestDto extends SubscriptionCreationRequestDto {
    messageFilter?: FlightFilingResultMessageFilterDto;
}
export interface FlightFilingResultSubscriptionDto extends SubscriptionDto {
    messageFilter?: FlightFilingResultMessageFilterDto;
}
export const FLIGHT_FILING_RESULT_SUBSCRIPTION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.FlightFilingResultSubscriptionDto';
export interface FlightFilingResultSubscriptionRetrievalRequestDto extends SubscriptionRetrievalRequestDto {}
export interface FlightFilingResultSubscriptionUpdateRequestDto extends SubscriptionUpdateRequestDto {
    messageFilter?: FlightFilingResultMessageFilterDto;
}
export interface FlightPlanEventDto {
    eventType?: FlightPlanEventType;
    originator?: MessageOriginatorDto;
    timeStamp?: Date;
    timestamp?: Date;
}
export enum FlightPlanEventType {
    AFP = 'AFP',
    ARR = 'ARR',
    CHG = 'CHG',
    CNL = 'CNL',
    DEP = 'DEP',
    DLA = 'DLA',
    FNM = 'FNM',
    FPL = 'FPL',
    MFS = 'MFS',
    REVAL = 'REVAL',
}
export interface FlightPlanEventHistoryItemDto {
    event?: FlightPlanEventDto;
    sequenceNumber?: number;
}
export interface FlightPlanMessageDto extends BusinessPubSubMessageDto {
    concernedUnits?: Array<string>;
    eventHistory?: Array<FlightPlanEventHistoryItemDto>;
    revalidationInformation?: RevalidationInformationDto;
    structuredData?: StructuredFlightPlanDataDto;
}
export const FLIGHT_PLAN_MESSAGE_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.pubsub.FlightPlanMessageDto';
export interface StructuredFlightPlanDataDto {
    aircraftOperator?: string;
    flightPlan?: FlightPlanDto;
    knownErrorIndicators?: Array<IFPIndicator>;
    operatingAircraftOperator?: string;
    originatorAddress?: string;
}
export interface RevalidationInformationDto {
    gufi?: string;
    proposedRoute?: string;
    revalidationErrors?: Array<string>;
    revalidationStatus?: RevalidationStatus;
}
export enum RevalidationStatus {
    ADVISORY = 'ADVISORY',
    COMPLIANT = 'COMPLIANT',
    SUSPENDED = 'SUSPENDED',
}
export interface FlightPlanMessageFilterDto extends SubscriptionMessageFilterDto {
    events?: Array<FlightPlanEventType>;
    flightSet?: Array<FlightSetDefinitionElementDto>;
}
export const FLIGHT_PLAN_MESSAGE_FILTER_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.FlightPlanMessageFilterDto';
export interface FlightPlanPayloadConfigurationDto extends SubscriptionPayloadConfigurationDto {
    concernedUnits?: boolean;
    flightPlanFormat?: FlightExchangeModelType;
}
export const FLIGHT_PLAN_PAYLOAD_CONFIGURATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.FlightPlanPayloadConfigurationDto';
export interface FlightPlanSubscriptionCreationRequestDto extends SubscriptionCreationRequestDto {
    messageFilter?: FlightPlanMessageFilterDto;
    payloadConfiguration?: FlightPlanPayloadConfigurationDto;
}
export interface FlightPlanSubscriptionDto extends SubscriptionDto {
    messageFilter?: FlightPlanMessageFilterDto;
    payloadConfiguration?: FlightPlanPayloadConfigurationDto;
}
export const FLIGHT_PLAN_SUBSCRIPTION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.FlightPlanSubscriptionDto';
export interface FlightPlanSubscriptionRetrievalRequestDto extends SubscriptionRetrievalRequestDto {}
export interface FlightPlanSubscriptionUpdateRequestDto extends SubscriptionUpdateRequestDto {
    messageFilter?: FlightPlanMessageFilterDto;
    payloadConfiguration?: FlightPlanPayloadConfigurationDto;
}
export interface HeartBeatTechnicalMessageDto extends TechnicalPubSubMessageDto {
    currentSubscriptionState?: SubscriptionState;
    timeToNextPulse?: Date;
}
export const HEART_BEAT_TECHNICAL_MESSAGE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.HeartBeatTechnicalMessageDto';
export interface TechnicalPubSubMessageDto extends PubSubMessageDto {
    subscriptionTopic?: SubscriptionTopic;
    subscriptionUuid?: string;
    subscriptionVersion?: number;
    topic?: TechnicalTopic;
}
export const TECHNICAL_PUB_SUB_MESSAGE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.TechnicalPubSubMessageDto';
export enum TechnicalTopic {
    SUBSCRIPTION = 'SUBSCRIPTION',
    HEARTBEAT = 'HEARTBEAT',
    SYNCHRONISATION = 'SYNCHRONISATION',
}
export interface KPITargetsPlanMessageDto extends BusinessPubSubMessageDto {
    plan?: KPITargetsPlanDto;
}
export const K_P_I_TARGETS_PLAN_MESSAGE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.KPITargetsPlanMessageDto';
export interface KPITargetsPlanMessageFilterDto extends SubscriptionMessageFilterDto {
    airspaceId?: string;
    day?: Date;
}
export const K_P_I_TARGETS_PLAN_MESSAGE_FILTER_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.KPITargetsPlanMessageFilterDto';
export interface KPITargetsSubscriptionCreationRequestDto extends SubscriptionCreationRequestDto {
    messageFilter?: KPITargetsPlanMessageFilterDto;
}
export interface KPITargetsSubscriptionDto extends SubscriptionDto {
    messageFilter?: KPITargetsPlanMessageFilterDto;
}
export const K_P_I_TARGETS_SUBSCRIPTION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.KPITargetsSubscriptionDto';
export interface KPITargetsSubscriptionRetrievalRequestDto extends SubscriptionRetrievalRequestDto {}
export interface KPITargetsSubscriptionUpdateRequestDto extends SubscriptionUpdateRequestDto {
    messageFilter?: KPITargetsPlanMessageFilterDto;
}
export interface ManualProcessingResultDto {
    rejectedFiling?: FilingResultRejectedDto;
    validFiling?: FilingResultValidDto;
}
export interface McdmMessageDto extends BusinessPubSubMessageDto {
    mcdmMeasure?: McdmMeasureTopic;
    nonStandaloneMcdmFlight?: McdmFlightTopic;
    standaloneMcdmFlight?: McdmFlightTopic;
}
export const MCDM_MESSAGE_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.pubsub.McdmMessageDto';
export interface McdmMessageFilterDto extends SubscriptionMessageFilterDto {
    anuIds?: Array<string>;
    dataset?: DatasetDto;
    includeMcdmRegulationTopics?: boolean;
    includeMcdmReroutingTopics?: boolean;
    includeStandaloneMcdmFlightTopics?: boolean;
}
export const MCDM_MESSAGE_FILTER_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.pubsub.McdmMessageFilterDto';
export interface McdmPayloadConfigurationDto extends SubscriptionPayloadConfigurationDto {
    mcdmTopicFields?: Array<McdmTopicFieldType>;
}
export const MCDM_PAYLOAD_CONFIGURATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.McdmPayloadConfigurationDto';
export interface McdmSubscriptionCreationRequestDto extends SubscriptionCreationRequestDto {
    messageFilter?: McdmMessageFilterDto;
    payloadConfiguration?: McdmPayloadConfigurationDto;
}
export interface McdmSubscriptionDto extends SubscriptionDto {
    messageFilter?: McdmMessageFilterDto;
    payloadConfiguration?: McdmPayloadConfigurationDto;
}
export const MCDM_SUBSCRIPTION_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.pubsub.McdmSubscriptionDto';
export interface McdmSubscriptionRetrievalRequestDto extends SubscriptionRetrievalRequestDto {}
export interface McdmSubscriptionUpdateRequestDto extends SubscriptionUpdateRequestDto {
    messageFilter?: McdmMessageFilterDto;
    payloadConfiguration?: McdmPayloadConfigurationDto;
}
export interface MessagePullReplyDto {
    hasMoreMessages?: boolean;
    messages?: Array<PubSubMessageDto>;
}
export interface MessagePullRequestDto {
    destructive?: boolean;
    maxSize?: number;
    queueName?: string;
}
export interface PSConnectionStatusDto {
    certificateConnections?: Array<string>;
    certificateSessions?: Array<string>;
    nrMessageConsumers?: number;
}
export interface PubSubListener {}
export interface RegulationMessageDto extends BusinessPubSubMessageDto {
    regulation?: RegulationDto;
}
export const REGULATION_MESSAGE_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.pubsub.RegulationMessageDto';
export interface RegulationMessageFilterDto extends SubscriptionMessageFilterDto {
    dataset?: DatasetDto;
    tvIds?: Array<string>;
    tvSetIds?: Array<string>;
}
export const REGULATION_MESSAGE_FILTER_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.RegulationMessageFilterDto';
export interface RegulationPayloadConfigurationDto extends SubscriptionPayloadConfigurationDto {
    regulationFields?: Array<RegulationFieldType>;
}
export const REGULATION_PAYLOAD_CONFIGURATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.RegulationPayloadConfigurationDto';
export interface RegulationSubscriptionCreationRequestDto extends SubscriptionCreationRequestDto {
    messageFilter?: RegulationMessageFilterDto;
    payloadConfiguration?: RegulationPayloadConfigurationDto;
}
export interface ReroutingMessageDto extends BusinessPubSubMessageDto {
    rerouting?: ReroutingDto;
}
export const REROUTING_MESSAGE_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.pubsub.ReroutingMessageDto';
export interface RegulationSubscriptionDto extends SubscriptionDto {
    messageFilter?: RegulationMessageFilterDto;
    payloadConfiguration?: RegulationPayloadConfigurationDto;
}
export const REGULATION_SUBSCRIPTION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.RegulationSubscriptionDto';
export interface RegulationSubscriptionRetrievalRequestDto extends SubscriptionRetrievalRequestDto {}
export interface RegulationSubscriptionUpdateRequestDto extends SubscriptionUpdateRequestDto {
    messageFilter?: RegulationMessageFilterDto;
    payloadConfiguration?: RegulationPayloadConfigurationDto;
}
export interface ReroutingMessageFilterDto extends SubscriptionMessageFilterDto {
    tvIds?: Array<string>;
    tvSetIds?: Array<string>;
}
export const REROUTING_MESSAGE_FILTER_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.ReroutingMessageFilterDto';
export interface ReroutingPayloadConfigurationDto extends SubscriptionPayloadConfigurationDto {
    reroutingFields?: Array<ReroutingFieldType>;
}
export const REROUTING_PAYLOAD_CONFIGURATION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.ReroutingPayloadConfigurationDto';
export interface ReroutingSubscriptionCreationRequestDto extends SubscriptionCreationRequestDto {
    messageFilter?: ReroutingMessageFilterDto;
    payloadConfiguration?: ReroutingPayloadConfigurationDto;
}
export interface ReroutingSubscriptionDto extends SubscriptionDto {
    messageFilter?: ReroutingMessageFilterDto;
    payloadConfiguration?: ReroutingPayloadConfigurationDto;
}
export const REROUTING_SUBSCRIPTION_DTO_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.dto.pubsub.ReroutingSubscriptionDto';
export interface ReroutingSubscriptionRetrievalRequestDto extends SubscriptionRetrievalRequestDto {}
export interface ReroutingSubscriptionUpdateRequestDto extends SubscriptionUpdateRequestDto {
    messageFilter?: ReroutingMessageFilterDto;
    payloadConfiguration?: ReroutingPayloadConfigurationDto;
}
export interface SectorConfigurationPlanMessageDto extends BusinessPubSubMessageDto {
    plan?: SectorConfigurationPlanDto;
}
export const SECTOR_CONFIGURATION_PLAN_MESSAGE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.SectorConfigurationPlanMessageDto';
export interface SectorConfigurationPlanMessageFilterDto extends SubscriptionMessageFilterDto {
    airspaceId?: string;
    day?: Date;
}
export const SECTOR_CONFIGURATION_PLAN_MESSAGE_FILTER_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.SectorConfigurationPlanMessageFilterDto';
export interface SectorConfigurationPlanSubscriptionCreationRequestDto extends SubscriptionCreationRequestDto {
    messageFilter?: SectorConfigurationPlanMessageFilterDto;
}
export interface SectorConfigurationPlanSubscriptionDto extends SubscriptionDto {
    messageFilter?: SectorConfigurationPlanMessageFilterDto;
}
export const SECTOR_CONFIGURATION_PLAN_SUBSCRIPTION_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.SectorConfigurationPlanSubscriptionDto';
export interface SectorConfigurationPlanSubscriptionRetrievalRequestDto extends SubscriptionRetrievalRequestDto {}
export interface SectorConfigurationPlanSubscriptionUpdateRequestDto extends SubscriptionUpdateRequestDto {
    messageFilter?: SectorConfigurationPlanMessageFilterDto;
}
export interface SubscribeQueueRequestDto {
    subscriptionDto?: SubscriptionDto;
}
export interface SubscriptionHistoryItemDto {
    description?: string;
    heartbeatEnabled?: boolean;
    state?: SubscriptionState;
    updatedBy?: string;
    updatedComment?: string;
    updatedOn?: Date;
    updatedReason?: SubscriptionUpdateReason;
    uuid?: string;
    version?: number;
}
export interface SubscriptionHistoryReplyDto {
    hasMoreItems?: boolean;
    history?: Array<SubscriptionHistoryItemDto>;
}
export interface SubscriptionHistoryRequestDto {
    referenceTime?: Date;
    subscriptionId?: string;
}
export interface SubscriptionListRequestDto {
    states?: Array<SubscriptionState>;
}
export interface SubscriptionRetrievalReplyDto {
    subscription?: SubscriptionDto;
    synchronisationSummary?: SubscriptionSynchronisationSummaryDto;
}
export interface SubscriptionSynchronisationSummaryDto {
    abortReason?: SubscriptionSynchronisationAbortReason;
    correlationId?: string;
    endTime?: Date;
    size?: number;
    startTime?: Date;
    status?: SubscriptionSynchronisationStatus;
    subscriptionUuid?: string;
}
export enum SubscriptionSynchronisationStatus {
    STARTED = 'STARTED',
    COMPLETED = 'COMPLETED',
    ABORTED = 'ABORTED',
}
export enum SubscriptionSynchronisationAbortReason {
    USER_REQUEST = 'USER_REQUEST',
    MAINTENANCE = 'MAINTENANCE',
    SUBSCRIPTION_NOT_ACTIVE = 'SUBSCRIPTION_NOT_ACTIVE',
}
export interface SubscriptionSynchronisationAbortReplyDto {
    synchronisationSummary?: SubscriptionSynchronisationSummaryDto;
}
export interface SubscriptionSynchronisationAbortRequestDto {
    subscriptionUuid?: string;
}
export interface SubscriptionSynchronisationReplyDto {
    correlationId?: string;
    messagesCount?: number;
}
export interface SubscriptionSynchronisationRequestDto {
    subscriptionUuid?: string;
    unt?: Date;
    wef?: Date;
}
export interface SubscriptionSynchronisationTechnicalMessageDto extends TechnicalPubSubMessageDto {
    synchronisationSummary?: SubscriptionSynchronisationSummaryDto;
}
export const SUBSCRIPTION_SYNCHRONISATION_TECHNICAL_MESSAGE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.SubscriptionSynchronisationTechnicalMessageDto';
export interface SubscriptionTechnicalMessageDto extends TechnicalPubSubMessageDto {
    lastUpdateComment?: string;
    lastUpdateReason?: SubscriptionUpdateReason;
    lastUpdatedBy?: string;
    lastUpdatedOn?: Date;
    subscriptionDescription?: string;
    subscriptionState?: SubscriptionState;
    updatedFields?: Array<string>;
}
export const SUBSCRIPTION_TECHNICAL_MESSAGE_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.pubsub.SubscriptionTechnicalMessageDto';
export interface AirspaceFRE extends FlowRoutingElement {
    airspaceId?: string;
}
export interface FlowRoutingElement {
    type?: FlowRoutingElementType;
    verticalLimit?: FlightLevelBand;
}
export enum FlowRoutingElementType {
    AIRSPACE = 'AIRSPACE',
    DCT_SEGMENT = 'DCT_SEGMENT',
    POINT = 'POINT',
    ROUTE_PORTION_ID_RELEVANT_REROUTING = 'ROUTE_PORTION_ID_RELEVANT_REROUTING',
    ROUTE_PORTION_POINT_LIST = 'ROUTE_PORTION_POINT_LIST',
    TERMINAL_PROCEDURE = 'TERMINAL_PROCEDURE',
}
export interface DctSegmentFRE extends FlowRoutingElement {
    fromPoint?: string;
    toPoint?: string;
}
export interface FlowRestriction {
    description?: string;
    flowRestrictionType?: FlowRestrictionType;
    id?: string;
    operationalGoal?: string;
    restrictionType?: RestrictionType;
    routing?: Array<FlowRouting>;
}
export enum FlowRestrictionType {
    AERODROME_FLIGHT_RULE = 'AERODROME_FLIGHT_RULE',
    DCT_LIMITATION = 'DCT_LIMITATION',
    ERROR_MANAGEMENT = 'ERROR_MANAGEMENT',
    FRA_DCT = 'FRA_DCT',
    HARD_SOFT_TRAFFIC_FLOW = 'HARD_SOFT_TRAFFIC_FLOW',
    PROFILE_TUNING = 'PROFILE_TUNING',
    SSR_CODE = 'SSR_CODE',
    TERMINAL_PROCEDURE = 'TERMINAL_PROCEDURE',
}
export enum RestrictionType {
    MANDATORY = 'MANDATORY',
    FORBIDDEN = 'FORBIDDEN',
    ALLOWED = 'ALLOWED',
    CLOSED = 'CLOSED',
}
export interface FlowRouting {
    elements?: Array<FlowRoutingElement>;
}
export interface RestrictionRetrievalReplyDto {
    restrictions?: Array<FlowRestriction>;
}
export interface RestrictionRetrievalRequestDto {
    restrictions?: Array<string>;
}
export interface RoutePortionFRE extends FlowRoutingElement {
    routePortion?: RoutePortion;
}
export interface SignificantPointFRE extends FlowRoutingElement {
    pointId?: string;
}
export interface TerminalProcedureFRE extends FlowRoutingElement {
    terminalProcedureId?: string;
}
export interface PlannedRunwayConfigurationsDto {
    applicabilityPeriod?: TimePeriod;
    dataSource?: PlanDataSourceType;
    runwayConfigurations?: Array<RunwayConfigurationDto>;
}
export interface RunwayConfigurationDto {
    arrivalTaxiTimeDataSource?: PlanDataSourceType;
    arrivalTaxiTimeInMs?: number;
    departureTaxiTimeDataSource?: PlanDataSourceType;
    departureTaxiTimeInMs?: number;
    runwayId?: string;
    timeToInsertInSequenceDataSource?: PlanDataSourceType;
    timeToInsertInSequenceInMs?: number;
    timeToRemoveFromSequenceDataSource?: PlanDataSourceType;
    timeToRemoveFromSequenceInMs?: number;
    usage?: RunwayUsage;
    usageDataSource?: PlanDataSourceType;
}
export enum RunwayUsage {
    ARRIVAL = 'ARRIVAL',
    DEPARTURE = 'DEPARTURE',
    DEPARTURE_ARRIVAL = 'DEPARTURE_ARRIVAL',
    INACTIVE = 'INACTIVE',
}
export interface RunwayConfigurationPlanDto extends TacticalPlan {
    aerodrome?: string;
    clientSchedule?: Array<PlannedRunwayConfigurationsDto>;
    nmSchedule?: Array<PlannedRunwayConfigurationsDto>;
    runwayIds?: Array<string>;
}
export const RUNWAY_CONFIGURATION_PLAN_DTO_CLAZZ_VALUE =
    'eurocontrol.npp.core.shared.dto.runway.RunwayConfigurationPlanDto';
export interface RunwayConfigurationPlanRequestDto {
    aerodromeId?: string;
    dataset?: DatasetDto;
    day?: Date;
}
export enum ExecutionEnvironmentType {
    OPS = 'OPS',
    OPT = 'OPT',
    DEV = 'DEV',
    PRE_RELEASE = 'PRE_RELEASE',
}
export interface NmPlatformDto {
    applicationInstance?: string;
    executionEnvironment?: ExecutionEnvironmentType;
}
export interface NmReleaseInformationDto {
    baseline?: string;
    platform?: NmPlatformDto;
    release?: string;
    supportedB2bVersions?: Array<string>;
}
export interface UserInformationDto {
    textReport?: string;
}
export interface ChatData {
    messages?: Array<ChatMessage>;
    presences?: Array<ChatPresence>;
}
export interface ChatMessage {
    fromId?: string;
    message?: string;
    simulatedTimestamp?: Date;
    timestamp?: Date;
    toId?: string;
}
export enum ChatPresence_Status {
    OFFLINE = 'OFFLINE',
    ONLINE = 'ONLINE',
    ABSENT = 'ABSENT',
    BUSY = 'BUSY',
    AVAILABLE = 'AVAILABLE',
}
export interface ChatPresence {
    status?: ChatPresence_Status;
    statusText?: string;
    userId?: string;
}
export interface FastPollingChatData {
    chatData?: ChatData;
    responseId?: ResponseId;
    updateType?: UpdateType;
}
export interface DownloadFile {
    clientFilename?: string;
    downloadRootUrl?: string;
    serverFilename?: string;
}
export interface ExportToFileRequest {
    fileContents?: string;
    filename?: string;
}
export interface B2BMessageDto {
    body?: string;
    summaryInfo?: B2BMessageSummaryDto;
}
export interface B2BMessageSummaryDto {
    date?: Date;
    firstWord?: string;
    messageId?: number;
    sizeInBytes?: number;
    truncated?: boolean;
    type?: B2BMessageType;
}
export enum B2BMessageType {
    OUTBOUND = 'OUTBOUND',
    INBOUND = 'INBOUND',
}
export interface PubSubLogMessageDto {
    body?: string;
    summaryInfo?: PubSubLogMessageSummaryDto;
}
export interface PubSubLogMessageSummaryDto {
    firstWord?: string;
    sizeInBytes?: number;
    timestamp?: Date;
    truncated?: boolean;
    type?: PubSubMessageType;
    uuid?: string;
}
export interface MTTDefinition {
    aerodromeIcaoCode?: string;
    aicraftIcaoCode?: string;
    airlineIcaoCode?: string;
    mttValue?: number;
}
export interface CommonAuthorisationRules {}
export interface UserProfile {
    firstName?: string;
    lastName?: string;
    unitRoleList?: Array<UnitAndRole>;
    userId?: string;
}
export interface UnitAndRole {
    opUnit?: string;
    role?: Role;
}
export enum Role {
    FMP = 'FMP',
    AOC = 'AOC',
    TWR = 'TWR',
    NM = 'NM',
    ACC = 'ACC',
    APT = 'APT',
    FMP_MAP = 'FMP_MAP',
}
export interface TimeSynchDto {
    frozenTime?: Date;
    timeShiftInMs?: number;
}
export interface SimulationTimeManager {
    simulationTime?: Date;
    timeSynch?: TimeSynchDto;
}
export interface AbstractFastPollingData {
    chatData?: ChatData;
    responseId?: ResponseId;
    timeSynch?: TimeSynchDto;
    updateType?: UpdateType;
}
export interface ConfigData {
    clazz?: string;
    claimedUserId?: string;
    coldLoadingBarEnabled?: boolean;
    debugMode?: boolean;
    helpBaseUrl?: string;
    inDmz?: boolean;
    logoutUrl?: string;
    mapTileProvider?: MapTileProvider;
    multipleProposals?: boolean;
    nmSystemInstance?: NmSystemInstance;
    nmVersionId?: NmVersionId;
    properties?: { [key: string]: string };
    pubSubEnabled?: boolean;
    simulationTimeSynch?: TimeSynchDto;
    stamEnabled?: boolean;
    supportedCountSubtotalTypes?: Array<CountSubtotalsType>;
    userProfile?: UserProfile;
    wmsUrl?: string;
}
export const CONFIG_DATA_CLAZZ_VALUE = 'eurocontrol.npp.core.shared.service.ConfigData';
export class TechnicalService {
    baseUrl: string;
    serviceUrl: string = '/services/TechnicalService';
    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    public appProperties(payload: boolean): Promise<Reply<{ [key: string]: string }>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/appProperties', 'get', payload);
    }
    public changeTime(payload: Date, frozen: boolean): Promise<Reply<TimeSynchDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/changeTime/' + frozen, 'post', payload);
    }
    public changeTimeAsync(payload: Date, frozen: boolean): Promise<Reply<string>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/changeTimeAsync/' + frozen, 'post', payload);
    }
    public emptyB2BCache(): Promise<Reply<boolean>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/emptyB2BCache', 'post');
    }
    public enableLogging(payload: boolean): Promise<Reply<boolean>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/enableLogging', 'post', payload);
    }
    public exportToDownloadFile(payload: ExportToFileRequest): Promise<Reply<DownloadFile>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/exportToDownloadFile', 'post', payload);
    }
    public getB2BMessage(messageId: number): Promise<Reply<B2BMessageDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getB2BMessage/' + messageId, 'get');
    }
    public getB2BMessageSummaryList(): Promise<Reply<Array<B2BMessageSummaryDto>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getB2BMessageSummaryList', 'get');
    }
    public getChangeTimeAsyncReply(futureReplyId: string): Promise<AsyncReply<TimeSynchDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getChangeTimeAsyncReply/' + futureReplyId, 'get');
    }
    public getChatDataSince(userId: string, payload: ResponseId): Promise<Reply<FastPollingChatData>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getChatDataSince/' + userId, 'post', payload);
    }
    public getConfigData(): Promise<Reply<ConfigData>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getConfigData', 'post');
    }
    public getLoggingStatus(): Promise<Reply<boolean>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getLoggingStatus', 'get');
    }
    public getNmReleaseInformation(): Promise<Reply<NmReleaseInformationDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getNmReleaseInformation', 'get');
    }
    public getTimeSynchronisation(): Promise<Reply<TimeSynchDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getTimeSynchronisation', 'get');
    }
    public getUserInformation(): Promise<Reply<UserInformationDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getUserInformation', 'get');
    }
    public postChatMessage(payload: ChatMessage): Promise<Reply<ChatMessage>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/postChatMessage', 'post', payload);
    }
    public restart(): Promise<Reply<boolean>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/restart', 'get');
    }
    public test(): Promise<Reply<string>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/test', 'get');
    }
    public updateChatPresence(payload: ChatPresence): Promise<Reply<boolean>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateChatPresence', 'post', payload);
    }
    private doSend<RequestType, ResponseType>(
        url: string,
        method: 'post' | 'get',
        request?: RequestType,
    ): Promise<ResponseType> {
        const headers = new Headers();
        headers.append('Accept', 'application/json'); // This one is enough for GET requests
        headers.append('Content-Type', 'application/json'); // This one sends body
        return fetch(url, { method: method, headers: headers, body: JSON.stringify(request) }).then(response => {
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            return response.text().then(text => JSON.parse(text));
        });
    }
}
export class StamCoreService {
    baseUrl: string;
    serviceUrl: string = '/services/StamCoreService';
    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    public acceptRejectRegulationProposal(
        payload: RegulationProposalAcceptRejectRequestDto,
    ): Promise<Reply<RegulationProposalDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/acceptRejectRegulationProposal', 'post', payload);
    }
    public cancelMeasure(payload: MeasureCancelRequestDto): Promise<Reply<MeasureDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/cancelMeasure', 'post', payload);
    }
    public cancelRegulationProposal(
        payload: RegulationProposalRevocationRequestDto,
    ): Promise<Reply<RegulationProposalDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/cancelRegulationProposal', 'post', payload);
    }
    public createEHelpDeskTicket(payload: EHelpDeskTicketCreationRequestDto): Promise<Reply<EHelpDeskTicketChoiceDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/createEHelpDeskTicket', 'post', payload);
    }
    public createEnhancedHotspot(payload: CreateEnrichedHotspotRequestDto): Promise<Reply<HotspotPlanDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/createEnhancedHotspot', 'post', payload);
    }
    public createMeasure(payload: MeasureCreateRequestDto): Promise<Reply<MeasureDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/createMeasure', 'post', payload);
    }
    public createOrUpdateMeasure(payload: MeasureCompositeUpdateRequest): Promise<Reply<MeasureCompositeUpdateReply>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/createOrUpdateMeasure', 'post', payload);
    }
    public createRegulationProposal(
        payload: RegulationProposalFilingRequestDto,
    ): Promise<Reply<RegulationProposalDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/createRegulationProposal', 'post', payload);
    }
    public getAllMeasuresList(payload: AllMeasureListRequestDto): Promise<Reply<MeasureList<MeasureDto>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getAllMeasuresList', 'post', payload);
    }
    public getHotspotPlan(payload: HotspotListRequestDto): Promise<Reply<HotspotPlanDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getHotspotPlan', 'post', payload);
    }
    public getHotspotPlans(payload: HotspotListRequestDto): Promise<Reply<HotspotPlansDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getHotspotPlans', 'post', payload);
    }
    public getMcdmOnlyList(payload: McdmOnlyListRequestDto): Promise<Reply<McdmOnlyList>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getMcdmOnlyList', 'post', payload);
    }
    public getMcdmTopicList(payload: McdmTopicListRequestDto): Promise<Reply<McdmTopicList>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getMcdmTopicList', 'post', payload);
    }
    public getMeasure(payload: MeasureRequestDto): Promise<Reply<MeasureDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getMeasure', 'post', payload);
    }
    public getMeasureAndTopicList(payload: MeasureAndTopicListRequestDto): Promise<Reply<Array<MeasureAndTopic>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getMeasureAndTopicList', 'post', payload);
    }
    public getMeasureCompositeData(payload: MeasureCompositeRequest): Promise<Reply<MeasureCompositeReply>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getMeasureCompositeData', 'post', payload);
    }
    public getMeasureKpis(payload: MeasureKpisRequestDto): Promise<Reply<MeasureKpisDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getMeasureKpis', 'post', payload);
    }
    public getMeasureOpLog(payload: OpLogRequestDto): Promise<Reply<Array<OpLogEntry>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getMeasureOpLog', 'post', payload);
    }
    public getRegulationProposals(payload: RegulationProposalListRequestDto): Promise<Reply<RegulationProposalList>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getRegulationProposals', 'post', payload);
    }
    public getReroutingList(payload: ReroutingListRequestDto): Promise<Reply<ReroutingList>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getReroutingList', 'post', payload);
    }
    public getScenarioList(payload: ScenarioListRequestDto): Promise<Reply<Array<ScenarioAttributesDto>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getScenarioList', 'post', payload);
    }
    public queryUdpp(payload: QueryUdppRequestDto): Promise<Reply<QueryUdppReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/queryUdpp', 'post', payload);
    }
    public retrieveMcdmOnlyFromScenario(
        payload: ScenarioMcdmOnlyRetrievalRequestDto,
    ): Promise<Reply<Array<McdmOnlyDto>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/retrieveMcdmOnlyFromScenario', 'post', payload);
    }
    public retrieveMeasuresFromScenario(
        payload: ScenarioAllMeasureRetrievalRequestDto,
    ): Promise<Reply<Array<MeasureDto>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/retrieveMeasuresFromScenario', 'post', payload);
    }
    public retrieveRegulationsFromScenario(
        payload: ScenarioRegulationRetrievalRequestDto,
    ): Promise<Reply<Array<RegulationDto>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/retrieveRegulationsFromScenario', 'post', payload);
    }
    public retrieveReroutingsFromScenario(
        payload: ScenarioReroutingRetrievalRequestDto,
    ): Promise<Reply<Array<ReroutingDto>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/retrieveReroutingsFromScenario', 'post', payload);
    }
    public revertSimulationMeasure(payload: SimulationMeasureRevertRequestDto): Promise<Reply<undefined>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/revertSimulationMeasure', 'post', payload);
    }
    public revokeEHelpDeskTicket(
        payload: EHelpDeskTicketRevocationRequestDto,
    ): Promise<Reply<EHelpDeskTicketRevocationReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/revokeEHelpDeskTicket', 'post', payload);
    }
    public safelyAddFlightsToMeasure(
        payload: SafelyAddFlightsToMeasureRequestDto,
    ): Promise<Reply<SafelyAddFlightsToMeasureReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/safelyAddFlightsToMeasure', 'post', payload);
    }
    public safelyRemoveFlightsFromMeasure(
        payload: SafelyRemoveFlightsFromMeasureRequestDto,
    ): Promise<Reply<SafelyRemoveFlightsFromMeasureReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/safelyRemoveFlightsFromMeasure', 'post', payload);
    }
    public submitUdpp(payload: SubmitUdppRequestDto): Promise<Reply<SubmitUdppReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/submitUdpp', 'post', payload);
    }
    public updateEHelpDeskTicket(payload: EHelpDeskTicketUpdateRequestDto): Promise<Reply<EHelpDeskTicketChoiceDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateEHelpDeskTicket', 'post', payload);
    }
    public updateFlightsInMeasure(
        payload: UpdateFlightsInMeasureRequestDto,
    ): Promise<Reply<FlightResultList<UpdateFlightInMeasureDto>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateFlightsInMeasure', 'post', payload);
    }
    public updateHotspotPlan(payload: HotspotPlanDto): Promise<Reply<HotspotPlanDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateHotspotPlan', 'post', payload);
    }
    public updateMcdmState(payload: McdmStateUpdateRequestDto): Promise<Reply<McdmState>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateMcdmState', 'post', payload);
    }
    public updateMcdmTopic(payload: UpdateMcdmTopicRequestDto): Promise<Reply<McdmTopic>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateMcdmTopic', 'post', payload);
    }
    public updateMeasure(payload: MeasureUpdateRequestDto): Promise<Reply<MeasureDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateMeasure', 'post', payload);
    }
    public updateRegulationProposal(
        payload: RegulationProposalUpdateRequestDto,
    ): Promise<Reply<RegulationProposalDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateRegulationProposal', 'post', payload);
    }
    private doSend<RequestType, ResponseType>(
        url: string,
        method: 'post' | 'get',
        request?: RequestType,
    ): Promise<ResponseType> {
        const headers = new Headers();
        headers.append('Accept', 'application/json'); // This one is enough for GET requests
        headers.append('Content-Type', 'application/json'); // This one sends body
        return fetch(url, { method: method, headers: headers, body: JSON.stringify(request) }).then(response => {
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            return response.text().then(text => JSON.parse(text));
        });
    }
}
export class CoreService {
    baseUrl: string;
    serviceUrl: string = '/services/CoreService';
    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    public applyRerouting(payload: ReroutingApplyRequestDto): Promise<Reply<ReroutingApplyReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/applyRerouting', 'post', payload);
    }
    public compareEAupRsas(payload: EAupRsaCompareRequestDto): Promise<Reply<EAupRsaCompareReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/compareEAupRsas', 'post', payload);
    }
    public createAresVolumeSet(
        payload: AresVolumeSetCreationRequestDto,
    ): Promise<Reply<AresVolumeSetCreationReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/createAresVolumeSet', 'post', payload);
    }
    public createAtcVolumeSet(payload: AtcVolumeSetCreationRequestDto): Promise<Reply<AtcVolumeSetCreationReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/createAtcVolumeSet', 'post', payload);
    }
    public createAup(payload: AupCreationRequestDto): Promise<Reply<AupDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/createAup', 'post', payload);
    }
    public createFRARerouting(payload: FRAReroutingCreationRequestDto): Promise<AsyncReply<boolean>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/createFRARerouting', 'post', payload);
    }
    public deleteAup(payload: AupDeletionRequestDto): Promise<Reply<undefined>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/deleteAup', 'post', payload);
    }
    public evaluateFlowImpact(payload: EvaluateFlowImpactRequestDto): Promise<Reply<EvaluateFlowImpactReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/evaluateFlowImpact', 'post', payload);
    }
    public fileFlightArrival(payload: FlightArrivalRequestDto): Promise<Reply<FilingReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/fileFlightArrival', 'post', payload);
    }
    public fileFlightDeparture(payload: FlightDepartureRequestDto): Promise<Reply<FilingReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/fileFlightDeparture', 'post', payload);
    }
    public fileFlightPlanCancellation(payload: FlightPlanCancellationRequestDto): Promise<Reply<FilingReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/fileFlightPlanCancellation', 'post', payload);
    }
    public fileFlightPlanDelay(payload: FlightPlanDelayRequestDto): Promise<Reply<FlightPlanReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/fileFlightPlanDelay', 'post', payload);
    }
    public fileFlightPlanUpdate(payload: FlightPlanUpdateRequestDto): Promise<Reply<FlightPlanReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/fileFlightPlanUpdate', 'post', payload);
    }
    public fileNewFlightPlan(payload: FlightPlanCreationRequestDto): Promise<Reply<FlightPlanReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/fileNewFlightPlan', 'post', payload);
    }
    public findFficeFiledFlights(payload: FficeFlightFinderRequestDto): Promise<Reply<FficeFlightFinderReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/findFficeFiledFlights', 'post', payload);
    }
    public generateKmlFile(payload: KmlSectorConfigurationPlansRequest): Promise<Reply<DownloadFile>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/generateKmlFile', 'post', payload);
    }
    public getAUPServiceConfiguration(
        payload: AupServiceConfigurationRequestDto,
    ): Promise<Reply<AupServiceConfigurationReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getAUPServiceConfiguration', 'post', payload);
    }
    public getAccMonitorData(payload: AccMonitorRequest): Promise<Reply<AccMonitorReply>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getAccMonitorData', 'post', payload);
    }
    public getAerodromes(payload: AerodromeListRequest): Promise<Reply<Array<Aerodrome>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getAerodromes', 'post', payload);
    }
    public getAirportDashboardKpis(payload: AirportDashboardKpiRequest): Promise<Reply<AirportDashboardKpis>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getAirportDashboardKpis', 'post', payload);
    }
    public getAirportTrendKpis(payload: AirportTrendKpiRequest): Promise<Reply<AirportTrendKpis>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getAirportTrendKpis', 'post', payload);
    }
    public getAirspaceIdList(payload: AirspaceIdListRequest): Promise<Reply<AirspaceIdList>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getAirspaceIdList', 'post', payload);
    }
    public getAirspaceIdsWithSectorConfiguration(
        payload: AirspaceIdsWithSectorConfigurationRequest,
    ): Promise<Reply<AirspaceIdList>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getAirspaceIdsWithSectorConfiguration', 'post', payload);
    }
    public getAirspaceList(payload: AirspaceListRequest): Promise<Reply<AirspaceList>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getAirspaceList', 'post', payload);
    }
    public getAirspaceMonitorData(payload: AirspaceMonitorRequest): Promise<Reply<AirspaceMonitorDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getAirspaceMonitorData', 'post', payload);
    }
    public getAirspaceSummaryList(payload: AirspaceSummaryListRequest): Promise<Reply<Array<AirspaceSummary>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getAirspaceSummaryList', 'post', payload);
    }
    public getAllProposalContexts(): Promise<Reply<Array<string>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getAllProposalContexts', 'post');
    }
    public getAresVolumeSet(payload: AresVolumeSetListRequestDto): Promise<Reply<AresVolumeSetListReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getAresVolumeSet', 'post', payload);
    }
    public getArrivalVariabilityKpis(payload: ArrivalVariabilityKpiRequest): Promise<Reply<ArrivalVariabilityKpis>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getArrivalVariabilityKpis', 'post', payload);
    }
    public getAtcVolumeSet(payload: AtcVolumeSetListRequestDto): Promise<Reply<AtcVolumeSetListReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getAtcVolumeSet', 'post', payload);
    }
    public getAtfcmSituation(payload: AtfcmSituationRequestDto): Promise<Reply<AtfcmSituationDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getAtfcmSituation', 'post', payload);
    }
    public getCometaComplexity(payload: CometaComplexityRequestDto): Promise<Reply<CometaComplexityReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getCometaComplexity', 'post', payload);
    }
    public getDelayCounts(payload: DelayCountsRequestDto): Promise<Reply<DelayCountsDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getDelayCounts', 'post', payload);
    }
    public getEnvWhereUsed(payload: EnvWhereUsedRequest): Promise<Reply<EnvWhereUsedReply>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getEnvWhereUsed', 'post', payload);
    }
    public getFlightData(payload: FlightDetailsRequestDto): Promise<Reply<FlightDetailsReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getFlightData', 'post', payload);
    }
    public getFlightIds(payload: FlightIdListRequestDto): Promise<Reply<Array<FlightId>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getFlightIds', 'post', payload);
    }
    public getFlightImpactAssessment(payload: FlightImpactAssessmentRequest): Promise<Reply<FlightImpactAssessment>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getFlightImpactAssessment', 'post', payload);
    }
    public getFlightList(payload: FlightListRequestDto): Promise<Reply<FlightListDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getFlightList', 'post', payload);
    }
    public getFlightNoGoZones(payload: FlightNoGoZonesRequest): Promise<Reply<FlightNoGoZones>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getFlightNoGoZones', 'post', payload);
    }
    public getFlightPlanList(
        payload: FlightPlanListRequestDto,
    ): Promise<Reply<Array<FlightPlanSummaryOrInvalidFiling>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getFlightPlanList', 'post', payload);
    }
    public getFlightTrafficVolumes(
        payload: FlightTrafficVolumeListRequestDto,
    ): Promise<Reply<Array<FlightTrafficVolumeDto>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getFlightTrafficVolumes', 'post', payload);
    }
    public getFlowList(payload: FlowListRequest): Promise<Reply<Array<Flow>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getFlowList', 'post', payload);
    }
    public getHistoricalLoadComparison(
        payload: HistoricalLoadComparisonRequest,
    ): Promise<Reply<HistoricalLoadComparison>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getHistoricalLoadComparison', 'post', payload);
    }
    public getHotspotList(payload: MapHotspotListRequest): Promise<Reply<MapHotspotListReply>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getHotspotList', 'post', payload);
    }
    public getMapAresVolumeSetList(payload: MapAresVolumeSetListRequestDto): Promise<Reply<AresVolumeSetListReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getMapAresVolumeSetList', 'post', payload);
    }
    public getMapAtcVolumeSetList(payload: MapAtcVolumeSetListRequestDto): Promise<Reply<AtcVolumeSetListReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getMapAtcVolumeSetList', 'post', payload);
    }
    public getMapFlightsData(payload: MapFlightsDataRequestDto): Promise<Reply<MapFlightsDataDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getMapFlightsData', 'post', payload);
    }
    public getMapRoutesData(payload: MapRouteListRequest): Promise<Reply<MapRouteListReply>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getMapRoutesData', 'post', payload);
    }
    public getMapSectorConfigurationPlan(
        payload: MapSectorConfigurationPlanRequest,
    ): Promise<Reply<MapSectorConfigurationPlan>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getMapSectorConfigurationPlan', 'post', payload);
    }
    public getMapTrafficVolumeList(payload: MapTrafficVolumeListRequest): Promise<Reply<Array<MapTrafficVolume>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getMapTrafficVolumeList', 'post', payload);
    }
    public getMultipleFlightData(
        payload: Array<FlightDetailsRequestDto>,
    ): Promise<Reply<Array<FlightDetailsReplyDto>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getMultipleFlightData', 'post', payload);
    }
    public getMultipleFlightLists(payload: Array<FlightListRequestDto>): Promise<Reply<Array<FlightListDto>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getMultipleFlightLists', 'post', payload);
    }
    public getNavigationPoints(payload: NavigationPointListRequest): Promise<Reply<Array<NavPoint>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getNavigationPoints', 'post', payload);
    }
    public getNetworkImpactAssessment(
        payload: NetworkImpactAssessmentRetrievalRequestDto,
    ): Promise<Reply<NetworkImpactAssessmentDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getNetworkImpactAssessment', 'post', payload);
    }
    public getNidData(payload: NidRequest): Promise<Reply<NidReply>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/NidRequest', 'post', payload);
    }
    public getOccupancyEntryLoadComparison(
        payload: OccupancyEntryLoadComparisonRequest,
    ): Promise<Reply<OccupancyEntryLoadComparison>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getOccupancyEntryLoadComparison', 'post', payload);
    }
    public getOccupancyVariabilityKpi(
        payload: OccupancyVariabilityKpiRequest,
    ): Promise<Reply<OccupancyVariabilityKpi>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getOccupancyVariabilityKpi', 'post', payload);
    }
    public getOtmvDurations(payload: OtmvDurationsRequestDto): Promise<Reply<OtmvDurationsDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getOtmvDurations', 'post', payload);
    }
    public getOtmvPlan(payload: OtmvPlanRequestDto): Promise<Reply<OtmvPlanDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getOtmvPlan', 'post', payload);
    }
    public getRegulationComplianceKpis(
        payload: RegulationComplianceKpiRequest,
    ): Promise<Reply<RegulationComplianceKpi>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getRegulationComplianceKpis', 'post', payload);
    }
    public getRegulationSituationKpis(
        payload: RegulationSituationKpisRequest,
    ): Promise<Reply<RegulationSituationKpis>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getRegulationSituationKpis', 'post', payload);
    }
    public getRegulationSituationList(
        payload: MapRegulationSituationListRequest,
    ): Promise<Reply<MapRegulationSituationListReply>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getRegulationSituationList', 'post', payload);
    }
    public getRegulations(payload: RegulationListRequestDto): Promise<Reply<RegulationList>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getRegulations', 'post', payload);
    }
    public getRestrictions(payload: RestrictionRetrievalRequestDto): Promise<Reply<RestrictionRetrievalReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getRestrictions', 'post', payload);
    }
    public getRunwayConfigurationPlan(
        payload: RunwayConfigurationPlanRequestDto,
    ): Promise<Reply<RunwayConfigurationPlanDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getRunwayConfigurationPlan', 'post', payload);
    }
    public getSectorConfigurationPlan(
        payload: SectorConfigurationPlanRequestDto,
    ): Promise<Reply<SectorConfigurationPlanDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getSectorConfigurationPlan', 'post', payload);
    }
    public getTrafficCounts(payload: TrafficCountsRequestDto): Promise<Reply<TrafficCountsDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getTrafficCounts', 'post', payload);
    }
    public getTrafficCountsAndFlightList(
        payload: TrafficCountsAndFlightListRequestDto,
    ): Promise<Reply<TrafficCountsAndFlightListDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getTrafficCountsAndFlightList', 'post', payload);
    }
    public getTrafficCountsAndFlightListComparison(
        payload: TrafficCountsAndFlightListComparisonRequestDto,
    ): Promise<Reply<TrafficCountsAndFlightListComparisonDto>> {
        return this.doSend(
            this.baseUrl + this.serviceUrl + '/getTrafficCountsAndFlightListComparison',
            'post',
            payload,
        );
    }
    public getTrafficCountsComparison(
        payload: TrafficCountsComparisonRequestDto,
    ): Promise<Reply<TrafficCountsAndComparisonDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getTrafficCountsComparison', 'post', payload);
    }
    public getTrafficMonitorData(payload: TrafficMonitorRequest): Promise<Reply<TrafficMonitorDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getTrafficMonitorData', 'post', payload);
    }
    public getTrafficVolumeList(payload: TrafficVolumeListRequest): Promise<Reply<Array<TrafficVolume>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getTrafficVolumeList', 'post', payload);
    }
    public getTrafficVolumeSetIdList(payload: TrafficVolumeSetIdListRequest): Promise<Reply<Array<string>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getTrafficVolumeSetIdList', 'post', payload);
    }
    public getTrafficVolumeSetList(payload: TrafficVolumeSetListRequest): Promise<Reply<Array<TrafficVolumeSet>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getTrafficVolumeSetList', 'post', payload);
    }
    public getTvActivationPlan(payload: TvActivationPlanRequestDto): Promise<Reply<TvActivationPlanDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getTvActivationPlan', 'post', payload);
    }
    public getTvCapacityPlan(payload: CapacityPlanRequestDto): Promise<Reply<CapacityPlanDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getTvCapacityPlan', 'post', payload);
    }
    public getTvEntryKpis(payload: TvEntryKpiRequest): Promise<Reply<TvEntryKpis>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getTvEntryKpis', 'post', payload);
    }
    public getTvImpactedByAresVolumeSet(
        payload: TvImpactedByAresVolumeSetRequestDto,
    ): Promise<Reply<TvImpactedByAresVolumeSetReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getTvImpactedByAresVolumeSet', 'post', payload);
    }
    public getTvSetActivations(payload: TvSetActivationRequestDto): Promise<Reply<TvSetActivationReply>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getTvSetActivations', 'post', payload);
    }
    public getTvSetImpactedTimePeriod(payload: TvSetImpactedPeriodRequest): Promise<Reply<TimePeriod>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getTvSetImpactedTimePeriod', 'post', payload);
    }
    public optimiseDMALocation(payload: OptimiseDMALocationRequestDto): Promise<AsyncReply<boolean>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/optimiseDMALocation', 'post', payload);
    }
    public optimiseSectorConfigurationPlan(payload: OptimiseSectorConfigurationPlanRequestDto): Promise<Reply<string>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/optimiseSectorConfigurationPlan', 'post', payload);
    }
    public processArrivalPlanningInfoRequest(
        payload: ArrivalPlanningInformationRequestDto,
    ): Promise<Reply<ApiReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/processArrivalPlanningInfoRequest', 'post', payload);
    }
    public processDeparturePlanningInfoRequest(
        payload: DeparturePlanningInformationRequestDto,
    ): Promise<Reply<DpiReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/processDeparturePlanningInfoRequest', 'post', payload);
    }
    public proposeRoutes(payload: RoutingAssistanceRequestDto): Promise<Reply<RoutingAssistanceReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/proposeRoutes', 'post', payload);
    }
    public queryAvailableSimulations(
        payload: DatasetReferenceDto,
    ): Promise<Reply<Array<SimulationAvailabilityPerReference>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/queryAvailableSimulations', 'post', payload);
    }
    public querySimulations(payload: SimulationListRequestDto): Promise<Reply<Array<SimulationDto>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/querySimulations', 'post', payload);
    }
    public queryTrafficMetricsByAirspace(
        payload: TrafficMetricsByAirspaceRequestDto,
    ): Promise<Reply<TrafficMetricsByAirspaceReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/queryTrafficMetricsByAirspace', 'post', payload);
    }
    public resetSimulation(payload: DatasetDto): Promise<Reply<undefined>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/resetSimulation', 'post', payload);
    }
    public retrieveAup(payload: AupRetrievalRequestDto): Promise<Reply<AupDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/retrieveAup', 'post', payload);
    }
    public retrieveAupChain(payload: AupChainRetrievalRequestDto): Promise<Reply<Array<AupChainDto>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/retrieveAupChain', 'post', payload);
    }
    public retrieveBackbone(payload: BackboneRetrievalRequestDto): Promise<Reply<BackboneDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/retrieveBackbone', 'post', payload);
    }
    public retrieveDraftEAupRsas(payload: DraftEAupRsaRequestDto): Promise<Reply<Array<AirspaceActivationDto>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/retrieveDraftEAupRsas', 'post', payload);
    }
    public retrieveDraftEAupSummaries(
        payload: DraftEAupsRetrievalRequestDto,
    ): Promise<Reply<Array<DraftEAupSummaryDto>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/retrieveDraftEAupSummaries', 'post', payload);
    }
    public retrieveEAupChain(payload: EAupChainRetrievalRequestDto): Promise<Reply<EAupChainDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/retrieveEAupChain', 'post', payload);
    }
    public retrieveEAupRsas(payload: EAupRsaRequestDto): Promise<Reply<Array<AirspaceActivationDto>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/retrieveEAupRsas', 'post', payload);
    }
    public retrieveFRAReroutingResults(
        payload: FRAReroutingResultsRetrievalRequestDto,
    ): Promise<AsyncReply<FRAReroutingResultsRetrievalReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/retrieveFRAReroutingResults', 'post', payload);
    }
    public retrieveFficeFlightPlanHistory(
        payload: FficeFlightPlanHistoryRequestDto,
    ): Promise<Reply<FficeFlightPlanHistoryReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/retrieveFficeFlightPlanHistory', 'post', payload);
    }
    public retrieveFilingStatus(payload: FilingStatusRequestDto): Promise<Reply<FilingReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/retrieveFilingStatus', 'post', payload);
    }
    public retrieveKPITargets(payload: KPITargetsPlanRetrievalRequestDto): Promise<Reply<KPITargetsPlanDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/retrieveKPITargets', 'post', payload);
    }
    public retrieveOptimiseDMALocationResults(
        payload: OptimiseDMALocationResultsRetrievalRequestDto,
    ): Promise<AsyncReply<DynamicVolumeSetDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/retrieveOptimiseDMALocationResults', 'post', payload);
    }
    public retrieveSectorConfigurationPlanResults(
        payload: OptimiseSectorConfigurationPlanResultsRetrievalRequestDto,
    ): Promise<AsyncReply<SectorConfigurationPlanDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/retrieveSectorConfigurationPlanResults', 'post', payload);
    }
    public retrieveSlotList(payload: RetrieveSlotListsRequestDto): Promise<Reply<Array<SlotList>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/retrieveSlotList', 'post', payload);
    }
    public startSimulation(payload: UserManagedSimulationDto): Promise<Reply<UserManagedSimulationDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/startSimulation', 'post', payload);
    }
    public stopSimulation(payload: DatasetDto): Promise<Reply<boolean>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/stopSimulation', 'post', payload);
    }
    public submitFficeFlightDataRequest(payload: FficeFlightDataRequestDto): Promise<Reply<FficeFlightDataReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/submitFficeFlightDataRequest', 'post', payload);
    }
    public submitFlightCriticality(
        payload: FlightCriticalityRequestDto,
    ): Promise<Reply<FlightCriticalityIndicatorDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/submitFlightCriticality', 'post', payload);
    }
    public test(): Promise<Reply<string>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/test', 'get');
    }
    public updateAresVolumeSet(payload: AresVolumeSetUpdateRequestDto): Promise<Reply<AresVolumeSetUpdateReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateAresVolumeSet', 'post', payload);
    }
    public updateAtcVolumeSet(payload: AtcVolumeSetUpdateRequestDto): Promise<Reply<AtcVolumeSetUpdateReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateAtcVolumeSet', 'post', payload);
    }
    public updateAup(payload: AupUpdateRequestDto): Promise<Reply<AupDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateAup', 'post', payload);
    }
    public updateBackbone(payload: BackboneUpdateRequestDto): Promise<Reply<BackboneDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateBackbone', 'post', payload);
    }
    public updateKPITargetsPlan(payload: KPITargetsPlanUpdateRequestDto): Promise<Reply<KPITargetsPlanDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateKPITargetsPlan', 'post', payload);
    }
    public updateOtmvPlan(payload: OtmvPlanDto): Promise<Reply<OtmvPlanDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateOtmvPlan', 'post', payload);
    }
    public updateRunwayConfigurationPlan(
        payload: RunwayConfigurationPlanDto,
    ): Promise<Reply<RunwayConfigurationPlanDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateRunwayConfigurationPlan', 'post', payload);
    }
    public updateSectorConfigurationPlan(
        payload: SectorConfigurationPlanDto,
    ): Promise<Reply<SectorConfigurationPlanDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateSectorConfigurationPlan', 'post', payload);
    }
    public updateSlot(payload: UpdateSlotRequestDto): Promise<Reply<undefined>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateSlot', 'post', payload);
    }
    public updateTvActivationPlan(payload: TvActivationPlanDto): Promise<Reply<TvActivationPlanDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateTvActivationPlan', 'post', payload);
    }
    public updateTvCapacityPlan(payload: CapacityPlanDto): Promise<Reply<CapacityPlanDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateTvCapacityPlan', 'post', payload);
    }
    public validateAup(payload: AupValidationRequestDto): Promise<Reply<undefined>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/validateAup', 'post', payload);
    }
    public validateFlightPlan(payload: FlightPlanValidationRequestDto): Promise<Reply<FlightPlanValidationReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/validateFlightPlan', 'post', payload);
    }
    public verifyDynamicVolumeSet(
        payload: AresVolumeSetVerificationRequestDto,
    ): Promise<Reply<AresVolumeSetVerificationReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/verifyDynamicVolumeSet', 'post', payload);
    }
    private doSend<RequestType, ResponseType>(
        url: string,
        method: 'post' | 'get',
        request?: RequestType,
    ): Promise<ResponseType> {
        const headers = new Headers();
        headers.append('Accept', 'application/json'); // This one is enough for GET requests
        headers.append('Content-Type', 'application/json'); // This one sends body
        return fetch(url, { method: method, headers: headers, body: JSON.stringify(request) }).then(response => {
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            return response.text().then(text => JSON.parse(text));
        });
    }
}
export class InnoveService {
    baseUrl: string;
    serviceUrl: string = '/services/InnoveService';
    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    public getDCBProblems(payload: DCBProblemListRequestDto): Promise<Reply<Array<DCBProblemDto>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getDCBProblems', 'post', payload);
    }
    public getNetspots(payload: NetspotListRequestDto): Promise<Reply<Array<NetspotDto>>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/getNetspots', 'post', payload);
    }
    public queryComplexity(payload: ComplexitySharingRequestDto): Promise<Reply<ComplexitySharingReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/queryComplexity', 'post', payload);
    }
    public triggerTrpRun(payload: DatasetDto): Promise<Reply<boolean>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/trpRun', 'post', payload);
    }
    public updateComplexity(
        payload: ComplexitySharingUpdateRequestDto,
    ): Promise<Reply<ComplexitySharingUpdateReplyDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateComplexity', 'post', payload);
    }
    public updateDCBProblem(payload: DCBProblemDto): Promise<Reply<DCBProblemDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateDCBProblem', 'post', payload);
    }
    public updateNetspot(payload: NetspotDto): Promise<Reply<NetspotDto>> {
        return this.doSend(this.baseUrl + this.serviceUrl + '/updateNetspot', 'post', payload);
    }
    private doSend<RequestType, ResponseType>(
        url: string,
        method: 'post' | 'get',
        request?: RequestType,
    ): Promise<ResponseType> {
        const headers = new Headers();
        headers.append('Accept', 'application/json'); // This one is enough for GET requests
        headers.append('Content-Type', 'application/json'); // This one sends body
        return fetch(url, { method: method, headers: headers, body: JSON.stringify(request) }).then(response => {
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            return response.text().then(text => JSON.parse(text));
        });
    }
}
